<template>
	<!--新建会议-->
	<div class="content a-new-meeting">
		<div class="layui-fluid">
			<div class="layui-row">
				<div class="layui-col-md12">
					<!--面包屑-->
					<div class="layui-row">
						<div class="layui-col-md8">
							<el-breadcrumb separator-class="el-icon-arrow-right">
								<el-breadcrumb-item :to="{ path: '/admin/MyMeeting' }">会议管理</el-breadcrumb-item>
								<el-breadcrumb-item :to="{ path: '/admin/MyMeeting' }">我的会议</el-breadcrumb-item>
								<el-breadcrumb-item>编辑会议</el-breadcrumb-item>
							</el-breadcrumb>
						</div>
						<div class="layui-col-md4 button">
							<!-- <button type="button" class="layui-btn">web端预览</button>
	              <button type="button" class="layui-btn" id="mobilePreview">移动端预览</button>-->
						</div>
					</div>
					<!--TAB-->
					<div class="layui-row" style="margin-top:20px">
						<div class="layui-col-md12">
							<div class="layui-tab layui-tab-brief" lay-filter="myDemo">
								<ul class="layui-tab-title">
									<li class="layui-this first-tab" lay-id="111">
										会议信息
									</li>
									<li lay-id="222">收费设置</li>
									<li lay-id="333">报名设置</li>
									<li lay-id="444">栏目管理</li>
									<li lay-id="555">分享管理</li>
									<li lay-id="666" v-if="editId != ''">
										专题管理
									</li>
								</ul>
								<div class="layui-tab-content">
									<!-- 会议信息 -->
									<div class="layui-tab-item layui-show">
										<!--1.会议信息-->
										<h5 class="meeting-the-basic">
											会议基本信息
										</h5>
										<form class="layui-form info" action lay-filter="dataInfo">
											<el-collapse v-model="activeNames" style="padding: 0 20px;background-color: #fff;">
												<el-collapse-item title="基本信息" name="1">
													<div class="layui-form-item">
														<label class="layui-form-label">
															会议性质
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<!-- <select name="type" lay-verify="required" lay-filter="test_type">
																<option>请选择会议性质</option>
																<option value="1">会议/论坛</option>
																<option value="2">讲座/沙龙</option>
																<option value="3">发布会</option>
																<option value="4">其他</option>
															</select>-->
															<el-select v-model="jbxxform.type" placeholder="请选择" @change="test_type">
																<el-option v-for="item in type_option" :key="item.value" :label="item.label" :value="item.value">
																</el-option>
															</el-select>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															会议名称
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<input type="text" name="name" lay-verify="required" placeholder="请输入会议名称" autocomplete="off" class="layui-input" />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															指导单位:
														</label>
														<div class="layui-input-block">
															<input type="text" name="guide_company" placeholder="请输入会议名称" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">主办方:</label>
														<div class="layui-input-block">
															<input type="text" name="organizers" placeholder="请输入主办方" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">承办单位:</label>
														<div class="layui-input-block">
															<input type="text" name="company" placeholder="请输入承办单位" autocomplete="off" class="layui-input" />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">会议主题:</label>
														<div class="layui-input-block">
															<input type="text" name="theme" placeholder="请输入会议主题" autocomplete="off" class="layui-input" />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">会议形式<span class="required">*</span>:</label>
														<div class="layui-input-block">
															<el-select v-model="xsarr" multiple placeholder="请选择">
																<el-option v-for="item in arrxs" :key="item.value" :label="item.label" :value="item.value"></el-option>
															</el-select>
														</div>
													</div>

													<div class="layui-form-item date">
														<label class="layui-form-label">
															报名日期
															<span class="required">*</span>:
														</label>
														<div class="layui-inline" style="margin-left: 10px">
															<div class="layui-input-inline">
																<input type="text" name="enroll_start_time" lay-verify="required" id="upTimeStart" placeholder="开始日期" autocomplete="off" readonly="readonly" class="layui-input" />
															</div>
															<div class="layui-form-mid">
																-
															</div>
															<div class="layui-input-inline">
																<input type="text" name="enroll_end_time" lay-verify="required" id="upTimeEnd" placeholder="结束日期" autocomplete="off" readonly="readonly" class="layui-input" />
															</div>
														</div>
													</div>

													<div class="layui-form-item date">
														<label class="layui-form-label">
															举办日期
															<span class="required">*</span>:
														</label>
														<div class="layui-inline" style="margin-left: 10px">
															<div class="layui-input-inline">
																<input type="text" name="start_time" lay-verify="required" id="startDate" placeholder="开始日期" autocomplete="off" readonly="readonly" class="layui-input" />
															</div>
															<div class="layui-form-mid">
																-
															</div>
															<div class="layui-input-inline">
																<input type="text" name="end_time" lay-verify="required" id="endDate" placeholder="结束日期" autocomplete="off" readonly="readonly" class="layui-input" />
															</div>
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">时间展示格式:</label>
														<div class="layui-input-block">
															<input type="radio" name="show_date_format" value="1" title="精确到日" lay-filter="ChoiceRadiod" />
															<input type="radio" name="show_date_format" value="0" title="精确到分" lay-filter="ChoiceRadiod" checked />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">隐藏报名须知:</label>
														<div class="layui-input-block">
															<input type="radio" name="hidden_enroll_notes" value="1" title="是" lay-filter="hidden_enroll_notes" />
															<input type="radio" name="hidden_enroll_notes" value="0" title="否" lay-filter="hidden_enroll_notes" checked />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">会议简介:</label>
														<div class="layui-input-block">
															<vue-ueditor-wrap class="vue-ueditor-wrap" v-model="msgok" :config="myConfig" />
														</div>
													</div>
													<!-- 百度富文本 -->
													<div class="layui-form-item">
														<label class="layui-form-label">会议介绍<span class="required">*</span>:</label>
														<div class="layui-input-block">
															<vue-ueditor-wrap v-model="detail" :config="myConfig
																"></vue-ueditor-wrap>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">签到地点:</label>
														<div class="layui-input-block">
															<input type="text" name="sign_location" placeholder="请输入签到地点" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item action">
														<label class="layui-form-label">举办地点:</label>
														<div class="layui-input-inline">
															<div class="province" style="padding-left: 10px;">
																<select name="province_id" lay-filter="province_id" id="province_id">
																	<option>请选择省</option>
																</select>
															</div>
														</div>
														<div class="layui-input-inline">
															<div class="city_id" style="padding-left: 10px;">
																<select name="city_id" lay-filter="city_id" id="city_id">
																	<option>请选择市</option>
																</select>
															</div>
														</div>
														<div class="layui-input-inline">
															<div class="area_id" style="padding-left: 10px;">
																<select name="area_id" lay-filter="area_id" id="area_id">
																	<option>请选择县/区</option>
																</select>
															</div>
														</div>
													</div>

													<div class="layui-form-item">
														<div class="layui-input-block mar-left">
															<input type="text" name="specific_address" placeholder="请输入会议详细地址" autocomplete="off" class="layui-input" v-model="mapName
																" style="width:50%;float:left;margin-right:20px;" />
															<el-button type="primary" @click="mapNameChange
																">搜索</el-button>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															经纬度：
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<input type="text" v-model="longitude
																" name="longitude" placeholder="请输入经度" autocomplete="off" class="layui-input" style="width:25%;display:inline;margin-right:20px;" />
															<input type="text" name="latitude" v-model="latitude
																" placeholder="请输入纬度" autocomplete="off" class="layui-input" style="width:25%;display:inline;" />
															<p style="font-size:12px;margin-top:7px;color:#606266">
																搜索后经纬度会自动填充
															</p>
														</div>
													</div>

													<div class="layui-form-item">
														<div id="container" style="width:50%;height:300px;margin-left:120px" ref="allmap"></div>
													</div>
												</el-collapse-item>
												<el-collapse-item title="会议配置" name="2">
													<div class="layui-form-item">
														<label class="layui-form-label">
															开启发票:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="is_invoice" value="1" title="是" lay-filter="ChoiceRadiod" />
															<input type="radio" name="is_invoice" value="0" title="否" lay-filter="ChoiceRadiod" checked />
														</div>
													</div>

													<!-- <div class="layui-form-item">
														<label
															class="layui-form-label"
														>
															 发票类型:
														</label>
														<div
															class="layui-input-block"
														>
															<input
																type="radio"
																name="invoice_type"
																value="1"
																title="增值税普通发票"
																lay-filter="ChoiceRadiod"
															/>
															<input
																type="radio"
																name="invoice_type"
																value="2"
																title="增值税专用发票"
																lay-filter="ChoiceRadiod"
																checked
															/>
															<input
																type="radio"
																name="invoice_type"
																value="3"
																title="增值税电子普通发票"
																lay-filter="ChoiceRadiod"
																checked
															/>
														</div>
													</div> -->

													<div class="layui-form-item">
														<label class="layui-form-label">发票类型: <span class="required">*</span>:</label>
														<div class="layui-input-block">
															<el-select v-model="invoice_type" multiple placeholder="请选择">
																<el-option v-for="item in invoice_type_arr" :key="item.value" :label="item.label" :value="item.value">
																</el-option>
															</el-select>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															票种方式:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="ticket_type" value="1" title="单选" lay-filter="ChoiceRadiod" />
															<input type="radio" name="ticket_type" value="0" title="多选" lay-filter="ChoiceRadiod" checked />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															最大购票数:
														</label>
														<div class="layui-input-block">
															<input type="text" name="conf_ticket_num" placeholder="每人最大购票数" autocomplete="off" class="layui-input" />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															是否展示剩余名额:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="is_show_residue" value="1" title="展示" lay-filter="ChoiceRadiod" />
															<input type="radio" name="is_show_residue" value="0" title="不展示" lay-filter="ChoiceRadiod" checked />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															报名处是否隐藏票种名称:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="hidden_ticket_name" value="1" title="隐藏" lay-filter="ChoiceRadiod" />
															<input type="radio" name="hidden_ticket_name" value="0" title="显示" lay-filter="ChoiceRadiod" checked />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															开启部门选择
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="is_dep" value="1" title="是" checked lay-filter="ChoiceRadiod" />
															<input type="radio" name="is_dep" value="0" title="否" lay-filter="ChoiceRadiod" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															显示价格:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="is_show_price" value="1" title="是" checked lay-filter="ChoiceRadiod" />
															<input type="radio" name="is_show_price" value="0" title="否" lay-filter="ChoiceRadiod" />
															<p style="font-size: 12px; margin-top: 7px; color: rgb(96, 98, 102);margin-bottom:0px">报名页面是否显示价格</p>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															跳转页面
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="jump_page" value="1" title="分享页" checked lay-filter="ChoiceRadiodb" />
															<input type="radio" name="jump_page" value="2" title="详情页" lay-filter="ChoiceRadiodb" />
															<input type="radio" name="jump_page" value="3" title="专题页" lay-filter="ChoiceRadiodb" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															是否开启线下支付:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="is_offline" value="1" title="是" lay-filter="ChoiceRadiods" />
															<input type="radio" name="is_offline" value="0" title="否" checked lay-filter="ChoiceRadiods" />
														</div> 
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															线下支付订单状态是否为自动完成:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="offline_pay_finish" value="1" title="是" lay-filter="ChoiceRadiods" />
															<input type="radio" name="offline_pay_finish" value="0" title="否" checked lay-filter="ChoiceRadiods" />
														</div> 
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															是否开启线上支付:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="scene_pay_type" value="1" title="是" lay-filter="ChoiceRadiods" />
															<input type="radio" name="scene_pay_type" value="0" title="否" checked lay-filter="ChoiceRadiods" />
														</div>
															<p style="font-size:12px;margin-top:7px;color:#606266">
																只针对现场报名链接有效
															</p>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															支付说明:
														</label>
														<div class="layui-input-block">
															<input type="text" name="pay_desc" placeholder="请填写支付说明" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">汇款信息:</label>
														<div class="layui-input-block">
															<vue-ueditor-wrap v-model="remittance_info" :config="myConfig"></vue-ueditor-wrap>
														</div>
													</div>

													<div class="layui-form-item action">
														<label class="layui-form-label">访问权限设置：</label>
														<div class="layui-input-inline">
															<div class="provinces" style="padding-left: 10px;">
																<select name="belong_team_id" lay-filter="belong_team_id" id="province_ids">
																	<!-- <option>请选择机构</option> -->
																</select>
															</div>
														</div>
														<div class="layui-input-inline">
															<div class="city_ids" style="padding-left: 10px;" id="city_idss">
																<select name=" belong_dep_id" lay-filter="belong_dep_id">
																	<!-- <option>请选择部门</option> -->
																</select>
															</div>
														</div>
														<p style="font-size:12px;color:#606266">
															设置后
															列表中将不会出现本次会议入口，只能通过转发链接进入，
															<br />且只有对应部门的用户有权限查看
														</p>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															在列表页显示：
														</label>
														<div class="layui-input-block">
															<input type="radio" name="list_display" value="0" title="显示" checked lay-filter="liecheck" />
															<input type="radio" name="list_display" value="1" title="不显示" lay-filter="liecheck" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">活动上线人数:</label>
														<div class="layui-input-block">
															<input type="text" name="maxmember" placeholder="请输入活动上线人数" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">信息来源:</label>
														<div class="layui-input-block">
															<input type="text" name="informant_link" placeholder="请输入信息来源" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">信息提供:</label>
														<div class="layui-input-block">
															<input type="text" name="informant" placeholder="请输入信息提供者" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">会议编码:</label>
														<div class="layui-input-block">
															<input type="text" name="code" placeholder="请输入会议编码" autocomplete="off" class="layui-input" />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															往届会议id:
														</label>
														<div class="layui-input-block">
															<input type="text" name="previous_id"  placeholder="请输入会议id" autocomplete="off" class="layui-input" />
														</div>
														<p style="font-size:12px;color:#606266">
														 多个会议用英文逗号隔开，空则不获取
														</p>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															往届报名信息字段:
														</label>
														<div class="layui-input-block">
															<input type="text" name="previous_field" placeholder="请输入会议报名信息字段名" autocomplete="off" class="layui-input" />
														</div>
														<p style="font-size:12px;color:#606266">
														 多个字段用英文逗号隔开，空则不获取
														</p>
													</div>
												</el-collapse-item>
												<el-collapse-item title="图片上传" name="3">
													<div class="layui-form-item">
														<label class="layui-form-label">
															主办方logo
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<button type="button" class="layui-btn" @click="handleTestlogo
																">
																上传图片
															</button>
															<p style="font-size:12px;margin-top:7px;color:#606266">
																建议尺寸：高度保持66px，宽度不限
															</p>
															<input type="file" name="logo_url" class="layui-input" id="testlogo" style="display: none;" @change="upload" />
															<div class="layui-upload-list" style="background:#cdcaca;width:60px;height:60px;">
																<img class="layui-upload-img" id="demo1" width="60" height="60" style="display: none" />
															</div>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															会议横封面
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<button type="button" class="layui-btn" @click="handleUploadConferenceCover
																">
																上传图片
															</button>
															<p style="font-size:12px;margin-top:7px;color:#606266">
																上传合适的封面，利于您活动的宣传分享(推荐尺寸：280*150)
															</p>
															<input type="file" name="cover_url" class="layui-input" id="testlogos" style="display: none;" @change="uploads
																" />
															<div class="layui-input-list" style="margin-top: 10px;">
																<img class="layui-upload-img" id="demos" width="60" height="60" style="display: none" />
															</div>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															会议竖封面
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<button type="button" class="layui-btn" @click="handleUploadConferenceCoversss
																">
																上传图片
															</button>
															<p style="font-size:12px;margin-top:7px;color:#606266">
																上传合适的封面，利于您活动的宣传分享
															</p>
															<input type="file" name="vertical_cover_url" class="layui-input" id="testlogossss" style="display: none;" @change="uploadssss
																" />
															<div class="layui-input-list" style="margin-top: 10px;">
																<img class="layui-upload-img" id="demoss" width="60" height="60" style="display: none" />
															</div>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">
															上传轮播图：
														</label>
														<div class="layui-input-block">
															<el-upload action="" :on-change="getFile" list-type="picture-card" :auto-upload="false" :file-list="fileListkk" :on-remove="handleRemove_swiper">
																<i class="el-icon-plus"></i>
															</el-upload>
														</div>
													</div>

													<div class="layui-form-item" id="shalong_img">
														<label class="layui-form-label">
															上传沙龙/活动会议封面：
														</label>
														<div class="layui-input-block">
															<button type="button" class="layui-btn" @click="handleUploadConferenceCover_img
																">
																上传图片
															</button>
															<p style="font-size:12px;margin-top:7px;color:#606266">
																上传合适的封面，利于您活动的宣传分享(推荐尺寸：160*220)
															</p>
															<input type="file" name="salon_cover_url" class="layui-input" id="salon_cover_url" style="display: none;" @change="uploads_img
																" />
															<div class="layui-input-list" style="margin-top: 10px;">
																<img class="layui-upload-img" id="demos_img" width="60" height="60" style="display: none" />
															</div>
														</div>
													</div>
												</el-collapse-item>
												<el-collapse-item title="订单配置" name="4">
													<div class="layui-form-item">
														<label class="layui-form-label">订单号前缀:</label>
														<div class="layui-input-block">
															<input type="text" name="order_no_prefix" placeholder="请输入订单号前缀" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">联系地址:</label>
														<div class="layui-input-block">
															<input type="text" name="contact_address" placeholder="请输入地址" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">购票须知:</label>
														<div class="layui-input-block">
															<textarea name="ticket_desc" placeholder="请输入购票须知" class="layui-textarea"></textarea>
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">报名联系人:</label>
														<div class="layui-input-block">
															<input type="text" name="contact_name" placeholder="请输入报名联系人" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label">报名咨询电话:</label>
														<div class="layui-input-block">
															<input type="text" name="tel" placeholder="请输入报名咨询电话" autocomplete="off" class="layui-input" />
														</div>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label" style="margin-right:10px">
															修改订单截止时间:
														</label>
														<el-date-picker v-model="modify_time
															" type="datetime" value-format="timestamp" placeholder="选择日期时间">
														</el-date-picker><br />
														<span style="font-size: 12px;
	                                         color: rgb(96, 98, 102);">直接按照时间配置，配到什么时候就统一截止到什么时候</span>
													</div>

													<div class="layui-form-item">
														<label class="layui-form-label" style="margin-right:10px">
															修改订单有效时间:
														</label>
														<div class="layui-input-block">
															<input type="text" name="modify_hour" placeholder="请输入时间" autocomplete="off" class="layui-input" />
														</div>
														<span style="font-size: 12px;
	                                         color: rgb(96, 98, 102);">报名成功后N个小时可修改</span>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label" style="margin-right:10px">
															可退款截止时间:
														</label>
														<el-date-picker v-model="refund_endtime
															" type="datetime" value-format="timestamp" placeholder="选择日期时间">
														</el-date-picker><br />
														<span style="font-size: 12px;
	                                         color: rgb(96, 98, 102);">可退款截止时间，为空则默认下单7天内可退款</span>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">退款提示语:</label>
														<div class="layui-input-block">
															<input type="text" name="refund_reminder" placeholder="请输入退款提示语" autocomplete="off" class="layui-input" />
														</div>
													</div>

												</el-collapse-item>
												<el-collapse-item title="平行会议" name="5">
													<div class="layui-form-item">
														<label class="layui-form-label">
															平行会议
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="parallel" value="1" title="是" lay-filter="ChoiceRadio" />
															<input type="radio" name="parallel" value="0" title="否" lay-filter="ChoiceRadio" checked />
														</div>
													</div>
													<div class="layui-form-item" style="display: none;" id="participant">
														<label class="layui-form-label">
															支持独立参会
															<span class="required">*</span>:
														</label>
														<div class="layui-input-block">
															<input type="radio" name="independence" value="1" title="是" checked />
															<input type="radio" name="independence" value="0" title="否" />
														</div>
													</div>
													<div class="associationParallel" id="pingxin">
														<div class="layui-form-item">
															<label class="layui-form-label">关联平行会议:</label>
															<div class="layui-input-block">
																<button style="width: 100px;" type="button" class="layui-btn layui-btn-fluid" id="meet_have" @click="meet_have
																	">
																	选择会议
																</button>
															</div>
														</div>
														<div class="layui-form-item">
															<div>
																<table class="layui-hide" id="associationParallel" lay-filter="associationParallel"></table>
															</div>
															<!-- <div
																id="barDemoParallel"
															>
																<a
																	class="layui-btn layui-btn-xs"
																	lay-event="edit"
																	style="color: #FFFFFF;"
																	>移除</a
																>
															</div> -->
														</div>
													</div>
												</el-collapse-item>
											</el-collapse>

											<div class="layui-form-item" style="text-align: center;margin-top:30px">
												<button type="button" class="layui-btn" lay-submit lay-filter="saveThemeeting">
													下一步
												</button>
											</div>
										</form>
									</div>
									<!-- 收费设置 -->
									<div class="layui-tab-item">
										<!--收费设置-->
										<div class="layui-card">
											<div class="layui-card-header">
												<h5 style="margin-left: 10px;padding-top: 10px">
													报名费管理
												</h5>
											</div>
											<div class="layui-card-body">
												<form class="layui-form" action>
													<div class="layui-row">
														<div class="layui-col-md2 layui-col-md-offset10 layui-col-lg-offset10 layui-col-sm-offset10 layui-col-xs-offset10">
															<button type="button" class="layui-btn" id="handleTicket">
																新增票种
															</button>
														</div>
													</div>
												</form>
												<table class="layui-hide" id="applicationFee" lay-filter="applicationFees"></table>
												<script type="text/html" id="barDemo">
													<a class="layui-btn layui-btn-xs" lay-event="edit" style="color: #FFFFFF;">编辑</a>
													<a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>

												</script>
											</div>
										</div>
										<div class="layui-card">
											<div class="layui-card-header">
												<h5 style="margin-left: 10px;padding-top: 10px">
													住宿管理
												</h5>
											</div>
											<div class="layui-card-body">
												<form class="layui-form" action>
													<div class="layui-row">
														<div class="layui-col-md2 layui-col-md-offset8 layui-col-lg-offset8 layui-col-sm-offset8 layui-col-xs-offset8">
															<button type="button" class="layui-btn handleRoom" id="handleRoom">
																新增住宿
															</button>
														</div>
														<div class="layui-col-md2">
															<button type="button" class="layui-btn" @click="popup" id="handleRoom_hotel">
																选择酒店
															</button>
														</div>
													</div>
												</form>
												<table class="layui-hide" id="dormmanager" lay-filter="dormmanagers"></table>
												<script type="text/html" id="bar_jiabin">
													<a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>

												</script>
												<script type="text/html" id="barDemos">
													<!-- d代表的是layui 引擎模板中所使用的单个数据 -->

												<a class="layui-btn layui-btn-xs" lay-event="edit" style="color: #FFFFFF;">编辑</a>
												<a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>
												</script>
											</div>
										</div>
										<div class="layui-card">
											<div class="layui-card-header">
												<h5 style="margin-left: 10px;padding-top: 10px">
													就餐管理
												</h5>
											</div>
											<div class="layui-card-body">
												<form class="layui-form" action>
													<div class="layui-row">
														<div class="layui-col-md2 layui-col-md-offset8 layui-col-lg-offset8 layui-col-sm-offset8 layui-col-xs-offset8">
															<button type="button" class="layui-btn handleDining" id="handleDining_a">
																新建就餐信息
															</button>
														</div>
														<div class="layui-col-md2">
															<button type="button" class="layui-btn" @click="popups" id="handleDining_b">
																选择就餐
															</button>
														</div>
													</div>
												</form>
												<table class="layui-hide" id="diningManagement" lay-filter="diningManagement"></table>
												<script type="text/html" id="diningManage">
													<a class="layui-btn layui-btn-xs" lay-event="edit" style="color: #FFFFFF;">编辑</a>
													<a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>

												</script>
											</div>
										</div>
										<div class="layui-form-item" style="text-align: center">
											<!-- <button type="button" class="layui-btn" id="previousStep">上一步</button> -->
											<button type="button" class="layui-btn" id="thereService" @click="three">
												下一步
											</button>
										</div>
									</div>
									<!-- 报名设置 -->
									<div class="layui-tab-item">
										<div class="layui-card">
											<div class="layui-card-header">报名字段列表</div>
											<div class="layui-card-body">
												<form action class="layui-form">
													<div class="layui-form-item">
														<table class="layui-hide" id="applicationField" lay-filter="applicationField"></table>
													</div>
													<div class="layui-form-item" style="text-align: left;">
														<button type="button" class="layui-btn" id="customRegistration">
															自定义报名字段
														</button>
													</div>
													<div class="layui-form-item" style="text-align: center">
														<button type="button" class="layui-btn" id="previous" @click="two">
															上一步
														</button>
														<button type="button" class="layui-btn" id="registration" @click="four">
															下一步
														</button>
													</div>
												</form>
											</div>
										</div>
										<div class="layui-card">
											<div class="layui-card-header">获取往届报名信息</div>
											<div class="layui-card-body">
												
											</div>
										</div>
									</div>
									<!-- 栏目管理 -->
									<div class="layui-tab-item">
										<div class="layui-card">
											<div class="layui-card-header"></div>
											<div class="layui-card-body">
												<form class="layui-form" action>
													<div class="layui-form-item" style="text-align: right">
														<button type="button" class="layui-btn" id="addColumn">
															新增栏目
														</button>
													</div>
													<div class="layui-form-item">
														<table class="layui-hide" id="columnmanagementables" lay-filter="columnmanagementables"></table>
														<script type="text/html" id="columnmanagementableDemo">
															<a class="layui-btn layui-btn-xs" lay-event="columnmanagementabedit" style="color: #FFFFFF;">编辑</a>
															<a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="columnmanagementabdel" style="color: #FFFFFF;">删除</a>

														</script>
													</div>
													<div class="layui-form-item" style="text-align: center">
														<button type="button" class="layui-btn" id="programstep" @click="three">
															上一步
														</button>
														<button type="button" class="layui-btn" id="columnmanagement" @click="five">
															下一步
														</button>
													</div>
												</form>
											</div>
										</div>
									</div>
									<!-- 分享管理 -->
									<div class="layui-tab-item">
										<form class="layui-form" action lay-filter="dataShareManagement">
											<div class="layui-card">
												<div class="layui-card-header">
													<h5 style="margin-left: 10px;padding-top: 10px;">
														分享基本信息
													</h5>
												</div>
												<div class="layui-card-body">
													<div class="layui-form-item">
														<label class="layui-form-label">
															分享标题 :
														</label>
														<div class="layui-input-block">
															<input type="text" name="shareTitle" placeholder="请输入分享标题" autocomplete="off" class="layui-input" />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															分享内容 :
														</label>
														<div class="layui-input-block">
															<input type="text" name="shareDesc" placeholder="请输入分享内容" autocomplete="off" class="layui-input" />
														</div>
													</div> 
													<div class="layui-form-item">
														<label class="layui-form-label">
															分享图片 :
														</label>
														<div class="layui-input-block">
															<div class="layui-col-md2 layui-col-xs6">
																<div class="layui-upload-list">
																	<img class="layui-upload-img" id="shareFiles_img" style="width:100%;" src="" />
																	<p style="font-size:12px;color:red;margin-top:5px">
																		*图片分辨率为300*300
																	</p>
																</div>
															</div>
															<div class="layui-col-md8 layui-col-xs6" style="margin-left:10px;">
																<div class="layui-form-item">
																	<button type="button" class="layui-btn" @click="handleshare
																		">
																		上传图片
																	</button>
																	<input name="shareImg" type="file" class="layui-input" id="shareImg" style="display: none;" @change="handleShare
																		" />
																</div>
															</div>
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															是否允许分享现场报名链接 :
														</label>
														<div class="layui-input-block">
															<input type="radio" name="share_url_type" value="1" title="是" lay-filter="share_url_type" />
															<input type="radio" name="share_url_type" value="0" title="否" lay-filter="share_url_type" checked />
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															线上报名链接 :
														</label>
														<div class="layui-input-block">
															<input type="text" name="onlineUrl" autocomplete="off" class="layui-input" disabled/>
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
															现场报名链接 :
														</label>
														<div class="layui-input-block">
															<input type="text" name="sceneUrl" autocomplete="off" class="layui-input" disabled/>
														</div>
													</div>
													<div class="layui-form-item">
														<label class="layui-form-label">
														  现场报名自动跳转报名页链接 :
														</label>
														<div class="layui-input-block">
															<input type="text" name="scene_jump_enroll_url" autocomplete="off" class="layui-input" disabled/>
														</div>
													</div>
												</div>
											</div>
											<div class="layui-card">
												<div class="layui-card-header">
													<h5 style="margin-left: 10px;padding-top: 10px;">
														微信首页背景图
													</h5>
												</div>
												<div class="layui-card-body">
													<div class="layui-row">
														<div class="layui-col-md2 layui-col-xs6">
															<div class="layui-upload-list">
																<img class="layui-upload-img" id="weChatFiles_img" width="120" src="http://bpic.588ku.com/element_pic/01/47/81/68574403f2100e0.jpg" />
																<p style="font-size:12px;color:red;margin-top:5px">
																	*图片分辨率为374*627
																</p>
															</div>
														</div>
														<div class="layui-col-md10 layui-col-xs6">
															<div class="layui-form-item">
																<button type="button" class="layui-btn" @click="handleWeChat
																	">
																	上传图片
																</button>
																<input name="background" type="file" class="layui-input" id="weChats" style="display: none;" @change="handleWeChats
																	" />
															</div>
														</div>
													</div>
												</div>
											</div>
											<div class="layui-card">
												<div class="layui-card-header">
													<h5 style="margin-left: 10px;padding-top: 10px;">
														会议模板
													</h5>
												</div>
												<div class="layui-card-body">
													<div class="layui-row">
														<div class="layui-col-md2" v-for="item in organizationTemplate" :key="item.id">
															<div class="layui-col-md12 layui-col-xs12" style="text-align: center;">
																<div class="layui-form-item">
																	<img :src="item.img_url
																		" alt width="120" height="160px" />
																	<p>
																		<input lay-verify="required" type="radio" name="template_id" :value="item.id" :title="item.title" />
																	</p>
																</div>
															</div>
														</div>
													</div>
													<div class="layui-form-item" style="text-align: center;">
														<button type="button" class="layui-btn" id="sharemanagement" @click="four">
															上一步
														</button>
														<button type="button" class="layui-btn" lay-submit lay-filter="saveDataShareManagement">
															保存
														</button>
													</div>
												</div>
											</div>
										</form>
									</div>
									<!--专题管理-->
									<div class="layui-tab-item" v-if="editId != ''">
										<zhuanti></zhuanti>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--新增栏目开始-->
		<el-dialog v-if="dialogFormVisibleFive" :title="titleFive" :visible.sync="dialogFormVisibleFive" :modal-append-to-body="false" :before-close="handleDialogClose" :close-on-click-modal="false" style="z-index:4000 ;">
			<form class="layui-form" action style="width: 98%;margin-top: 20px;" id="newcolumn" lay-filter="dataColumn">
				<!-- 父级列表 -->
				<div class="layui-form-item" id="father" style="display:none">
					<label class="layui-form-label" style="width: 110px;">父级列表:</label>
					<div class="layui-input-block" style="z-index:99">
						<el-select v-model="couponSelected" placeholder="请选择父级列表" style="width:100%" :disabled="lian_d" @change="lian">
							<el-option label="请选择父级列表" value></el-option>
							<el-option v-for="item in fu_lan" :key="item.id" :label="item.title" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<!-- 父级栏目 -->
				<div class="layui-form-item" id="fathers">
					<label class="layui-form-label" style="width: 110px;">父级栏目:</label>
					<div class="layui-input-block" style="z-index:99">
						<el-select v-model="couponSelecteds" placeholder="请选择父级栏目" style="width:100%" @change="lan" :disabled="lan_d">
							<el-option label="请选择父级栏目" value></el-option>
							<el-option v-for="item in fu_lans" :key="item.id" :label="item.title" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
				<!-- 栏目名称 -->
				<div class="layui-form-item">
					<label class="layui-form-label" style="width: 110px;">
						栏目名称:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block">
						<input type="text" name="title" lay-verify="required" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 栏目类型 -->
				<div class="layui-form-item">
					<label class="layui-form-label" style="width: 110px;">
						栏目类型:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block" style="z-index:999999">
						<select name="type" lay-verify="required" lay-filter="columnType" id="columnTypes">
							<option>请选择类型</option>
							<option value="1">内容单页</option>
							<option value="2">内容列表</option>
							<option value="3">跳转链接</option>
							<option value="4">附件下载</option>
							<option value="5">关联嘉宾</option>
							<option value="6">会议详情</option>
							<option value="7">我的报名</option>
							<option value="8">发票开票</option>
							<option value="9">会后-媒体报道</option>
							<option value="10">会后-会议资料</option>
							<option value="11">会后-会议回顾</option>
							<option value="12">查找座位</option>
							<option value="13">顶级栏目</option>
							<option value="14">图文直播</option>
						</select>
					</div>
				</div>
				<!-- 标题 -->
				<div class="layui-form-item sp_img">
					<label class="layui-form-label" style="width: 110px;">
						标题:
					</label>
					<div class="layui-input-block">
						<input type="text" name="title_name" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 图文直播作者 -->
				<div class="layui-form-item" v-show="zhibo">
					<label class="layui-form-label" style="width: 110px;">
						作者:
					</label>
					<div class="layui-input-block">
						<input type="text" name="author" placeholder="请输入作者" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 图文直播关键词 -->
				<div class="layui-form-item" v-show="zhibo">
					<label class="layui-form-label" style="width: 110px;">
						关键词:
					</label>
					<div class="layui-input-block">
						<input type="text" name="keyword" placeholder="关键词英文 ',' 隔开" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 发布时间 -->
				<div class="layui-form-item" id="lan_time">
					<label class="layui-form-label" style="width: 110px;">
						发布时间:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-inline" style="margin-left: 10px;">
						<input type="text" name="publish_time" id="publish_time" placeholder="yyyy-MM-dd HH:mm:ss" autocomplete="off" class="layui-input" lay-filter="publish_time" />
					</div>
				</div>
				<!-- 跳转链接 -->
				<div class="layui-form-item" style="display: none;" id="skipLinks">
					<label class="layui-form-label" style="width: 110px;">
						跳转链接:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block">
						<input type="text" name="jump_url" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 简介 -->
				<div class="layui-form-item" id="jiejian">
					<label class="layui-form-label" style="width: 110px;">
						简介:
						<i style="color:red">*</i>
					</label>

					<div class="layui-input-block">
						<vue-ueditor-wrap v-model="contenthave" :config="myConfig"></vue-ueditor-wrap>
					</div>
					<!-- </div> -->
				</div>
				<!-- 上传附件 -->
				<div class="layui-form-item" style="display: none" id="attachments">
					<label class="layui-form-label" style="width: 110px;">
						上传附件:
						<i style="color:red">*</i>
					</label>

					<div class="layui-input-block" id="fufu">
						<el-upload class="upload-demo" action="/ac1/upload/oneFile" :on-success="handleTopFile" :on-error="handleerr" :limit="1" :on-exceed="handleExceed" ref="my-upload" accept=".xls, .PDF, .pptx, .dox, .docx, .ppt, .xlsx">
							<el-button type="primary" @click="fujian_file">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">
								支持上传文件PPT,Excel,Word,PDF(仅支持上传一个文件)
							</div>
						</el-upload>
					</div>
				</div>
				<!-- 上传资料文件 -->
				<div class="layui-form-item" style="display:none" id="ziliao">
					<label class="layui-form-label" style="width: 110px;">
						上传资料文件:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block" id="ziliao_file">
						<el-upload class="upload-demo" action="/ac1/conference/column/upload" multiple :on-success="handleTopFiles" :on-remove="remove_file" ref="my-uploads" accept=".xls, .PDF, .pptx, .dox, .docx, .ppt, .xlsx">
							<el-button type="primary" @click="file_top">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">
								支持PDF\PPT\WORD\Excil格式内容(支持上传多个文件)
							</div>
						</el-upload>
					</div>
				</div>
				<!-- 视频封面 -->
				<div class="layui-form-item sp_img" style="display:none">
					<label class="layui-form-label">视频封面:</label>
					<div class="layui-input-block">
						<button type="button" class="layui-btn" @click="handleUploadConferenceCovers">
							上传图片
						</button>
						<input type="file" name="head_img" class="layui-input" id="testlogoss" style="display: none;" @change="uploadss" />
						<p class="layui-elip" style="color: red;font-size: 12px;margin-top: 10px;">
							仅支持png、jpg格式图片
						</p>
						<div class="layui-input-list" style="margin-top: 10px;">
							<img class="layui-upload-img" id="demosGuests" width="60" height="60" style="display: none" />
						</div>
					</div>
				</div>
				<!-- 直播封面 -->
				<div class="layui-form-item" v-show="zhibo">
					<label class="layui-form-label">直播封面:</label>
					<div class="layui-input-block">
						<button type="button" class="layui-btn" @click="mh_handleUploadConferenceCovers">
							上传图片
						</button>
						<input type="file" name="head_img" class="layui-input" id="mh_testlogoss" style="display: none;" @change="mh_uploadss" />
						<p class="layui-elip" style="color: red;font-size: 12px;margin-top: 10px;">
							仅支持png、jpg格式图片
						</p>
						<div class="layui-input-list" style="margin-top: 10px;">
							<img class="layui-upload-img" id="mh_demosGuests" width="60" height="60" style="display: none" />
						</div>
					</div>
				</div>
				<!-- 关联嘉宾 -->
				<div class="layui-form-item" id="lan_xx" style="display:none">
					<label class="layui-form-label" style="width: 110px;">
						关联嘉宾:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block">
						<div style="background:white">
							<button type="button" class="layui-btn" @click="change_people">
								+选择嘉宾
							</button>
							<table class="layui-hide" id="jiabing" lay-filter="jiabing"></table>
						</div>
						<!-- 嘉宾表格 -->
						<table id="test_jiabin" lay-filter="test_jiabin"></table>
					</div>
				</div>
				<!-- 直播状态 -->
				<div class="layui-form-item" v-show="zhibo">
					<label class="layui-form-label" style="width: 110px;">直播状态<i style="color:red">*</i></label>
					<div class="layui-input-block">
						<input type="radio" name="play_status" value="1" title="直播未开始" />
						<input type="radio" name="play_status" value="2" title="直播开始" />
						<input type="radio" name="play_status" value="3" checked title="直播暂停" />
						<input type="radio" name="play_status" value="4" title="直播结束" />
					</div>
				</div>
				<!-- 新建直播 -->
				<div class="
	                layui-form-item" v-show="zhibo">
					<el-button type="primary" style="margin-left:40px" @click="startzb">新建直播</el-button>
				</div>
				<!-- 直播列表 -->
				<div class="layui-form-item" v-show="zhibo" style="padding-left:40px">
					<el-table :data="tableData" style="width: 100%">
						<el-table-column type="expand">
							<template slot-scope="props">
								<el-form label-position="left" inline class="demo-table-expand">
									<el-form label-position="left" inline class="demo-table-expand">
										<p v-html="props.row.desc"></p>
									</el-form>
								</el-form>
							</template>
						</el-table-column>
						<el-table-column label="日期">
							<template slot-scope="scope">
								<i class="el-icon-time"></i>
								<span style="margin-left: 10px">{{
									scope.row.publish_time | dateformat
								}}</span>
							</template>
						</el-table-column>
						<el-table-column label="内容" show-overflow-tooltip>
							<template slot-scope="scope">
								<p v-html="scope.row.desc" style="height: 20px;"></p>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button size="mini" @click="editzb(scope.row.id)">
									编辑</el-button>
								<el-button size="mini" type="danger" @click="deletzb(scope.row.id)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination @current-change="zbChange" background layout="prev, pager, next" :total="zbtotle" :current-page="zbpage" :page-size="zbpagesize" style="margin-top:20px">
					</el-pagination>
				</div>
				<!-- 分享页的图标 -->
				<div class="layui-form-item">
					<label class="layui-form-label" style="width: 110px;">
						分享页图标:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block">
						<button type="button" class="layui-btn" @click="handleColumnIcon">
							上传图片
						</button>
						<input type="file" class="layui-input" id="columnIcon_file" style="display: none;" @change="handleIcon" />
						<div class="layui-upload-list" style="background:#cdcaca">
							<img class="layui-upload-img" width="60" height="60" style="display: none;" id="columnIcon_img" />
						</div>
					</div>
				</div>
				<div class="layui-form-item">
					<div class="layui-input-block" style="margin-left: 24%;">
						<span style="display: inline-block; margin-bottom: 6px;width: 95px;position: relative;" v-for="(item, index) in iconlist" :key="index">
							<img style="width: 60px;height: 60px;background: rgb(205, 202, 202)" :src="item.img_url" alt="" /><br />
							<input type="radio" name="icon_id" lay-filter="iconids" :value="item.id" :title="'图标' + (index + 1)" @change="iconchange" />
							<i class="el-icon-delete" style="position: absolute;
										right: 36%;
										top: 0px;
										background: white;
										padding: 2px;
										cursor: pointer;
										color: red;" @click="removeicon(item.id)"></i></span>
					</div>
				</div>
				<!-- 栏目的图标 -->
				<div class="layui-form-item icon">
					<label class="layui-form-label" style="width: 110px;">
						栏目图标:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block">
						<button type="button" class="layui-btn" @click="handleColumnIcons">
							上传图片
						</button>
						<input type="file" class="layui-input" id="columnIcon_files" style="display: none;" @change="handleIcons" />

						<div class="layui-upload-list" style="background:#cdcaca">
							<img class="layui-upload-img" width="60" height="60" style="display: none;" id="columnIcon_imgs" />
						</div>
					</div>
				</div>
				<div class="layui-form-item icon">
					<div class="layui-input-block" style="margin-left: 24%;">
						<span style="display: inline-block; margin-bottom: 6px;width: 95px;position: relative;" v-for="(items, index) in iconlists" :key="index">
							<img style="width: 60px;height: 60px;background: rgb(205, 202, 202)" :src="items.img_url" alt="" /><br />
							<input type="radio" name="column_icon_id" lay-filter="iconidss" :value="items.id" :title="'图标' + (index + 1)" @change="iconchanges" />
							<i class="el-icon-delete" style="    position: absolute;
											right: 36%;
											top: 0px;
											background: white;
											padding: 2px;
											cursor: pointer;
											color: red;" @click="removeicon(items.id)"></i></span>
					</div>
				</div>
				<!-- 是否在详情页显示 -->
				<div class="
                layui-form-item" id="synchronizeWeChat">
					<label class="layui-form-label" style="width: 110px;">是否详情页显示</label>
					<div class="layui-input-block">
						<input type="radio" name="display" value="1" title="显示" />
						<input type="radio" name="display" value="0" title="不显示" checked />
					</div>
				</div>
				<!-- 是否在分享页显示 -->
				<div class="layui-form-item" id="fxy">
					<label class="layui-form-label" style="width: 110px;">是否分享页显示<i style="color:red">*</i></label>
					<div class="layui-input-block">
						<input type="radio" name="share_show" value="1" title="显示" />
						<input type="radio" name="share_show" value="0" title="不显示" checked />
					</div>
				</div>

				<div class="layui-form-item" id="fxy">
					<label class="layui-form-label" style="width: 110px;">内容页边距<i style="color:red">*</i></label>
					<div class="layui-input-block">
						<input type="radio" name="is_full" value="1" title="无边距" />
						<input type="radio" name="is_full" value="0" title="有边距" checked />
					</div>
				</div>
				<!-- 排序 -->
				<div class="layui-form-item" id="paixu">
					<label class="layui-form-label" style="width: 110px;">排序:</label>
					<div class="layui-input-block">
						<input type="text" name="list_order" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 是否公开 -->
				<div class="layui-form-item" id="out_people" style="display:none">
					<label class="layui-form-label" style="width: 110px;">是否公开:</label>
					<div class="layui-input-block" style="z-index:99">
						<el-select v-model="out_peoples" placeholder="请选择" style="width:100%">
							<el-option value="0" label="公开所有人可见">公开所有人可见</el-option>
							<el-option value="1" label="不公开">不公开</el-option>
						</el-select>
					</div>
				</div>
				<!-- 选择视频 -->
				<div class="layui-form-item" id="ship" style="display:none">
					<label class="layui-form-label" style="width: 110px;">
						选择视频:
						<i style="color:red">*</i>
					</label>
					<div class="layui-input-block" style="z-index:99">
						<el-select v-model="video_id" placeholder="请选择视频" style="width:100%">
							<el-option label="请选择视频" value></el-option>
							<el-option v-for="item in video_all" :key="item.id" :label="item.title" :value="item.resource_id"></el-option>
						</el-select>
					</div>
				</div>
				<!-- 提交 -->
				<div class="layui-form-item" style="text-align: center">
					<button type="button" class="layui-btn" lay-submit lay-filter="saveNewcolumn">
						确定
					</button>
					<button type="reset" id="handleCancel" class="layui-btn layui-btn-primary" @click="nos">
						取消
					</button>
				</div>
			</form>
		</el-dialog>
		<!--新增栏目结束-->
		<!-- 新建直播开始 -->
		<el-dialog title="直播信息" :visible.sync="newzhibo">
			<el-form :model="zbform">
				<el-form-item label="发布时间">
					<el-date-picker v-model="zbform.publish_time" type="datetime" value-format="timestamp" placeholder="选择日期时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="直播内容">
					<div style="width: 90%;float: right;">
						<vue-ueditor-wrap v-model="zbform.desc" :config="myConfig"></vue-ueditor-wrap>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="newzhibo = false">取 消</el-button>
				<el-button type="primary" @click="submitzb">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 新建直播结束-->
		<!--新增票种弹窗开始-->
		<el-dialog :title="titleTwo" :visible.sync="dialogFormVisibleTwo" :modal-append-to-body="false" :close-on-click-modal="false">
			<form class="layui-form" action style="width: 90%;" id="ticket" lay-filter="dataForm">
				<div class="layui-card">
					<div class="layui-card-header">票种基本信息</div>
					<div class="layui-card-body">
						<div class="layui-form-item" style="margin-top: 20px">
							<label class="layui-form-label" style="width: 110px">票种名称:</label>
							<div class="layui-input-block">
								<input type="text" name="name" lay-verify="required" placeholder="请输入票种名称" autocomplete="off" class="layui-input" />
							</div>
						</div>
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 110px">价格:</label>
							<div class="layui-input-block">
								<input type="text" name="price" lay-verify="required" placeholder="请输入价格" autocomplete="off" class="layui-input" />
							</div>
						</div>
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 110px">总量:</label>
							<div class="layui-input-block">
								<input type="text" name="number" placeholder="请输入总量" autocomplete="off" class="layui-input" />
							</div>
						</div>

						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 110px">每人限购数:</label>
							<div class="layui-input-block">
								<input type="text" name="limit_number" lay-verify="required" placeholder="请输入" autocomplete="off" class="layui-input" />
							</div>
						</div>
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 110px">预定说明:</label>
							<div class="layui-input-block">
								<textarea name="desc" lay-verify="required" placeholder="请输入" class="layui-textarea"></textarea>
							</div>
						</div>
					</div>
				</div>

				<div class="layui-card">
					<!-- <div class="layui-card-header">设置发票规则</div> -->
					<div class="layui-card-body">
						<div class="layui-form-item" style="text-align: center">
							<button type="button" class="layui-btn" lay-submit lay-filter="saveTicket">
								确定
							</button>
							<button type="reset" class="layui-btn layui-btn-primary" @click="dialogFormVisibleTwo = false">
								取消
							</button>
						</div>
					</div>
				</div>
			</form>
		</el-dialog>
		<!--新增票种弹窗结束-->

		<!--创建酒店信息开始-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :modal-append-to-body="false" :close-on-click-modal="false">
			<div class="theDormManager">
				<!--创建酒店信息开始-->
				<form class="layui-form" action style="width: 90%" id="theDormManagerId" lay-filter="dataApplicationFields">
					<div class="layui-form-item" style="margin-top: 20px;">
						<label class="layui-form-label">酒店名称:</label>
						<div class="layui-input-block">
							<input type="text" name="h_name" lay-verify="required" placeholder="请输入酒店名称" autocomplete="off" class="layui-input" id="jiudian" />
						</div>
					</div>
					<!--动态添加-->
					<div>
						<div class="layui-form-item">
							<label class="layui-form-label">房型:</label>
							<div class="layui-input-block">
								<input type="text" name="hotel_type" lay-verify="required" placeholder="请输入房型名" autocomplete="off" class="layui-input" />
							</div>
						</div>
						<div class="layui-form-item">
							<label class="layui-form-label">房间价格:</label>
							<div class="layui-input-block">
								<input type="text" name="price" lay-verify="required" placeholder="请输入房间价格" autocomplete="off" class="layui-input" />
							</div>
						</div>

						<div class="layui-form-item">
							<label class="layui-form-label">预定数:</label>
							<div class="layui-input-block">
								<input type="text" name="quantity" lay-verify="required" placeholder="请输入预定数" autocomplete="off" class="layui-input" />
							</div>
						</div>
						<div class="layui-form-item">
							<div class="layui-inline">
								<label class="layui-form-label" style="width: 110px">可入住时间:</label>
								<div class="layui-input-inline" style="margin-left: 10px;">
									<input type="text" name="start_time" lay-verify="required" id="diningStarts" placeholder="开始日期" autocomplete="off" readonly="readonly" class="layui-input" />
								</div>
								<div class="layui-form-mid">-</div>
								<div class="layui-input-inline">
									<input type="text" name="end_time" lay-verify="required" id="diningEnds" placeholder="结束日期" autocomplete="off" readonly="readonly" class="layui-input" />
								</div>
							</div>
						</div>

						<div class="layui-form-item">
							<label class="layui-form-label">可入住人数:</label>
							<div class="layui-input-block">
								<input type="radio" name="member_num" value="1" title="1人" checked />
								<input type="radio" name="member_num" value="2" title="2人" />
							</div>
						</div>

						<div class="layui-form-item yuding">
							<label class="layui-form-label">预定说明:</label>
							<div class="layui-input-block">
								<textarea name="explain" placeholder="请输入预定说明" class="layui-textarea"></textarea>
							</div>
						</div>

						<div class="layui-form-item yuding">
							<label class="layui-form-label">备注信息:</label>
							<div class="layui-input-block">
								<textarea name="desc" placeholder="请输入备注信息" class="layui-textarea"></textarea>
							</div>
						</div>

						<div class="layui-form-item status">
							<label class="layui-form-label">排序:</label>
							<div class="layui-input-block">
								<input class="layui-input" name="list_order" type="text" />
							</div>
						</div>
						<div class="layui-form-item status">
							<label class="layui-form-label">状态:</label>
							<div class="layui-input-block">
								<input type="checkbox" name="status" lay-skin="switch" lay-text="上架|下架" value="1" checked />
							</div>
						</div>
					</div>
					<div style="text-align: center">
						<button type="button" class="layui-btn" lay-submit lay-filter="theDormManagerSave">
							确定
						</button>
						<button type="reset" class="layui-btn layui-btn-primary" @click="dialogFormVisible = false">
							取消
						</button>
					</div>
				</form>
			</div>
		</el-dialog>
		<!--创建酒店信息结束-->

		<!--新建就餐信息开始-->
		<el-dialog :title="titleThree" :visible.sync="dialogFormVisibleThree" :modal-append-to-body="false" :close-on-click-modal="false">
			<form class="layui-form" action style="width: 90%" id="dining" lay-filter="diningManagementDataForm">
				<div class="layui-form-item" style="margin-top: 20px;">
					<label class="layui-form-label">就餐地点:</label>
					<div class="layui-input-block">
						<input type="text" name="address" required lay-verify="required" placeholder="请输入就餐地点" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" style="margin-top: 20px;">
					<label class="layui-form-label invoice">是否清真:</label>
					<div class="layui-input-block">
						<input type="radio" name="is_muslim" value="1" title="是" checked />
						<input type="radio" name="is_muslim" value="0" title="否" />
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">就餐价格:</label>
					<div class="layui-input-block">
						<input type="text" name="price" required lay-verify="required" placeholder="请输入就餐价格" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">就餐说明:</label>
					<div class="layui-input-block">
						<input type="text" name="explain" required lay-verify="required" placeholder="请输入就餐说明" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">预定数:</label>
					<div class="layui-input-block">
						<input type="text" name="number" required lay-verify="required" placeholder="请输入预定数" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item">
					<div class="layui-inline">
						<label class="layui-form-label" style="width: 110px">就餐日期:</label>
						<div class="layui-input-inline" style="margin-left: 10px;">
							<input type="text" name="start_time" lay-verify="required" id="diningStart" placeholder="开始日期" autocomplete="off" readonly="readonly" class="layui-input" style />
						</div>
						<div class="layui-form-mid">-</div>
						<div class="layui-input-inline">
							<input type="text" name="end_time" lay-verify="required" id="diningEnd" placeholder="结束日期" autocomplete="off" readonly="readonly" class="layui-input" style />
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="eight_zd">
					<label class="layui-form-label" style="width: 118px;">排序:</label>
					<div class="layui-input-block">
						<input name="list_order" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item status">
					<label class="layui-form-label">状态:</label>
					<div class="layui-input-block">
						<input type="checkbox" name="status" lay-skin="switch" lay-text="上架|下架" value="1" checked />
					</div>
				</div>
				<div class="layui-form-item" style="text-align: center">
					<button type="button" class="layui-btn" lay-submit lay-filter="diningManagementAndPreservation">
						确定
					</button>
					<button type="reset" class="layui-btn layui-btn-primary" @click="dialogFormVisibleThree = false">
						取消
					</button>
				</div>
			</form>
		</el-dialog>
		<!--新建就餐信息结束-->

		<!--报名字段弹窗开始-->
		<el-dialog :title="titleFour" :visible.sync="dialogFormVisibleFour" :modal-append-to-body="false" :before-close="removea" :close-on-click-modal="false">
			<form action class="layui-form" id="signupfield" lay-filter="dataApplicationField" style="width: 100%;">
				<div class="layui-form-item" style="margin-top: 20px;" id="one_zd">
					<label class="layui-form-label" style="width: 118px;">
						请选择字段类型
						<span style="color: red;font-size: 150%">*</span>:
					</label>
					<div class="layui-input-block">
						<select name="form_type" lay-filter="fieldType" id="formtype">
							<option>请选择字段类型</option>
							<option value="1">单行文本</option>
							<option value="2">多行文本</option>
							<option value="3">单选按钮</option>
							<option value="4">多选按钮</option>
							<option value="5">下拉框</option>
							<option value="6">选择日期</option>
							<option value="7">搜索下拉</option>
							<option value="8">分组标识</option>
						</select>
					</div>
				</div>
				<div class="layui-form-item" id="two_zd">
					<label class="layui-form-label" style="width: 118px;">
						字段名
						<span style="color: red;font-size: 150%">*</span>:
					</label>
					<div class="layui-input-block">
						<input lay-verify="required" name="field" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
						<div class="layui-form-mid layui-word-aux">
							例如：文章标题
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="three_zd">
					<label class="layui-form-label" style="width: 118px;">
						字段别名:
					</label>
					<div class="layui-input-block">
						<input name="field_name" type="text" placeholder="请输入" autocomplete="off" class="layui-input" id="name_text" />
						<div class="layui-form-mid layui-word-aux">
							只可以英文字母数字，要字母开头
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="four_zd">
					<label class="layui-form-label" style="width: 118px;">
						字段提示
						<span style="color: red;font-size: 150%">*</span>:
					</label>
					<div class="layui-input-block">
						<textarea name="tips" placeholder="请输入" class="layui-textarea"></textarea>
						<div class="layui-form-mid layui-word-aux">
							作为表单字段的输入提示
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="four_bz">
					<label class="layui-form-label" style="width: 118px;">
						字段备注信息:
					</label>
					<div class="layui-input-block">
						<textarea name="remake" placeholder="请输入" class="layui-textarea"></textarea>
						<div class="layui-form-mid layui-word-aux">
							字段备注信息 标签名下 灰色提示字
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="three_zd">
					<label class="layui-form-label" style="width: 118px;">
						是否关联:
					</label>
					<div class="layui-input-block">
						<input type="checkbox" name="relation_status" lay-skin="switch" lay-text="是|否" value="1" />
					</div>
				</div>
				<div class="layui-form-item" id="three_zd">
					<label class="layui-form-label" style="width: 118px;">
						被关联字段:
					</label>
					<div class="layui-input-block">
						<select name="relation_field_id" lay-filter="relation_field_id">
							<option>请选择</option>
							<option v-for="(item,
								index) in relation_params.relation_field_id_options" :key="index" :value="item.id" :selected="relation_params.selected_id == item.id
		">{{ item.field }}</option>
						</select>
					</div>
				</div>
				<div class="layui-form-item" id="three_zd">
					<label class="layui-form-label" style="width: 118px;">
						关联字段值:
					</label>
					<div class="layui-input-block">
						<select name="relation_field_val" lay-filter="business">
							<option v-for="(item,
								index) in relation_params.relation_field_val_options" :key="index" :value="item" :selected="relation_params.relation_field_val_selected ==
		item
		">{{ item }}</option>
						</select>
					</div>
				</div>
				<!--切换-->
				<div class="layui-card" style="display: none" id="singletext">
					<div class="layui-card-header" style="font-weight: bold">
						相关参数
					</div>
					<div class="layui-card-body">
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 118px;">
								文本框长度：
								<span style="color: red;font-size: 150%">*</span>:
							</label>
							<div class="layui-input-block">
								<input name="setting_width" id="onehundredpercent" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
								<div class="layui-form-mid layui-word-aux">
									例子：80px 或 100%
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="layui-card" style="display: none" id="textField">
					<div class="layui-card-body">
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 118px;">
								文本域高度：
								<span style="color: red;font-size: 150%">*</span>:
							</label>
							<div class="layui-input-block">
								<input name="setting_height" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
								<div class="layui-form-mid layui-word-aux">
									示例 50px
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="layui-card" style="display: none" id="mima">
					<div class="layui-card-body">
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 118px;">是否为密码框:</label>
							<div class="layui-input-block">
								<input type="radio" name="is_password" value="1" title="是" />
								<input type="radio" name="is_password" value="0" title="否" checked />
							</div>
						</div>
					</div>
				</div>
				<div class="layui-card" style="display: none" id="comprehensive">
					<div class="layui-card-header" style="font-weight: bold">
						相关参数
					</div>

					<div class="layui-card-body">
						<div class="layui-form-item">
							<label class="layui-form-label" style="width: 118px;">选项列表</label>
							<span style="color: red;font-size: 150%">*</span>:
							<div class="layui-input-block">
								<textarea placeholder="请输入xxx，用英文“,”隔开,如单选框“男,女”" class="layui-textarea" name="options"></textarea>
								<div class="layui-form-mid layui-word-aux">
									请输入xxx，用英文“,”隔开,如单选框“男,女”
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="layui-form-item" id="five_zd">
					<label class="layui-form-label" style="width: 118px;">表单附加属性:</label>
					<div class="layui-input-block">
						<input name="formattribute" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
						<div class="layui-form-mid layui-word-aux">
							可以通过此处加入javascript事件
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="six_zd">
					<label class="layui-form-label" style="width: 118px;">表单样式名:</label>
					<div class="layui-input-block">
						<input name="css" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
						<div class="layui-form-mid layui-word-aux">
							定义表单的CSS样式名
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="text_length">
					<div class="layui-inline">
						<label class="layui-form-label" style="width: 140px;">
							字符长度取值范围
							<span style="color: red;font-size: 150%">*</span>:
						</label>

						<div class="layui-input-inline" style="width: 100px;margin-left: 10px;">
							<input type="text" name="minlength" placeholder="0" autocomplete="off" lay-verify="required" class="layui-input" value="0" />
						</div>
						<div class="layui-form-mid">-</div>
						<div class="layui-input-inline" style="width: 100px;">
							<input type="text" name="maxlength" placeholder="99" autocomplete="off" lay-verify="required" class="layui-input" value="99" />
						</div>
						<div class="layui-form-mid layui-word-aux">
							默认长度0~99
						</div>
					</div>
				</div>
				<div class="layui-form-item" id="zze">
					<label class="layui-form-label" style="width: 118px;">常用正则:</label>
					<div class="layui-input-block">
						<select name="pattern" lay-filter="business">
							<option value>请选择</option>
							<option value="0">数字</option>
							<option value="1">整数</option>
							<option value="2">字母</option>
							<option value="3">数字+字母</option>
							<option value="4">E-mail</option>
							<option value="5">QQ</option>
							<option value="6">超级链接</option>
							<option value="7">手机号码</option>
							<option value="8">电话号码</option>
							<option value="9">邮政编码</option>
						</select>
					</div>
				</div>

				<div class="layui-form-item" id="seven_zd">
					<label class="layui-form-label" style="width: 118px;">是否必填:</label>
					<div class="layui-input-block">
						<select name="is_required" lay-filter="required">
							<option value>请选择</option>
							<option value="0">否</option>
							<option value="1">是</option>
						</select>
					</div>
				</div>
				<div class="layui-form-item" id="eight_zd">
					<label class="layui-form-label" style="width: 118px;">排序:</label>
					<div class="layui-input-block">
						<input name="list_order" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<div class="layui-form-item" id="nine_zd">
					<label class="layui-form-label" style="width: 118px;">校验未通过的提示:</label>
					<div class="layui-input-block">
						<input name="errortips" type="text" placeholder="请输入" autocomplete="off" class="layui-input" />
					</div>
				</div>
				<!-- 是否皮书部门 -->
				<div class="layui-form-item" id="psbm">
					<label class="layui-form-label" style="width: 110px;">皮书部门<i style="color:red">*</i>:</label>
					<div class="layui-input-block">
						<input type="radio" name="is_pishu_group" value="1" title="是" />
						<input type="radio" name="is_pishu_group" value="0" title="否" checked />
					</div>
				</div>
				<!-- 皮书部门最多数量 -->
				<div class="layui-form-item" id="maxps">
					<label class="layui-form-label" style="width: 110px;">选项最大数量<i style="color:red">*</i>:</label>
					<div class="layui-input-inline" style="width: 150px;">
						<input type="Number" autocomplete="off" name="max_select_num" value="0" placeholder="请输入数量" class="layui-input"/> 
					</div> 
					<div class="layui-form-mid layui-word-aux">
						皮书课题组限制最大选择数量（0 为不限制）
						</div>
				</div>
				<div class="layui-form-item" style="text-align: center" id="ten_zd">
					<button type="button" class="layui-btn" lay-submit lay-filter="formDemo">
						确定
					</button>
					<button type="reset" class="layui-btn layui-btn-primary" @click="removea">
						取消
					</button>
				</div>
			</form>
		</el-dialog>
		<!-- 房间弹出层 -->
		<div id="openProductBox" style="display: none; padding: 10px;">
			<table id="openProductTable" lay-filter="openProductTable">
				<h3 style="text-align: center">签到名单</h3>
			</table>
		</div>
	</div>
</template>

<script>
import moment from "moment"; //时间处理
import VueUeditorWrap from "vue-ueditor-wrap";
import zhuanti from "@/pages/AnewMeeting/zhuanti";
let map = null,
	geoc = null;
export default {
	data () {
		return {
			//会议ID
			editId: "",
			activeNames: ["1", "2", "3", "4", "5", "6", "7"], //版块开关
			/* 直播列表 */
			tableData: [],
			/* 直播列表分页 */
			zbtotle: "",
			zbpage: 1,
			zbpagesize: 8,
			/* 判断直播类型时字段显示 */
			zhibo: false,
			/* 新建直播弹窗 */
			newzhibo: false,
			/* 新建直播字段 */
			zbform: {
				id: "",
				publish_time: "",
				desc: ""
			},
			//会议基本信息form
			jbxxform: {
				type: "", //会议类型
				enroll_start_time: "", //报名开始时间
				enroll_end_time: "" //报名结束时间
			},
			type_option: [
				{
					label: "请选择会议性质",
					value: ""
				},
				{
					label: "会议/论坛",
					value: "1"
				},
				{
					label: "讲座/沙龙",
					value: "2"
				},
				{
					label: "发布会",
					value: "3"
				},
				{
					label: "其他",
					value: "4"
				}
			],

			/* 形式 */
			xsarr: [],
			arrxs: [
				{
					value: "1",
					label: "线上"
				},
				{
					value: "2",
					label: "线下"
				},
				{
					value: "3",
					label: "直播"
				}
			],
			modify_time: "",
			refund_endtime:'',
			/* 上传轮播图 */
			fileListkk: [],
			fileLists: [],
			arrsurl: [],
			baseimg: [],
			/* 富文本参数 */
			msgok: "",
			detail: "",
			remittance_info: "",
			contenthave: "",
			/* 分享页图标 */
			iconlist: [],
			/* 栏目图标 */
			iconlists: [],
			contents: "",
			myConfig: {
				// 编辑器自动被内容撑高
				autoHeightEnabled: true,
				// 初始容器高度
				initialFrameHeight: 200,
				// 初始容器宽度
				initialFrameWidth: "100%",
				retainOnlyLabelPasted: false,
				pasteplain: false,
				zIndex: 200000,
				toolbars: [
					[
						"source",
						"|",
						"undo",
						"redo",
						"|",
						"bold",
						"italic",
						"underline",
						"strikethrough",
						"forecolor",
						"backcolor",
						"superscript",
						"subscript",
						"autotypeset",
						"blockquote",
						"pasteplain",
						"|",
						"removeformat",
						"formatmatch",
						"cleardoc",
						"|",
						"paragraph",
						"fontfamily",
						"fontsize",
						"|",
						"insertorderedlist",
						"insertunorderedlist",
						"rowspacingtop",
						"rowspacingbottom",
						"lineheight",
						"indent",
						"|",
						"justifyleft",
						"justifycenter",
						"justifyright",
						"justifyjustify",
						"|",
						"touppercase",
						"tolowercase",
						"|",
						"link",
						"unlink",
						/*'anchor',*/
						"|",
						"imagenone",
						"imageleft",
						"imageright",
						"imagecenter",
						"|",
						"insertimage",
						"emotion",
						/*'insertvideo', 'music', 'attachment',*/
						/* 'map',*/ "insertframe",
						"background",
						"|",
						"horizontal",
						"spechars",
						"|",
						"inserttable",
						"deletetable",
						"insertparagraphbeforetable",
						"insertrow",
						"deleterow",
						/*'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', */
						"|",
						/*'print',*/
						"selectall",
						"135editor",
						"searchreplace",
						"fullscreen"
					]
				],
				// 上传文件接口
				serverUrl: "/ac1/conference/uploadBase64",
				UEDITOR_HOME_URL: "./static/UEditor/"
			},
			/* 地图参数 */
			dialogMap: false,
			mapName: "",
			mapPointName: "",
			loading: true,
			mapGetshow: true,
			dialogName: "",
			/* 经纬度 */
			longitude: "",
			latitude: "",
			data: [],
			defaultProps: {
				children: "children",
				label: "name"
			},
			/* 平行会议 */
			arr: [],
			arrt: [],
			/* ==住宿===== */
			room: [],
			/* 就餐 */
			repast: [],
			/* 父栏目 */
			fu_lan: [],
			fu_lans: [],
			/* 父级id */
			couponSelected: "",
			couponSelecteds: "",
			lan_d: false,
			lian_d: false,
			/* 是否公开 */
			out_peoples: "",
			/* 视频 */
			video_all: [],
			video_id: "",
			/* 视频封面 */
			video_cover_url: "",
			/* 直播封面 */
			meet_video_cover_url: "",
			/* 上传文件 */
			file_url: "",
			/* 上传资料 */
			file_ids: [],
			/* 富文本的值 */
			ed_text: "",
			/*编辑模板时id */
			lan_id: "",
			content: "",
			/* 栏目的选择嘉宾 */
			ids: [],
			hotel: {
				name: "",
				list: [
					{
						hotel_type: "",
						price: "",
						quantity: "",
						start_time: "",
						end_time: "",
						explain: ""
					}
				]
			},
			title: "",
			titleTwo: "",
			titleFour: "",
			titleFive: "",
			proLists: "",
			dialogFormVisibleFive: false,
			//会议信息结束
			dialogFormVisibleFour: false,
			dialogFormVisible: false,
			dialogFormVisibleTwo: false,
			dialogFormVisibleThree: false,
			titleThree: "",
			held: {}, //举办地点
			base64: "",
			proList: {},
			logo_url: "",
			cover_url: "",
			vertical_cover_url: "",
			totalData: {},
			/* 沙龙会议封面 */
			salon_cover_url: "",
			listtickets: [], //门票列表数据
			lanM: {},
			organizationTemplate: [],
			theMeetingId: "", //会议id
			icon_id: "", //分享图标id
			lanicon_id: "", //栏目图标
			background: "",
			share_img: "",
			/* token */
			token: "",

			relation_params: {
				relation_field_id: null,
				relation_field_id_options: [],
				relation_field_val_selected: null,
				relation_field_val_options: []
			},

			invoice_type: [],
			invoice_type_arr: [
				{
					label: '增值税普通发票',
					value: 1,
				},
				{
					label: '增值税专用发票',
					value: 2,
				},
				{
					label: '增值税电子普通发票',
					value: 3,
				},
				{
					label: '增值税电子专用发票',
					value: 4,
				},
			]
		};
	},
	components: {
		VueUeditorWrap,
		zhuanti
	},
	created () {
		sessionStorage.setItem( "theMeetingId", "" );
		if (
			this.$route.query.editId != null &&
			this.$route.query.editId != undefined
		)
		{
			this.editId = this.$route.query.editId;
		}
	},
	methods: {
		/* 监听直播列表分页 */
		zbChange ( val ) {
			this.zbpage = val;
			this.zhibolist();
		},
		/* 获取直播列表 */
		zhibolist () {
			var _this = this;
			var url = "/ac1/conference/ImageDetailing/list";
			var params = {
				conference_id: _this.$route.query.editId
					? _this.$route.query.editId
					: sessionStorage.getItem( "theMeetingId" ),
				page: this.zbpage,
				pagesize: this.zbpagesize
			};
			_this.$get( url, params ).then( res => {
				if ( res.code == 1 )
				{
					_this.zbtotle = res.posts.count;
					_this.zbpage = res.posts.page;
					_this.zbpagesize = res.posts.pagesize;
					_this.tableData = res.posts.data;
				}
			} );
		},
		/* 新增直播窗口 */
		startzb () {
			this.newzhibo = true;
			this.zbform = {
				id: "",
				publish_time: "",
				desc: ""
			};
			this.zbform.publish_time = new Date().getTime();
		},
		/* 提交新建直播 */
		submitzb () {
			var _this = this;
			var url = "/ac1/conference/ImageDetailing/add";
			var params = _this.zbform;
			( params.conference_id = this.$route.query.editId
				? this.$route.query.editId
				: sessionStorage.getItem( "theMeetingId" ) ),
				( params.publish_time = params.publish_time / 1000 );
			_this.$post( url, params ).then( res => {
				if ( res.code == 1 )
				{
					this.newzhibo = false;
					this.zhibolist();
					this.$message( {
						message: "成功",
						type: "success",
						duration: 1000
					} );
				} else
				{
					this.$message( {
						message: res.msg,
						type: "warning"
					} );
				}
			} );
		},
		/* 编辑直播 */
		editzb ( id ) {
			var _this = this;
			this.zbform.id = id;
			this.newzhibo = true;
			var url = "/ac1/conference/ImageDetailing/detail";
			var params = {
				id: id
			};
			_this.$get( url, params ).then( res => {
				if ( res.code == 1 )
				{
					this.zbform.id = res.posts.id;
					this.zbform.desc = res.posts.desc;
					this.zbform.publish_time = res.posts.publish_time * 1000;
				}
			} );
		},
		/* 删除直播 */
		deletzb ( id ) {
			var _this = this;
			var url = "/ac1/conference/ImageDetailing/del";
			var params = {
				id: id
			};
			this.$confirm( "是否删除?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			} )
				.then( () => {
					_this.$delet( url, params ).then( res => {
						if ( res.code == 1 )
						{
							this.zhibolist();
							this.$message( {
								message: "删除成功",
								type: "success",
								duration: 1000
							} );
						} else
						{
							this.$message( {
								message: res.msg,
								type: "warning"
							} );
						}
					} );
				} )
				.catch( () => {
					this.$message( {
						type: "info",
						message: "已取消删除"
					} );
				} );
		},

		/* 删除图标 */
		removeicon ( id ) {
			var _this = this;
			var url = "/ac1/conference/icon/del";
			var params = {
				id: id
			};
			this.$confirm( "此操作将永久删除该图标, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			} )
				.then( () => {
					_this.$delet( url, params ).then( res => {
						if ( res.code == 1 )
						{
							this.$message( {
								type: "success",
								message: "删除成功!",
								duration: 1000
							} );
							_this.getIconlist();
							_this.iconchanges();
						} else
						{
							this.$message( {
								type: "warning",
								message: res.msg
							} );
						}
					} );
				} )
				.catch( () => {
					this.$message( {
						type: "info",
						message: "已取消删除"
					} );
				} );
		},
		/* 监听栏目管理父级列表和父级栏目的选择 */
		lian ( val ) {
			if ( val )
			{
				this.lan_d = true;
				this.couponSelecteds = "";
			} else
			{
				this.lan_d = false;
				this.couponSelecteds = "";
			}
		},
		lan ( val ) {
			if ( val )
			{
				this.lian_d = true;
				this.couponSelected = "";
			} else
			{
				this.lian_d = false;
				this.couponSelected = "";
			}
		},
		/* 关闭报名字段弹窗 */
		removea () {
			var _this = this;
			_this.dialogFormVisibleFour = false;
			_this.fujian_file();
			_this.file_top();
			_this.couponSelected = "";
			_this.couponSelecteds = "";
		},
		/* 上传轮播图 */
		getBase64 ( file ) {
			return new Promise( function ( resolve, reject ) {
				const reader = new FileReader();
				let imgResult = "";
				reader.readAsDataURL( file );
				reader.onload = function () {
					imgResult = reader.result;
				};
				reader.onerror = function ( error ) {
					reject( error );
				};
				reader.onloadend = function () {
					resolve( imgResult );
				};
			} );
		},
		getFile ( file, fileList ) {
			var _this = this;
			var objs = {};
			_this.getBase64( file.raw ).then( resu => {
				let url = _this.APIurl.API.api.up_baimg;
				let params = { base64: resu };
				_this.$postform( url, params ).then( res => {
					if ( res.code == 1 )
					{
						_this.$message( {
							message: "上传成功",
							type: "success",
							duration: 1000
						} );
						objs = {
							name: file.name,
							url: res.posts[0].image
						};
						_this.fileLists.push( objs );
					} else
					{
						_this.$message( {
							message: "上传失败",
							type: "error",
							duration: 1000
						} );
					}
				} );
			} );
		},
		/* 删除轮播图 */
		handleRemove_swiper ( file, fileList ) {
			var _this = this;
			for ( let i = 0; i < _this.fileLists.length; i++ )
			{
				if ( _this.fileLists[i].name == file.name )
				{
					_this.fileLists.splice( i, 1 );
				}
			}
		},
		/* 分享页获取栏目图标 */
		getIconlist () {
			var _this = this;
			let url = "/ac1/icon/lsit";
			_this.$get( url ).then( res => {
				if ( res.code == 1 )
				{
					_this.iconlist = res.posts.share_icon;
					_this.iconlists = res.posts.detail_icon;
				}
			} );
		},
		/*分享页图标选择 */
		iconchange () {
			var _this = this;
			layui.use( "form", function () {
				var form = layui.form;
				form.on( "radio(iconids)", function ( data ) {
					_this.icon_id = data.value;
					for ( let i = 0; i < _this.iconlist.length; i++ )
					{
						if ( data.value == _this.iconlist[i].id )
						{
							$( "#columnIcon_img" ).show();
							$( "#columnIcon_img" ).attr(
								"src",
								_this.iconlist[i].img_url
							);
						}
					}
				} );
			} );
		},
		/* 栏目图标 */
		iconchanges () {
			var _this = this;
			layui.use( "form", function () {
				var form = layui.form;
				form.on( "radio(iconidss)", function ( data ) {
					_this.lanicon_id = data.value;
					for ( let i = 0; i < _this.iconlists.length; i++ )
					{
						if ( data.value == _this.iconlists[i].id )
						{
							$( "#columnIcon_imgs" ).show();
							$( "#columnIcon_imgs" ).attr(
								"src",
								_this.iconlists[i].img_url
							);
						}
					}
				} );
			} );
		},
		// 收费，报名，栏目，分享设置
		handlePublics () {
			let _this = this;
			this.$nextTick( () => {
				//注意：导航 依赖 element 模块，否则无法进行功能性操作
				layui.use(
					[
						"jquery",
						"element",
						"form",
						"laydate",
						"upload",
						"layedit",
						"layer",
						"table"
					],
					function () {
						var layer = layui.layer;
						var $ = layui.jquery;
						var element = layui.element;
						var form = layui.form;
						var laydate = layui.laydate;
						var upload = layui.upload;
						var nowTime = new Date().valueOf();
						var table = layui.table;
						var layedit = layui.layedit;
						//无法监听监听下拉框
						form.on( "select(fulan)" ),
							function ( data ) {
								console.log( data );
							};

						/*----------------移动端预览开始-----------------------*/
						$( "#mobilePreview" ).on( "click", function () {
							layer.open( {
								title: "存放二维码",
								content: "存放二维码"
							} );
						} );
						/*----------------移动端预览结束-----------------------*/

						/*-------------- 会议基本信息 省 市 区 三级联动 结束   --------------*/
						/* 栏目时间 */
						laydate.render( {
							elem: "#publish_time",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss"
						} );

						//入住
						var dinnerDateStart = laydate.render( {
							elem: "#diningStarts",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								console.log('dinnerDateStart', value, date, dinnerDateEnd)
								if ( value != "" ){
									date.month = date.month - 1;
									dinnerDateEnd.config.min = date;
								} else {
									dinnerDateEnd.config.min = dinnerDateStart.config.min;
								}
							}
						} );
						var dinnerDateEnd = laydate.render( {
							elem: "#diningEnds",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								console.log('dinnerDateEnd', value, date, dinnerDateStart)
								if ( value != "" ){
									date.month = date.month - 1;
									dinnerDateStart.config.max = date;
								} else {
									dinnerDateStart.config.max = dinnerDateEnd.config.max;
								}
							}
						} );

						//收费设置>新增票种>售卖起止日期
						var sellingstart = laydate.render( {
							elem: "#sellingstart",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" ) {
									date.month = date.month - 1;
									sellingend.config.min = date;
								} else {
									sellingend.config.min = sellingstart.config.min;
								}
							}
						} );

						var sellingend = laydate.render( {
							elem: "#sellingend",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" ){
									date.month = date.month - 1;
									sellingstart.config.max = date;
								} else {
									sellingstart.config.max = sellingend.config.max;
								}
							}
						} );
						//收费设置>新建就餐信息>就餐日期
						var dinnerDateStart = laydate.render( {
							elem: "#diningStart",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" ){
									date.month = date.month - 1;
									dinnerDateEnd.config.min = date;
								} else {
									dinnerDateEnd.config.min = dinnerDateStart.config.min;
								}
							}
						} );
						var dinnerDateEnd = laydate.render( {
							elem: "#diningEnd",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" ){
									date.month = date.month - 1;
									dinnerDateStart.config.max = date;
								} else {
									dinnerDateStart.config.max = dinnerDateEnd.config.max;
								}
							}
						} );

						/*===================--------------======收费设置函数开始-----------------==========================*/
						/* =====================================门票============================================== */
						var sUserAgent = navigator.userAgent.toLowerCase();
						var myIndex;
						var tabLeIns;
						var handlePcTicket = function () {
							/*添加报名费*/
							$( "#handleTicket" ).on( "click", function () {
								_this.titleTwo = "新增票种";
								_this.dialogFormVisibleTwo = true;
								$( "#ticket" )[0].reset();
							} );
						};
						var handleTicket = function () {
							/*添加报名费*/
							$( "#handleTicket" ).on( "click", function () {
								myIndex = layer.open( {
									type: 1,
									title: "创建票种信息",
									area: ["100%", "100vh"], //宽高
									shadeClose: true,
									content: $( "#ticket" ), //调到新增页面
									end: function ( res ) {
										$( "#ticket" ).css( "display", "none" );
										$( ".layui-layer-shade" ).css(
											"display",
											"none"
										);
									},
									success: function ( layero ) {
										$( ".layui-layer-page" ).css(
											"z-index",
											"1000"
										);
										// 清空表单数据
										$( "#ticket" )[0].reset();
									}
								} );
							} );
						};
						if (
							/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
								sUserAgent
							)
						)
						{
							handleTicket();
						} else
						{
							handlePcTicket();
						}
						/* ==========================================就餐========================================= */

						var sUserAgent = navigator.userAgent.toLowerCase();
						var handleDormPcDining;
						var tabLeDingManagement;
						var handlePcDining = function () {
							$( ".handleDining" ).on( "click", function () {
								_this.titleThree = "新建就餐信息";
								_this.dialogFormVisibleThree = true;
								$( "#dining" )[0].reset();
							} );
						};
						var handleMobileDining = function () {
							$( ".handleDining" ).on( "click", function () {
								handleDormPcDining = layer.open( {
									type: 1,
									title: "添加就餐",
									area: ["650px", "600px"], //宽高
									shadeClose: true,
									content: $( "#dining" ), //调到新增页面
									end: function ( res ) {
										$( "#dining" ).css( "display", "none" );
										$( ".layui-layer-shade" ).css(
											"display",
											"none"
										);
									},
									success: function ( index ) {
										$( ".layui-layer-page" ).css(
											"z-index",
											"1000"
										);
										// 清空表单数据
										$( "#dining" )[0].reset();
									}
								} );
							} );
						};
						if (
							/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
								sUserAgent
							)
						)
						{
							handleMobileDining();
						} else
						{
							handlePcDining();
						}
						/* =======================================收费设置函数结束============================================ */
						//頂頂頂頂頂頂頂頂頂　頂頂頂頂頂頂頂頂頂
						//頂頂頂頂頂頂頂　　　　　頂頂
						//　　　頂頂　　　頂頂頂頂頂頂頂頂頂頂頂
						//　　　頂頂　　　頂頂頂頂頂頂頂頂頂頂頂
						//　　　頂頂　　　頂頂　　　　　　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　　　　　頂頂頂
						//　　　頂頂　　　　　　頂頂　頂頂　頂頂
						//　頂頂頂頂　　　頂頂頂頂頂　頂頂頂頂頂
						//　頂頂頂頂　　　頂頂頂頂　　　頂頂頂頂
						/*----------会议基本信息表单提交开始--------------*/

						/* 收费设置表单表格提交设置开始======================================= */
						element.on( "tab(myDemo)", function ( data ) {
							if ( data.index == "1" )
							{
								/* 新增票种和新增就餐的判断开始 */
								if ( _this.$route.query.editId )
								{
									//编辑
									let url = _this.APIurl.API.api.pay_set;
									let params = {
										id: _this.$route.query.editId
									};
									_this
										.$get( url, params )

										.then( res => {
											if ( res.code == "1" ){
												let repast = res.posts.repast;
												let tabaleArr = [];
												for ( let i = 0; i < repast.length; i++ ){
													var tt = {};
													tt = {
														id:
															repast[i]
																.repast_info[
															"id"
															],
														hotel_id: repast[i].id,
														number:
															repast[i]
																.repast_info[
															"number"
															],
														address:
															repast[i]
																.repast_info[
															"address"
															],
														is_muslim:
															repast[i]
																.repast_info[
															"is_muslim"
															],
														price:
															repast[i]
																.repast_info[
															"price"
															],
														explain:
															repast[i]
																.repast_info[
															"explain"
															],
														start_time:
															repast[i]
																.repast_info[
															"start_time"
															],
														end_time:
															repast[i]
																.repast_info[
															"end_time"
															],
														list_order:
															repast[i]
																.repast_info[
															"list_order"
															],
														status:
															repast[i]
																.repast_info[
															"status"
															],
													};
													tabaleArr.push( tt );
												}
												tabLeDingManagement = table.render({
														//就餐表格数据
														elem:
															"#diningManagement",
														data: tabaleArr,
														method: "get",
														where: {
															id:
																_this.$route
																	.query
																	.editId
														},
														cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
														cols: [
															[
																{
																	field: "id",
																	title: "id"
																},
																{
																	field:
																		"address",
																	title:
																		"就餐地点"
																},
																{
																	field:
																		"is_muslim",
																	title:
																		"是否清真",
																	templet: function (
																		d
																	) {
																		if (
																			d.is_muslim ==
																			1
																		)
																		{
																			return "是";
																		} else if (
																			d.is_muslim ==
																			0
																		)
																		{
																			return "否";
																		}
																	}
																},
																{
																	field:
																		"price",
																	title:
																		"价格"
																},
																{
																	field:
																		"number",
																	title:
																		"预定数"
																},
																{
																	field:
																		"start_time",
																	title:
																		"就餐开始时间",
																	width: 140,
																	templet: function (
																		d
																	) {
																		return moment
																			.unix(
																				d.start_time
																			)
																			.format(
																				"YYYY.MM.DD:hh:mm:ss"
																			);
																	}
																},
																{
																	field:
																		"end_time",
																	title:
																		"就餐结束时间",
																	width: 140,
																	templet: function (
																		d
																	) {
																		return moment
																			.unix(
																				d.end_time
																			)
																			.format(
																				"YYYY.MM.DD:hh:mm:ss"
																			);
																	}
																},
																{
																	fixed:
																		"right",
																	title:
																		"操作",
																	toolbar:
																		"#diningManage",
																	width: 140
																}
															]
														],
														page: true
													}
												);
												tabLeIns = table.render( {
													elem: "#applicationFee",
													data: res.posts.ticket,
													response: {
														statusName: "code", //规定数据状态的字段名称，默认：code
														statusCode: 1, //规定成功的状态码，默认：0
														msgName: "hint", //规定状态信息的字段名称，默认：msg
														countName: "total", //规定数据总数的字段名称，默认：count
														dataName: "posts" //规定数据列表的字段名称，默认：data
													},
													where: {
														id:
															_this.$route.query
																.editId
													},
													cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
													cols: [
														[
															// { field: "id", title: "排序" },
															{
																field: "name",
																title:
																	"票种名称"
															},
															{
																field: "price",
																title: "价格"
															},
															// {
															//   field: "deal_start_time",
															//   title: "售卖开始时间",
															//   width: 140,
															//   templet: function (d) {
															//     return moment
															//       .unix(d.deal_start_time)
															//       .format("YYYY-MM-DD HH:mm:ss");
															//   },
															// },
															// {
															//   field: "deal_end_time",
															//   title: "售卖结束时间",
															//   width: 140,
															//   templet: function (d) {
															//     return moment
															//       .unix(d.deal_end_time)
															//       .format("YYYY-MM-DD HH:mm:ss");
															//   },
															// },
															{
																field: "number",
																title: "总数量"
															},
															{
																field:
																	"remaining_num",
																title:
																	"剩余数量",
																templet: function (
																	d
																) {
																	return (
																		d.number -
																		d.sold_num
																	);
																}
															},
															{
																field:
																	"sold_num",
																title:
																	"已购数量"
															},
															{
																fixed: "right",
																title: "操作",
																toolbar:
																	"#barDemo",
																width: 140
															}
														]
													],
													page: true
												} );
											} else
											{
												console.log( res.msg );
											}
										} )
										.catch( error => {
											console.log( error );
										} );
								} else
								{
									let url = _this.APIurl.API.api.pay_set;
									let params = {
										id: sessionStorage.getItem(
											"theMeetingId"
										)
									};
									_this
										.$get( url, params )
										.then( res => {
											if ( res.code == "1" ){
												let repast = res.posts.repast;
												let tabaleArr = [];
												for (
													let i = 0;
													i < repast.length;
													i++
												){
													var tt = {};
													tt = {
														id:
															repast[i]
																.repast_info[
															"id"
															],
														hotel_id: repast[i].id,
														number:
															repast[i]
																.repast_info[
															"number"
															],
														address:
															repast[i]
																.repast_info[
															"address"
															],
														is_muslim:
															repast[i]
																.repast_info[
															"is_muslim"
															],
														price:
															repast[i]
																.repast_info[
															"price"
															],
														explain:
															repast[i]
																.repast_info[
															"explain"
															],
														start_time:
															repast[i]
																.repast_info[
															"start_time"
															],
														end_time:
															repast[i]
																.repast_info[
															"end_time"
															],
														list_order:
															repast[i]
																.repast_info[
															"list_order"
															],
														status:
															repast[i]
																.repast_info[
															"status"
															],
													};
													tabaleArr.push( tt );
												}
												tabLeDingManagement = table.render({
														//就餐表格数据
														elem:
															"#diningManagement",
														data: tabaleArr,
														where: {
															id: sessionStorage.getItem(
																"theMeetingId"
															)
														}, //_this.theMeetingId
														cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
														cols: [
															[
																{
																	field: "id",
																	title: "id"
																},
																{
																	field:
																		"address",
																	title:
																		"就餐地点"
																},
																{
																	field:
																		"is_muslim",
																	title:
																		"是否清真",
																	templet: function (
																		d
																	) {
																		if (
																			d.is_muslim ==
																			1
																		)
																		{
																			return "是";
																		} else if (
																			d.is_muslim ==
																			0
																		)
																		{
																			return "否";
																		}
																	}
																},
																{
																	field:
																		"price",
																	title:
																		"价格"
																},
																{
																	field:
																		"number",
																	title:
																		"预定数"
																},
																{
																	field:
																		"start_time",
																	title:
																		"就餐开始时间",
																	width: 140,
																	templet: function (
																		d
																	) {
																		return moment
																			.unix(
																				d.start_time
																			)
																			.format(
																				"YYYY.MM.DD:hh:mm:ss"
																			);
																	}
																},
																{
																	field:
																		"end_time",
																	title:
																		"就餐结束时间",
																	width: 140,
																	templet: function (
																		d
																	) {
																		return moment
																			.unix(
																				d.end_time
																			)
																			.format(
																				"YYYY.MM.DD:hh:mm:ss"
																			);
																	}
																},
																{
																	fixed:
																		"right",
																	title:
																		"操作",
																	toolbar:
																		"#diningManage",
																	width: 140
																}
															]
														],
														page: true
													}
												);
												table.render( {
													elem: "#applicationFee",
													data: res.posts.ticket,
													response: {
														statusName: "code", //规定数据状态的字段名称，默认：code
														statusCode: 1, //规定成功的状态码，默认：0
														msgName: "hint", //规定状态信息的字段名称，默认：msg
														countName: "total", //规定数据总数的字段名称，默认：count
														dataName: "posts" //规定数据列表的字段名称，默认：data
													},

													where: {
														id: sessionStorage.getItem(
															"theMeetingId"
														)
													}, //_this.theMeetingId

													cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
													cols: [
														[
															// { field: "id", title: "排序" },
															{
																field: "name",
																title:
																	"票种名称"
															},
															{
																field: "price",
																title: "价格"
															},
															// {
															//   field: "deal_start_time",
															//   title: "售卖开始时间",
															//   width: 140,
															//   templet: function (d) {
															//     return moment
															//       .unix(d.deal_start_time)
															//       .format("YYYY-MM-DD HH:mm:ss");
															//   },
															// },
															// {
															//   field: "deal_end_time",
															//   title: "售卖结束时间",
															//   width: 140,
															//   templet: function (d) {
															//     return moment
															//       .unix(d.deal_end_time)
															//       .format("YYYY-MM-DD HH:mm:ss");
															//   },
															// },
															{
																field: "number",
																title: "总数量"
															},
															{
																field:
																	"remaining_num",
																title:
																	"剩余数量"
															},
															{
																field:
																	"purchased_num",
																title:
																	"已购数量"
															},
															{
																fixed: "right",
																title: "操作",
																toolbar:
																	"#barDemo",
																width: 140
															}
														]
													],
													page: true
												} );
											} else
											{
												console.log( res.msg );
											}
										} )
										.catch( error => {
											console.log( error );
										} );
								}
								/* 新增票种和新增就餐的判断结束 */

								/* 报名费管理开始========================================================*/
								var ticketsId;
								table.on( "tool(applicationFees)", function (
									obj
								) {
									var data = obj.data; //获得当前行数据
									var layEvent = obj.event; //获得 lay-event 对应的值（也可以是表头的 event 参数对应的值）
									var tr = obj.tr; //获得当前行 tr 的 DOM 对象（如果有的话）
									if ( layEvent === "edit" ){
										//编辑按钮
										if (
											/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
												sUserAgent
											)
										){
											myIndex = layer.open( {
												type: 1,
												title: "修改票种信息",
												area: ["100%", "100vh"], //宽高
												content: $( "#ticket" ), //调到新增页面
												end: function ( res ) {
													$( "#ticket" ).css(
														"display",
														"none"
													);
													$( ".layui-layer-shade" ).css(
														"display",
														"none"
													);
												},
												success: function ( index ) {
													$( ".layui-layer-page" ).css(
														"z-index",
														"1000"
													);
													//获取门票详情
													let url =
														_this.APIurl.API.api
															.ticket_set;
													let params = {
														id: data.id
													};
													_this
														.$get( url, params )
														.then( res => {
															if (
																parseInt(
																	res.code
																) === 1
															)
															{
																let dataFrm =
																	res.posts;
																// dataFrm.deal_start_time = moment
																//   .unix(dataFrm.deal_start_time)
																//   .format("YYYY-MM-DD HH:mm:ss");
																// dataFrm.deal_end_time = moment
																//   .unix(dataFrm.deal_end_time)
																//   .format("YYYY-MM-DD HH:mm:ss");
																ticketsId =
																	res.posts
																		.id;
																form.val(
																	"dataForm",
																	dataFrm
																); //赋值表单的
															} else
															{
																_this.$message( {
																	message:
																		res.msg,
																	type:
																		"warning",
																	duration: 1000
																} );
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												}
											} );
										} else
										{
											_this.titleTwo = "修改票种信息";
											_this.dialogFormVisibleTwo = true;
											//获取门票详情
											let url =
												_this.APIurl.API.api.ticket_set;
											let params = { id: data.id };
											_this
												.$get( url, params )
												.then( res => {
													if (
														parseInt( res.code ) === 1
													){
														let dataFrm = res.posts;
														// dataFrm.deal_start_time = moment
														//   .unix(dataFrm.deal_start_time)
														//   .format("YYYY-MM-DD HH:mm:ss");
														// dataFrm.deal_end_time = moment
														//   .unix(dataFrm.deal_end_time)
														//   .format("YYYY-MM-DD HH:mm:ss");
														ticketsId =
															res.posts.id;
														form.val(
															"dataForm",
															dataFrm
														); //赋值表单的
													} else{
														_this.$message( {
															message: res.msg,
															type: "warning",
															duration: 1000
														} );
													}
												} )
												.catch( error => {
													console.log( error );
												} );
										}
									} else if ( layEvent === "del" ){
										//删除按钮
										layer.confirm(
											"确定删除此行么",
											function ( index ) {
												//向服务端发送删除指令
												let url =
													_this.APIurl.API.api
														.del_ticket;
												let params = {
													id: data.id
												};
												_this
													.$delet( url, params )
													.then( res => {
														if (
															parseInt(
																res.code
															) === 1
														)
														{
															_this.$message( {
																message:
																	"删除成功",
																type: "success",
																duration: 1000
															} );
															obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
															layer.close( index );
															/*刷新数据表格*/

															if (
																_this.$route
																	.query
																	.editId
															)
															{
																/*刷新数据表格*/
																let url =
																	_this.APIurl
																		.API.api
																		.pay_set;
																let params = {
																	id:
																		_this
																			.$route
																			.query
																			.editId
																};
																_this
																	.$get(
																		url,
																		params
																	)
																	.then(
																		res => {
																			if (
																				res.code ==
																				"1"
																			)
																			{
																				tabLeIns = table.render(
																					{
																						elem:
																							"#applicationFee",
																						data:
																							res
																								.posts
																								.ticket,
																						response: {
																							statusName:
																								"code", //规定数据状态的字段名称，默认：code
																							statusCode: 1, //规定成功的状态码，默认：0
																							msgName:
																								"hint", //规定状态信息的字段名称，默认：msg
																							countName:
																								"total", //规定数据总数的字段名称，默认：count
																							dataName:
																								"posts" //规定数据列表的字段名称，默认：data
																						},

																						where: {
																							id:
																								_this
																									.$route
																									.query
																									.editId
																						},

																						cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																						cols: [
																							[
																								// { field: "id", title: "排序" },
																								{
																									field:
																										"name",
																									title:
																										"票种名称"
																								},
																								{
																									field:
																										"price",
																									title:
																										"价格"
																								},
																								// {
																								//   field: "deal_start_time",
																								//   title: "售卖开始时间",
																								//   width: 140,
																								//   templet: function (d) {
																								//     return moment
																								//       .unix(d.deal_start_time)
																								//       .format("YYYY-MM-DD HH:mm:ss");
																								//   },
																								// },
																								// {
																								//   field: "deal_end_time",
																								//   title: "售卖结束时间",
																								//   width: 140,
																								//   templet: function (d) {
																								//     return moment
																								//       .unix(d.deal_end_time)
																								//       .format("YYYY-MM-DD HH:mm:ss");
																								//   },
																								// },
																								{
																									field:
																										"number",
																									title:
																										"总数量"
																								},
																								{
																									field:
																										"remaining_num",
																									title:
																										"剩余数量"
																								},
																								{
																									field:
																										"purchased_num",
																									title:
																										"已购数量"
																								},
																								{
																									fixed:
																										"right",
																									title:
																										"操作",
																									toolbar:
																										"#barDemo",
																									width: 140
																								}
																							]
																						],
																						page: true
																					}
																				);
																			} else
																			{
																				console.log(
																					res.msg
																				);
																			}
																		}
																	)
																	.catch(
																		error => {
																			console.log(
																				error
																			);
																		}
																	);
															} else
															{
																let url =
																	_this.APIurl
																		.API.api
																		.pay_set;
																let params = {
																	id: sessionStorage.getItem(
																		"theMeetingId"
																	)
																};
																_this
																	.$get(
																		url,
																		params
																	)
																	.then(
																		res => {
																			if (
																				res.code ==
																				"1"
																			)
																			{
																				table.render(
																					{
																						elem:
																							"#applicationFee",
																						data:
																							res
																								.posts
																								.ticket,
																						response: {
																							statusName:
																								"code", //规定数据状态的字段名称，默认：code
																							statusCode: 1, //规定成功的状态码，默认：0
																							msgName:
																								"hint", //规定状态信息的字段名称，默认：msg
																							countName:
																								"total", //规定数据总数的字段名称，默认：count
																							dataName:
																								"posts" //规定数据列表的字段名称，默认：data
																						},

																						where: {
																							id: sessionStorage.getItem(
																								"theMeetingId"
																							)
																						}, //_this.theMeetingId

																						cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																						cols: [
																							[
																								// { field: "id", title: "排序" },
																								{
																									field:
																										"name",
																									title:
																										"票种名称"
																								},
																								{
																									field:
																										"price",
																									title:
																										"价格"
																								},
																								// {
																								//   field: "deal_start_time",
																								//   title: "售卖开始时间",
																								//   width: 140,
																								//   templet: function (d) {
																								//     return moment
																								//       .unix(d.deal_start_time)
																								//       .format("YYYY-MM-DD HH:mm:ss");
																								//   },
																								// },
																								// {
																								//   field: "deal_end_time",
																								//   title: "售卖结束时间",
																								//   width: 140,
																								//   templet: function (d) {
																								//     return moment
																								//       .unix(d.deal_end_time)
																								//       .format("YYYY-MM-DD HH:mm:ss");
																								//   },
																								// },
																								{
																									field:
																										"number",
																									title:
																										"总数量"
																								},
																								{
																									field:
																										"remaining_num",
																									title:
																										"剩余数量"
																								},
																								{
																									field:
																										"purchased_num",
																									title:
																										"已购数量"
																								},
																								{
																									fixed:
																										"right",
																									title:
																										"操作",
																									toolbar:
																										"#barDemo",
																									width: 140
																								}
																							]
																						],
																						page: true
																					}
																				);
																			} else
																			{
																				console.log(
																					res.msg
																				);
																			}
																		}
																	)
																	.catch(
																		error => {
																			console.log(
																				error
																			);
																		}
																	);
															}
															tabLeIns.reload();
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													} )
													.catch( error => {
														console.log( error );
													} );
											}
										);
									}
								} );
								// 保存票种信息
								form.on( "submit(saveTicket)", function ( data ) {
									/*调用保存报名费管理接口*/
									if ( _this.$route.query.editId ){
										//编辑
										let url =
											_this.APIurl.API.api.ticket_save;
										let params = {
											id: ticketsId,
											name: data.field.name,
											price: data.field.price,
											number: data.field.number,
											deal_start_time: "00000000",
											deal_end_time: "00000000",

											limit_number:
												data.field.limit_number,
											desc: data.field.desc,
											is_online_pay:
												data.field.is_online_pay,
											refund_desc: data.field.refund_desc,
											is_write_invoice:
												data.field.is_write_invoice,
											invoice_item:
												data.field.invoice_item,
											conference_id:
												_this.$route.query.editId
										};

										_this
											.$post( url, params )
											.then( res => {
												if ( parseInt( res.code ) === 1 ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													ticketsId = "";
													/*关闭弹出层*/
													_this.dialogFormVisibleTwo = false;

													/*刷新数据表格*/
													let url =
														_this.APIurl.API.api
															.pay_set;
													let params = {
														id:
															_this.$route.query
																.editId
													};

													_this
														.$get( url, params )
														.then( res => {
															if (
																res.code == "1"
															)
															{
																tabLeIns = table.render(
																	{
																		elem:
																			"#applicationFee",
																		data:
																			res
																				.posts
																				.ticket,
																		response: {
																			statusName:
																				"code", //规定数据状态的字段名称，默认：code
																			statusCode: 1, //规定成功的状态码，默认：0
																			msgName:
																				"hint", //规定状态信息的字段名称，默认：msg
																			countName:
																				"total", //规定数据总数的字段名称，默认：count
																			dataName:
																				"posts" //规定数据列表的字段名称，默认：data
																		},

																		where: {
																			id:
																				_this
																					.$route
																					.query
																					.editId
																		},

																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																		cols: [
																			[
																				// { field: "id", title: "排序" },
																				{
																					field:
																						"name",
																					title:
																						"票种名称"
																				},
																				{
																					field:
																						"price",
																					title:
																						"价格"
																				},
																				// {
																				//   field: "deal_start_time",
																				//   title: "售卖开始时间",
																				//   width: 140,
																				//   templet: function (d) {
																				//     return moment
																				//       .unix(d.deal_start_time)
																				//       .format("YYYY-MM-DD HH:mm:ss");
																				//   },
																				// },
																				// {
																				//   field: "deal_end_time",
																				//   title: "售卖结束时间",
																				//   width: 140,
																				//   templet: function (d) {
																				//     return moment
																				//       .unix(d.deal_end_time)
																				//       .format("YYYY-MM-DD HH:mm:ss");
																				//   },
																				// },
																				{
																					field:
																						"number",
																					title:
																						"总数量"
																				},
																				{
																					field:
																						"remaining_num",
																					title:
																						"剩余数量",
																					templet: function (
																						d
																					) {
																						return (
																							d.number -
																							d.sold_num
																						);
																					}
																				},
																				{
																					field:
																						"sold_num",
																					title:
																						"已购数量"
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					toolbar:
																						"#barDemo",
																					width: 140
																				}
																			]
																		],
																		page: true
																	}
																);
															} else
															{
																console.log(
																	res.msg
																);
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												} else{
													_this.$message( {
														message: res.msg,
														type: "warning",
														duration: 1000
													} );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
										return false;
									} else{
										let url =
											_this.APIurl.API.api.ticket_save;
										let params = {
											id: ticketsId,
											name: data.field.name,
											price: data.field.price,
											number: data.field.number,
											deal_start_time: "00000000",
											deal_end_time: "00000000",
											limit_number:
												data.field.limit_number,
											desc: data.field.desc,
											is_online_pay:
												data.field.is_online_pay,
											refund_desc: data.field.refund_desc,
											is_write_invoice:
												data.field.is_write_invoice,
											invoice_item:
												data.field.invoice_item,
											conference_id: sessionStorage.getItem(
												"theMeetingId"
											) //_this.theMeetingId
										};
										_this
											.$post( url, params )
											.then( res => {
												if ( parseInt( res.code ) === 1 ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													ticketsId = "";
													/*关闭弹出层*/
													_this.dialogFormVisibleTwo = false;

													/*刷新数据表格*/
													let url =
														_this.APIurl.API.api
															.pay_set;
													let params = {};
													if (
														_this.$route.query
															.editId
													){
														params = {
															id:
																_this.$route
																	.query
																	.editId
														};
													} else{
														params = {
															id: sessionStorage.getItem(
																"theMeetingId"
															)
														};
													}
													_this
														.$get( url, params )
														.then( res => {
															if (
																res.code == "1"
															)
															{
																table.render( {
																	elem:
																		"#applicationFee",
																	data:
																		res
																			.posts
																			.ticket,
																	response: {
																		statusName:
																			"code", //规定数据状态的字段名称，默认：code
																		statusCode: 1, //规定成功的状态码，默认：0
																		msgName:
																			"hint", //规定状态信息的字段名称，默认：msg
																		countName:
																			"total", //规定数据总数的字段名称，默认：count
																		dataName:
																			"posts" //规定数据列表的字段名称，默认：data
																	},

																	cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																	cols: [
																		[
																			// { field: "id", title: "排序" },
																			{
																				field:
																					"name",
																				title:
																					"票种名称"
																			},
																			{
																				field:
																					"price",
																				title:
																					"价格"
																			},
																			// {
																			//   field: "deal_start_time",
																			//   title: "售卖开始时间",
																			//   width: 140,
																			//   templet: function (d) {
																			//     return moment
																			//       .unix(d.deal_start_time)
																			//       .format("YYYY-MM-DD HH:mm:ss");
																			//   },
																			// },
																			// {
																			//   field: "deal_end_time",
																			//   title: "售卖结束时间",
																			//   width: 140,
																			//   templet: function (d) {
																			//     return moment
																			//       .unix(d.deal_end_time)
																			//       .format("YYYY-MM-DD HH:mm:ss");
																			//   },
																			// },
																			{
																				field:
																					"number",
																				title:
																					"总数量"
																			},
																			{
																				field:
																					"remaining_num",
																				title:
																					"剩余数量",
																				templet: function (
																					d
																				) {
																					return (
																						d.number -
																						d.sold_num
																					);
																				}
																			},
																			{
																				field:
																					"sold_num",
																				title:
																					"已购数量"
																			},
																			{
																				fixed:
																					"right",
																				title:
																					"操作",
																				toolbar:
																					"#barDemo",
																				width: 140
																			}
																		]
																	],
																	page: true
																} );
															} else
															{
																console.log(
																	res.msg
																);
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												} else{
													_this.$message( {
														message: res.msg,
														type: "warning",
														duration: 1000
													} );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
									}
									return false;
								} );
								// 取消保存票种信息
								$( "#cancel" ).on( "click", function () {
									//关闭弹出层
									layer.close( myIndex );
								} );

								/*==================报名费管理结束======================================*/

								/*------------------住宿管理开始--------------==========================*/

								var sUserAgent = navigator.userAgent.toLowerCase();
								var handleDormManagerIndex;
								var tabLeDorm;
								var handleDormManager = function () {
									$( ".handleRoom" ).on( "click", function () {
										_this.title = "新建住宿";
										_this.dialogFormVisible = true;
										$( "#theDormManagerId" )[0].reset();
									} );
								};

								var handleDormManagers = function () {
									$( ".handleRoom" ).on( "click", function () {
										$( "#theDormManagerId" ).appendTo( "body" );
										handleDormManagerIndex = layer.open( {
											type: 1,
											title: "添加房间",
											area: ["100%", "600px"], //宽高
											content: $( "#theDormManagerId" ), //调到新增页面
											end: function ( res ) {
												$( "#theDormManagerId" ).css(
													"display",
													"none"
												);
											},
											success: function ( index ) {
												$(
													"#theDormManagerId"
												)[0].reset();
											}
										} );
									} );
								};
								if (
									/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
										sUserAgent
									)
								)
								{
									handleDormManagers();
								} else
								{
									handleDormManager();
								}
								if ( _this.$route.query.editId )
								{
									//编辑
									let url = _this.APIurl.API.api.pay_set;
									let params = {
										id: _this.$route.query.editId
									};
									_this
										.$get( url, params )
										.then( res => {
											if ( res.code == "1" ){
												let hotel = res.posts.hotel;
												let tabaleArr = [];
												for (
													let i = 0;
													i < hotel.length;
													i++
												){
													var t = {};
													t = {
														id:
															hotel[i].hotel_info[
															"id"
															],
														hotel_id: hotel[i].id,
														h_name:
															hotel[i].hotel_info[
															"h_name"
															],
														hotel_type:
															hotel[i].hotel_info[
															"hotel_type"
															],
														price:
															hotel[i].hotel_info[
															"price"
															],
														is_reserve:
															hotel[i].is_reserve,
														quantity:
															hotel[i].hotel_info[
															"quantity"
															],
														member_num:
															hotel[i].hotel_info[
															"member_num"
															],
														start_time:
															hotel[i].hotel_info[
															"start_time"
															],
														end_time:
															hotel[i].hotel_info[
															"end_time"
															],
														explain:
															hotel[i].hotel_info[
															"explain"
															],
														desc:
															hotel[i].hotel_info[
															"h_desc"
															],
														sold_num:
															hotel[i]
																.sold_quantity,
														list_order:
															hotel[i].hotel_info[
															"list_order"
															],
														status:
															hotel[i].hotel_info[
															"status"
															],
													};
													tabaleArr.push( t );
												}
												tabLeDorm = table.render( {
													elem: "#dormmanager",
													data: tabaleArr,
													response: {
														statusName: "code", //规定数据状态的字段名称，默认：code
														statusCode: 1, //规定成功的状态码，默认：0
														msgName: "hint", //规定状态信息的字段名称，默认：msg
														countName: "total", //规定数据总数的字段名称，默认：count
														dataName: "posts" //规定数据列表的字段名称，默认：data
													},

													where: {
														id:
															_this.$route.query
																.editId
													},

													cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
													cols: [
														[
															{
																field: "id",
																title: "id"
															},
															{
																field: "h_name",
																title:
																	"酒店名称"
															},
															{
																field:
																	"hotel_type",
																title:
																	"酒店房型"
															},
															{
																field: "price",
																title: "价格"
															},
															{
																field:
																	"quantity",
																title: "数量"
															},
															//  { field: "is_reserve", title: "是否预定",templet:function(d){
															//           if(d.is_reserve==0){
															//            return "否"
															//           }else{
															//             return "是"
															//           }
															//  }},
															{
																field:
																	"start_time",
																title:
																	"入住开始时间",
																width: 140,
																templet: function (
																	d
																) {
																	return moment
																		.unix(
																			d.start_time
																		)
																		.format(
																			"YYYY-MM-DD HH:mm:ss"
																		);
																}
															},
															{
																field:
																	"end_time",
																title:
																	"入住结束时间",
																width: 140,
																templet: function (
																	d
																) {
																	return moment
																		.unix(
																			d.end_time
																		)
																		.format(
																			"YYYY-MM-DD HH:mm:ss"
																		);
																}
															},
															{
																field:
																	"explain",
																title: "说明"
															},
															{
																field:
																	"sold_num",
																title:
																	"已售数量"
															},
															{
																fixed: "right",
																title: "操作",
																toolbar:
																	"#barDemos",
																width: 160,
																align: "center"
															}
														]
													],
													page: true,
													done: function (
														res,
														curr,
														count
													) {
														_this.tableRowSpanNoFixedCol(
															"dormmanager",
															"name"
														);
													}
												} );
											} else
											{
												console.log( res.msg );
											}
										} )
										.catch( error => {
											console.log( error );
										} );
								} else
								{
									let url = _this.APIurl.API.api.pay_set;
									let params = {
										id: sessionStorage.getItem(
											"theMeetingId"
										)
									};
									_this
										.$get( url, params )
										.then( res => {
											if ( res.code == "1" ){
												let hotel = res.posts.hotel;
												let tabaleArr = [];
												for (
													let i = 0;
													i < hotel.length;
													i++
												){
													var t = {};
													t = {
														id:
															hotel[i].hotel_info[
															"id"
															],
														hotel_id: hotel[i].id,
														is_reserve:
															hotel[i].is_reserve,
														h_name:
															hotel[i].hotel_info[
															"h_name"
															],
														hotel_type:
															hotel[i].hotel_info[
															"hotel_type"
															],
														price:
															hotel[i].hotel_info[
															"price"
															],
														quantity:
															hotel[i].hotel_info[
															"quantity"
															],
														start_time:
															hotel[i].hotel_info[
															"start_time"
															],
														end_time:
															hotel[i].hotel_info[
															"end_time"
															],
														explain:
															hotel[i].hotel_info[
															"explain"
															],
														sold_num:
															hotel[i]
																.sold_quantity
													};
													tabaleArr.push( t );
												}

												tabLeDorm = table.render( {
													elem: "#dormmanager",
													data: tabaleArr,
													response: {
														statusName: "code", //规定数据状态的字段名称，默认：code
														statusCode: 1, //规定成功的状态码，默认：0
														msgName: "hint", //规定状态信息的字段名称，默认：msg
														countName: "total", //规定数据总数的字段名称，默认：count
														dataName: "posts" //规定数据列表的字段名称，默认：data
													},

													where: {
														id: sessionStorage.getItem(
															"theMeetingId"
														)
													}, //_this.theMeetingId

													cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
													cols: [
														[
															{
																field: "id",
																title: "id"
															},
															{
																field: "h_name",
																title:
																	"酒店名称"
															},
															{
																field:
																	"hotel_type",
																title:
																	"酒店房型"
															},
															{
																field: "price",
																title: "价格"
															},
															{
																field:
																	"quantity",
																title: "数量"
															},
															// { field: "is_reserve", title: "是否预定",templet:function(d){
															//           if(d.is_reserve==0){
															//             return "否"
															//           }else{
															//             return "是"
															//           }
															//  }},
															{
																field:
																	"start_time",
																title:
																	"入住开始时间",
																width: 140,
																templet: function (
																	d
																) {
																	return moment
																		.unix(
																			d.start_time
																		)
																		.format(
																			"YYYY-MM-DD HH:mm:ss"
																		);
																}
															},
															{
																field:
																	"end_time",
																title:
																	"入住结束时间",
																width: 140,
																templet: function (
																	d
																) {
																	return moment
																		.unix(
																			d.end_time
																		)
																		.format(
																			"YYYY-MM-DD HH:mm:ss"
																		);
																}
															},
															{
																field:
																	"explain",
																title: "说明"
															},
															{
																field:
																	"sold_num",
																title:
																	"已售数量"
															},
															{
																fixed: "right",
																title: "操作",
																toolbar:
																	"#barDemos",
																width: 140,
																align: "center"
															}
														]
													],
													page: true,
													done: function (
														res,
														curr,
														count
													) {
														_this.tableRowSpanNoFixedCol(
															"dormmanager",
															"name"
														);
													}
												} );
											} else
											{
												console.log( res.msg );
											}
										} )
										.catch( error => {
											console.log( error );
										} );
								}
								/* 监听新建房型的提交 */
								form.on( "submit(theDormManagerSave)", function ( data ) {
									if ( _this.$route.query.editId ){
										let url =
											_this.APIurl.API.api.hotel_save;
										let obj = {
											id: ticketsId,
											hotel_type: data.field.hotel_type,
											price: data.field.price,
											is_reserve: data.field.is_reserve,
											quantity: data.field.quantity,
											start_time: _this.get_time(
												new Date( data.field.start_time )
											),
											end_time: _this.get_time(
												new Date( data.field.end_time )
											),
											member_num: data.field.member_num,
											explain: data.field.explain,
											desc: data.field.desc,
											status: data.field.status || 0,
										};
										let params = {
											name: data.field.h_name,
											conference_id:
												_this.$route.query.editId,
											list: [obj],
											desc: data.field.desc,
											list_order: data.field.list_order,
										};
										_this
											.$post( url, params )
											.then( res => {
												if ( res.code == "1" ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													ticketsId = "";
													/*关闭弹出层*/
													_this.dialogFormVisible = false;
													/*刷新数据表格*/
													// tabLeDorm.reload()
													let url =
														_this.APIurl.API.api
															.pay_set;
													let params = {
														id:
															_this.$route.query
																.editId
													};
													_this
														.$get( url, params )
														.then( res => {
															if (
																res.code == "1"
															)
															{
																let hotel =
																	res.posts
																		.hotel;
																let tabaleArr = [];
																for (
																	let i = 0;
																	i <
																	hotel.length;
																	i++
																)
																{
																	var t = {};
																	t = {
																		id:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"id"
																			],
																		hotel_id:
																			hotel[
																				i
																			]
																				.id,
																		h_name:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"h_name"
																			],
																		hotel_type:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"hotel_type"
																			],
																		price:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"price"
																			],
																		quantity:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"quantity"
																			],
																		start_time:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"start_time"
																			],
																		end_time:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"end_time"
																			],
																		member_num:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"member_num"
																			],
																		explain:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"explain"
																			],
																		desc:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"h_desc"
																			],
																		sold_num:
																			hotel[
																				i
																			]
																				.sold_quantity,
																		list_order:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"list_order"
																			],
																		status:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"status"
																			],
																	};
																	tabaleArr.push(
																		t
																	);
																}
																tabLeDorm = table.render(
																	{
																		elem:
																			"#dormmanager",
																		data: tabaleArr,
																		response: {
																			statusName:
																				"code", //规定数据状态的字段名称，默认：code
																			statusCode: 1, //规定成功的状态码，默认：0
																			msgName:
																				"hint", //规定状态信息的字段名称，默认：msg
																			countName:
																				"total", //规定数据总数的字段名称，默认：count
																			dataName:
																				"posts" //规定数据列表的字段名称，默认：data
																		},

																		where: {
																			id:
																				_this
																					.$route
																					.query
																					.editId
																		},

																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																		cols: [
																			[
																				{
																					field:
																						"id",
																					title:
																						"id"
																				},
																				{
																					field:
																						"h_name",
																					title:
																						"酒店名称"
																				},
																				{
																					field:
																						"hotel_type",
																					title:
																						"酒店房型"
																				},
																				{
																					field:
																						"price",
																					title:
																						"价格"
																				},
																				{
																					field:
																						"quantity",
																					title:
																						"数量"
																				},
																				//   { field: "is_reserve", title: "是否预定",templet:function(d){
																				//   if(d.is_reserve==0){
																				//     return "否"
																				//   }else{
																				//     return "是"
																				//   }
																				// }},
																				{
																					field:
																						"start_time",
																					title:
																						"入住开始时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.start_time
																							)
																							.format(
																								"YYYY-MM-DD HH:mm:ss"
																							);
																					}
																				},
																				{
																					field:
																						"end_time",
																					title:
																						"入住结束时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.end_time
																							)
																							.format(
																								"YYYY-MM-DD HH:mm:ss"
																							);
																					}
																				},
																				{
																					field:
																						"explain",
																					title:
																						"说明"
																				},
																				{
																					field:
																						"sold_num",
																					title:
																						"已售数量"
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					toolbar:
																						"#barDemos",
																					width: 140,
																					align:
																						"center"
																				}
																			]
																		],
																		page: true
																	}
																);
															} else
															{
																console.log(
																	res.msg
																);
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												} else{
													console.log( res.msg );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
									} else{
										let url =
											_this.APIurl.API.api.hotel_save;
										let objs = {
											id: ticketsId,
											hotel_type: data.field.hotel_type,
											price: data.field.price,
											is_reserve: data.field.is_reserve,
											quantity: data.field.quantity,
											start_time: _this.get_time(
												new Date( data.field.start_time )
											),
											end_time: _this.get_time(
												new Date( data.field.end_time )
											),
											member_num: data.field.member_num,
											explain: data.field.explain,
											desc: data.field.desc
										};
										let params = {
											name: data.field.h_name,
											conference_id: sessionStorage.getItem(
												"theMeetingId"
											),
											list: [objs],
											desc: data.field.desc
										};
										_this
											.$post( url, params )
											.then( res => {
												if ( res.code == "1" ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													ticketsId = "";
													/*关闭弹出层*/
													_this.dialogFormVisible = false;
													/*刷新数据表格*/
													// tabLeDorm.reload()
													let url =
														_this.APIurl.API.api
															.pay_set;
													let params = {};
													if (
														_this.$route.query
															.editId
													){
														params = {
															id:
																_this.$route
																	.query
																	.editId
														};
													} else{
														params = {
															id: sessionStorage.getItem(
																"theMeetingId"
															)
														};
													}
													_this
														.$get( url, params )
														.then( res => {
															if (
																res.code == "1"
															)
															{
																let hotel =
																	res.posts
																		.hotel;
																let tabaleArr = [];
																for (
																	let i = 0;
																	i <
																	hotel.length;
																	i++
																)
																{
																	var t = {};
																	t = {
																		id:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"id"
																			],
																		hotel_id:
																			hotel[
																				i
																			]
																				.id,
																		h_name:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"h_name"
																			],
																		hotel_type:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"hotel_type"
																			],
																		price:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"price"
																			],
																		quantity:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"quantity"
																			],
																		start_time:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"start_time"
																			],
																		end_time:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"end_time"
																			],
																		member_num:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"member_num"
																			],
																		explain:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"explain"
																			],
																		desc:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"h_desc"
																			],
																		sold_num:
																			hotel[
																				i
																			]
																				.sold_quantity,
																		list_order:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"list_order"
																			],
																		status:
																			hotel[
																				i
																			]
																				.hotel_info[
																			"status"
																			],
																	};
																	tabaleArr.push(
																		t
																	);
																}
																tabLeDorm = table.render(
																	{
																		elem:
																			"#dormmanager",
																		data: tabaleArr,
																		response: {
																			statusName:
																				"code", //规定数据状态的字段名称，默认：code
																			statusCode: 1, //规定成功的状态码，默认：0
																			msgName:
																				"hint", //规定状态信息的字段名称，默认：msg
																			countName:
																				"total", //规定数据总数的字段名称，默认：count
																			dataName:
																				"posts" //规定数据列表的字段名称，默认：data
																		},

																		where: {
																			id: sessionStorage.getItem(
																				"theMeetingId"
																			)
																		},

																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																		cols: [
																			[
																				{
																					field:
																						"id",
																					title:
																						"id"
																				},
																				{
																					field:
																						"h_name",
																					title:
																						"酒店名称"
																				},
																				{
																					field:
																						"hotel_type",
																					title:
																						"酒店房型"
																				},
																				{
																					field:
																						"price",
																					title:
																						"价格"
																				},
																				{
																					field:
																						"quantity",
																					title:
																						"数量"
																				},
																				//   { field: "is_reserve", title: "是否预定",templet:function(d){
																				//   if(d.is_reserve==0){
																				//     return "否"
																				//   }else{
																				//     return "是"
																				//   }
																				// }},
																				{
																					field:
																						"start_time",
																					title:
																						"入住开始时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.start_time
																							)
																							.format(
																								"YYYY-MM-DD HH:mm:ss"
																							);
																					}
																				},
																				{
																					field:
																						"end_time",
																					title:
																						"入住结束时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.end_time
																							)
																							.format(
																								"YYYY-MM-DD HH:mm:ss"
																							);
																					}
																				},
																				{
																					field:
																						"explain",
																					title:
																						"说明"
																				},
																				{
																					field:
																						"sold_num",
																					title:
																						"已售数量"
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					toolbar:
																						"#barDemos",
																					width: 140,
																					align:
																						"center"
																				}
																			]
																		],
																		page: true
																	}
																);
															} else
															{
																console.log(
																	res.msg
																);
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												} else{
													console.log( res.msg );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
									}
								} );
								/*------------------酒店编辑开始--------------*/
								table.on( "tool(dormmanagers)", function ( obj ) {
									//注：edit是固定事件名，test是table原始容器的属性 lay-filter="对应的值"
									var data = obj.data; //获得当前行数据
									var layEvent = obj.event; //获得 lay-event 对应的值（也可以是表头的 event 参数对应的值）
									var tr = obj.tr; //获得当前行 tr 的 DOM 对象（如果有的话）

									if ( layEvent === "edit" ){
										if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)){
											handleDormPcDining = layer.open( {
												type: 1,
												title: "酒店编辑",
												area: ["100%", "600px"], //宽高
												shadeClose: true,
												content: $( "#theDormManagerId" ), //调到新增页面
												end: function ( res ) {
													$( "#theDormManagerId" ).css(
														"display",
														"none"
													);
													$( ".layui-layer-shade" ).css(
														"display",
														"none"
													);
												},
												success: function ( index ) {
													$( ".layui-layer-page" ).css(
														"z-index",
														"1000"
													);
													data.start_time = moment
														.unix( data.start_time )
														.format(
															"YYYY-MM-DD HH:mm:ss"
														);
													data.end_time = moment
														.unix( data.end_time )
														.format(
															"YYYY-MM-DD HH:mm:ss"
														);
													/* 此处待优化 */
													setTimeout( function () {
														form.val(
															"dataApplicationFields",
															data
														); //赋值表单的
													}, 20 );
													ticketsId = data.id;
												}
											} );
										} else {
											_this.title = "编辑住宿";
											_this.dialogFormVisible = true;
											data.start_time = moment.unix( data.start_time ).format( "YYYY-MM-DD HH:mm:ss" );
											data.end_time = moment.unix( data.end_time ).format( "YYYY-MM-DD HH:mm:ss" );
											/* 此处待优化 */
											setTimeout( function () {
												form.val("dataApplicationFields", data); //赋值表单的
											}, 20 );
											ticketsId = data.id;
										}
									} else if ( layEvent === "del" ){
										layer.confirm(
											"确定删除此行么",
											function ( index ) {
												//向服务端发送删除指令
												let url =
													_this.APIurl.API.api
														.del_hotel;
												let params = {
													id: data.hotel_id
												};
												_this
													.$delet( url, params )
													.then( res => {
														if (
															parseInt(
																res.code
															) === 1
														)
														{
															_this.$message( {
																message:
																	"删除成功",
																type: "success",
																duration: 1000
															} );
															obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
															layer.close( index );
															/* 删除完刷新页面 */
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													} )
													.catch( error => {
														console.log( error );
													} );
											}
										);
									}
								} );
								/*------------------住宿管理结束---------------*/
								/*------------------住宿管理结束---------------=========================*/

								/*=====================就餐编辑开始====================================*/
								table.on( "tool(diningManagement)", function (
									obj
								) {
									var data = obj.data; //获得当前行数据

									var layEvent = obj.event; //获得 lay-event 对应的值（也可以是表头的 event 参数对应的值）
									var tr = obj.tr; //获得当前行 tr 的 DOM 对象（如果有的话）
									if ( layEvent === "edit" ){
										if (
											/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
												sUserAgent
											)
										){
											handleDormPcDining = layer.open( {
												type: 1,
												title: "编辑就餐",
												area: ["100%", "600px"], //宽高
												content: $( "#dining" ), //调到新增页面
												end: function ( res ) {
													$( "#dining" ).css(
														"display",
														"none"
													);
													$( ".layui-layer-shade" ).css(
														"display",
														"none"
													);
												},
												success: function ( index ) {
													$( ".layui-layer-page" ).css(
														"z-index",
														"1000"
													);

													setTimeout( function () {
														form.val(
															"diningManagementDataForm",
															data
														); //赋值表单的
													}, 20 );
													ticketsId = data.id;
												}
											} );
										} else
										{
											_this.titleThree = "编辑就餐";
											_this.dialogFormVisibleThree = true;
											data.start_time = moment
												.unix( data.start_time )
												.format( "YYYY-MM-DD HH:mm:ss" );
											data.end_time = moment
												.unix( data.end_time )
												.format( "YYYY-MM-DD HH:mm:ss" );
											setTimeout( function () {
												form.val(
													"diningManagementDataForm",
													data
												); //赋值表单的
											}, 20 );
											ticketsId = data.id;
										}
									} else if ( layEvent === "del" ){
										layer.confirm(
											"确定要删除行吗?",
											function ( index ) {
												/*请求删除就餐信息 */
												let url =
													_this.APIurl.API.api
														.del_eat;
												let paramss = {
													id: data.hotel_id
												};
												_this
													.$delet( url, paramss )
													.then( res => {
														if (
															parseInt(
																res.code
															) === 1
														)
														{
															_this.$message( {
																message:
																	"删除成功",
																type: "success",
																duration: 1000
															} );
															obj.del();
															layer.close( index );
														} else
														{
														}
													} )
													.catch( error => {
														console.log( error );
													} );
											}
										);
									}
								} );
								form.on( "submit(diningManagementAndPreservation)", function ( data ) {
									if ( _this.$route.query.editId ){
										let url =
											_this.APIurl.API.api.eat_save;
										let obj = {
											id: ticketsId,
											address: data.field.address,
											price: data.field.price,
											explain: data.field.explain,
											start_time: _this.get_time(
												new Date(
													data.field.start_time
												)
											),
											end_time: _this.get_time(
												new Date(
													data.field.end_time
												)
											),
											is_muslim: data.field.is_muslim,
											number: data.field.number,
											list_order: data.field.list_order,
											status: data.field.status || 0,
										};
										let params = {
											conference_id:
												_this.$route.query.editId,
											repast: [obj]
										};
										_this
											.$post( url, params )
											.then( res => {
												if ( res.code === 1 ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													ticketsId = "";
													/*关闭弹出层*/
													_this.dialogFormVisibleThree = false;
													/* 刷新表格 */
													let url =
														_this.APIurl.API.api
															.pay_set;
													let params = {
														id:
															_this.$route
																.query
																.editId
													};
													_this
														.$get( url, params )
														.then( res => {
															if (
																res.code ==
																"1"
															)
															{
																let repast =
																	res
																		.posts
																		.repast;
																let tabaleArrs = [];
																for (
																	let i = 0;
																	i <
																	repast.length;
																	i++
																)
																{
																	var tt = {};
																	tt = {
																		id:
																			repast[
																				i
																			]
																				.repast_info[
																			"id"
																			],
																		hotel_id:
																			repast[
																				i
																			]
																				.id,
																		number:
																			repast[
																				i
																			]
																				.repast_info[
																			"number"
																			],
																		address:
																			repast[
																				i
																			]
																				.repast_info[
																			"address"
																			],
																		is_muslim:
																			repast[
																				i
																			]
																				.repast_info[
																			"is_muslim"
																			],
																		price:
																			repast[
																				i
																			]
																				.repast_info[
																			"price"
																			],
																		explain:
																			repast[
																				i
																			]
																				.repast_info[
																			"explain"
																			],
																		start_time:
																			repast[
																				i
																			]
																				.repast_info[
																			"start_time"
																			],
																		end_time:
																			repast[
																				i
																			]
																				.repast_info[
																			"end_time"
																			],
																		list_order:
																			repast[
																				i
																			]
																				.repast_info[
																			"list_order"
																			],
																		status:
																			repast[
																				i
																			]
																				.repast_info[
																			"status"
																			],
																	};
																	tabaleArrs.push(
																		tt
																	);
																}

																tabLeDingManagement = table.render(
																	{
																		//就餐表格数据
																		elem:
																			"#diningManagement",
																		data: tabaleArrs,
																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增

																		where: {
																			id:
																				_this
																					.$route
																					.query
																					.editId
																		},

																		cols: [
																			[
																				{
																					field:
																						"id",
																					title:
																						"id"
																				},
																				{
																					field:
																						"address",
																					title:
																						"就餐地点"
																				},
																				{
																					field:
																						"is_muslim",
																					title:
																						"是否清真",
																					templet: function (
																						d
																					) {
																						if (
																							d.is_muslim ==
																							1
																						)
																						{
																							return "是";
																						} else if (
																							d.is_muslim ==
																							0
																						)
																						{
																							return "否";
																						}
																					}
																				},
																				{
																					field:
																						"price",
																					title:
																						"价格"
																				},
																				{
																					field:
																						"number",
																					title:
																						"预定数"
																				},
																				{
																					field:
																						"start_time",
																					title:
																						"就餐开始时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.start_time
																							)
																							.format(
																								"YYYY.MM.DD:hh:mm:ss"
																							);
																					}
																				},
																				{
																					field:
																						"end_time",
																					title:
																						"就餐结束时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.end_time
																							)
																							.format(
																								"YYYY.MM.DD:hh:mm:ss"
																							);
																					}
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					toolbar:
																						"#diningManage",
																					width: 140
																				}
																			]
																		],
																		page: true
																	}
																);
															} else
															{
																console.log(
																	res.msg
																);
															}
														} )
														.catch( error => {
															console.log(
																error
															);
														} );
												} else{
													console.log( res.msg );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
									} else{
										let url =
											_this.APIurl.API.api.eat_save;
										let obj = {
											id: ticketsId,
											address: data.field.address,
											price: data.field.price,
											start_time: _this.get_time(
												new Date(
													data.field.start_time
												)
											),
											end_time: _this.get_time(
												new Date(
													data.field.end_time
												)
											),
											is_muslim: data.field.is_muslim,
											number: data.field.number,
											list_order: data.field.list_order,
											status: data.field.status,
										};
										let params = {
											repast: [obj],
											conference_id: sessionStorage.getItem(
												"theMeetingId"
											)
										};
										_this
											.$post( url, params )
											.then( res => {
												if ( res.code === 1 ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													ticketsId = "";
													_this.dialogFormVisibleThree = false;
													let url =
														_this.APIurl.API.api
															.pay_set;
													let params = {
														id: sessionStorage.getItem(
															"theMeetingId"
														)
													};
													_this
														.$get( url, params )
														.then( res => {
															if (
																res.code ==
																"1"
															)
															{
																let repast =
																	res
																		.posts
																		.repast;
																let tabaleArrs = [];
																for (
																	let i = 0;
																	i <
																	repast.length;
																	i++
																)
																{
																	var tt = {};
																	tt = {
																		id:
																			repast[
																				i
																			]
																				.repast_info[
																			"id"
																			],
																		hotel_id:
																			repast[
																				i
																			]
																				.id,
																		number:
																			repast[
																				i
																			]
																				.repast_info[
																			"number"
																			],
																		address:
																			repast[
																				i
																			]
																				.repast_info[
																			"address"
																			],
																		is_muslim:
																			repast[
																				i
																			]
																				.repast_info[
																			"is_muslim"
																			],
																		price:
																			repast[
																				i
																			]
																				.repast_info[
																			"price"
																			],
																		explain:
																			repast[
																				i
																			]
																				.repast_info[
																			"explain"
																			],
																		start_time:
																			repast[
																				i
																			]
																				.repast_info[
																			"start_time"
																			],
																		end_time:
																			repast[
																				i
																			]
																				.repast_info[
																			"end_time"
																			],
																		list_order:
																			repast[
																				i
																			]
																				.repast_info[
																			"list_order"
																			],
																		status:
																			repast[
																				i
																			]
																				.repast_info[
																			"status"
																			],
																	};
																	tabaleArrs.push(
																		tt
																	);
																}
																table.render(
																	{
																		//就餐表格数据
																		elem:
																			"#diningManagement",
																		data: tabaleArrs,

																		where: {
																			id: sessionStorage.getItem(
																				"theMeetingId"
																			)
																		},

																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																		cols: [
																			[
																				{
																					field:
																						"id",
																					title:
																						"id"
																				},
																				{
																					field:
																						"address",
																					title:
																						"就餐地点"
																				},
																				{
																					field:
																						"is_muslim",
																					title:
																						"是否清真",
																					templet: function (
																						d
																					) {
																						if (
																							d.is_muslim ==
																							1
																						)
																						{
																							return "是";
																						} else if (
																							d.is_muslim ==
																							0
																						)
																						{
																							return "否";
																						}
																					}
																				},
																				{
																					field:
																						"price",
																					title:
																						"价格"
																				},
																				{
																					field:
																						"number",
																					title:
																						"预定数"
																				},
																				{
																					field:
																						"start_time",
																					title:
																						"就餐开始时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.start_time
																							)
																							.format(
																								"YYYY.MM.DD:hh:mm:ss"
																							);
																					}
																				},
																				{
																					field:
																						"end_time",
																					title:
																						"就餐结束时间",
																					width: 140,
																					templet: function (
																						d
																					) {
																						return moment
																							.unix(
																								d.end_time
																							)
																							.format(
																								"YYYY.MM.DD:hh:mm:ss"
																							);
																					}
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					toolbar:
																						"#diningManage",
																					width: 140
																				}
																			]
																		],
																		page: true
																	}
																);
															} else
															{
																console.log(
																	res.msg
																);
															}
														} )
														.catch( error => {
															console.log(
																error
															);
														} );
												} else{
													console.log( res.msg );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
									}
								}
								);
								/*==========--------------就餐编辑结束-----------------===============*/
								/* 收费设置表单表格提交设置结束======================================= */
							} else if ( data.index == "2" )
							{
								var signUpId;
								/*--------------报名弹窗开始--------------------*/
								var sUserAgent = navigator.userAgent.toLowerCase();
								var handlefField;
								var handleFieldTable;
								//监听下拉框
								form.on( "select(business)", function ( data ) {
									if ( data.value == "0" ){
										$( "#datacheckegularity" ).val(
											"/^[0-9.-]+$/"
										);
									} else if ( data.value == "1" ){
										$( "#datacheckegularity" ).val(
											"/^[0-9-]+$/"
										);
									} else if ( data.value == "2" ){
										$( "#datacheckegularity" ).val(
											"/^[a-z]+$/i"
										);
									} else if ( data.value == "3" ){
										$( "#datacheckegularity" ).val(
											"/^[0-9a-z]+$/i"
										);
									} else if ( data.value == "4" ){
										$( "#datacheckegularity" ).val(
											"/^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+.[a-zA-Z]{2,3}$/"
										);
									} else if ( data.value == "5" ){
										$( "#datacheckegularity" ).val(
											"/^[0-9]{5,20}$/"
										);
									} else if ( data.value == "6" ){
										$( "#datacheckegularity" ).val(
											"/^http:\\/\\//"
										);
									} else if ( data.value == "7" ){
										$( "#datacheckegularity" ).val(
											"/^(1)[0-9]{10}$/"
										);
									} else if ( data.value == "8" ){
										$( "#datacheckegularity" ).val(
											"/^[0-9-]{6,13}$/"
										);
									} else if ( data.value == "9" ){
										$( "#datacheckegularity" ).val(
											"/^[0-9]{6}$/"
										);
									} else{
										$( "#datacheckegularity" ).val( "" );
									}
								} );
								/*切换文本类型的*/
								/* 改 */
								form.on( "select(fieldType)", function ( data ) {
									if ( data.value == "1" ){
										$( "#singletext" ).css(
											"display",
											"block"
										);
										$( "#textField" ).css( "display", "block" );
										$( "#mima" ).css( "display", "block" );
										$( "#thedateof" ).css( "display", "none" );
										$( "#comprehensive" ).css(
											"display",
											"none"
										);
										$( "#onehundredpercent" ).val( "100%" );
										$( "#comprehensive" ).hide();
										$( "#zze" ).show();
										$( "#text_length" ).show();
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "2" ){
										$( "#textField" ).css( "display", "block" );
										$( "#singletext" ).css(
											"display",
											"block"
										);
										$( "#thedateof" ).css( "display", "none" );
										$( "#comprehensive" ).css(
											"display",
											"none"
										);
										$( "#comprehensive" ).hide();
										$( "#zze" ).show();
										$( "#text_length" ).show();
										$( "#mima" ).css( "display", "none" );
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "3" ){
										$( "#comprehensive" ).css(
											"display",
											"block"
										);
										$( "#singletext" ).css( "display", "none" );
										$( "#textField" ).css( "display", "none" );
										$( "#thedateof" ).css( "display", "none" );
										$( "#comprehensive" ).show();
										$( "#zze" ).hide();
										$( "#text_length" ).hide();
										$( "#mima" ).css( "display", "none" );
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "4" ){
										$( "#comprehensive" ).css(
											"display",
											"block"
										);
										$( "#singletext" ).css( "display", "none" );
										$( "#textField" ).css( "display", "none" );
										$( "#thedateof" ).css( "display", "none" );
										$( "#comprehensive" ).show();
										$( "#zze" ).hide();
										$( "#text_length" ).hide();
										$( "#mima" ).css( "display", "none" );
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "5" ){
										$( "#comprehensive" ).css(
											"display",
											"block"
										);
										$( "#singletext" ).css( "display", "none" );
										$( "#textField" ).css( "display", "none" );
										$( "#thedateof" ).css( "display", "none" );
										$( "#comprehensive" ).show();
										$( "#zze" ).hide();
										$( "#text_length" ).hide();
										$( "#mima" ).css( "display", "none" );
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "6" ){
										$( "#thedateof" ).css( "display", "block" );
										$( "#singletext" ).css( "display", "none" );
										$( "#textField" ).css( "display", "none" );

										$( "#comprehensive" ).css(
											"display",
											"none"
										);
										$( "#comprehensive" ).hide();
										$( "#zze" ).hide();
										$( "#text_length" ).hide();
										$( "#mima" ).css( "display", "none" );
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "7" ){
										$( "#comprehensive" ).css(
											"display",
											"block"
										);
										$( "#singletext" ).css( "display", "none" );
										$( "#textField" ).css( "display", "none" );
										$( "#thedateof" ).css( "display", "none" );
										$( "#comprehensive" ).show();
										$( "#zze" ).hide();
										$( "#text_length" ).show();
										$( "#mima" ).css( "display", "none" );
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).show();
										$( "#four_zd" ).show();
										$( "#five_zd" ).show();
										$( "#six_zd" ).show();
										$( "#seven_zd" ).show();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).show();
									} else if ( data.value == "8" ){
										$( "#comprehensive" ).hide();
										$( "#singletext" ).hide();
										$( "#textField" ).hide();
										$( "#thedateof" ).hide();
										$( "#comprehensive" ).hide();
										$( "#zze" ).hide();
										$( "#text_length" ).hide();
										$( "#mima" ).hide();
										$( "#one_zd" ).show();
										$( "#two_zd" ).show();
										$( "#three_zd" ).hide();
										$( "#four_zd" ).hide();
										$( "#five_zd" ).hide();
										$( "#six_zd" ).hide();
										$( "#seven_zd" ).hide();
										$( "#eight_zd" ).show();
										$( "#nine_zd" ).hide();
									}
								} );
								form.on( "select(relation_field_id)", function ( {
									value
								} ) {
									_this.relation_params.relation_field_val_options = _this.relation_params.relation_field_id_options.find(
										i => i.id == value
									).setting.options;
								} );
								laydate.render( {
									elem: "#moren"
								} );
								var handlePcfield = function () {
									$( "#customRegistration" ).on(
										"click",
										function () {
											$( "#formtype" ).removeAttr(
												"disabled"
											);
											$( "#name_text " ).removeAttr(
												"disabled"
											);
											_this.titleFour = "自定义";
											_this.dialogFormVisibleFour = true;

											setTimeout( () => {
												$( "#signupfield" )[0].reset();
												$( "#comprehensive" ).hide();
												$( "#name_text " ).css(
													"color",
													"black"
												);
												signUpId = "";

												// 设置选线列表
												_this
													.$get( url, params )
													.then( res => {
														if ( res.code == 1 )
														{
															_this.relation_params.relation_field_id_options =
																res.posts;
														}
													} );
											}, 0 );
										}
									);
								};
								var handleMobile = function () {
									$( "#customRegistration" ).on(
										"click",
										function () {
											handlefField = layer.open( {
												type: 1,
												title: "新增模型",
												area: ["100%", "100vh"], //宽高
												content: $( "#signupfield" ), //调到新增页面
												end: function ( res ) {
													$( "#signupfield" ).css(
														"display",
														"none"
													);
													$( ".layui-layer-shade" ).css(
														"display",
														"none"
													);
												},
												success: function ( index ) {
													$( ".layui-layer-page" ).css(
														"z-index",
														"1000"
													);
													// 清空表单数据
													// $('#signupfield')[0].reset();
												}
											} );
										}
									);
								};
								if (
									/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
										sUserAgent
									)
								)
								{
									handleMobile();
								} else
								{
									handlePcfield();
								}
								//取消操作
								$( "#handleApplicationField" ).on(
									"click",
									function () {
										layer.close( handlefField ); //关闭弹出层
										$( "#formtype" ).removeAttr( "disabled" );
										$( "#name_text " ).removeAttr( "disabled" );
										$( "#name_text " ).css( "color", "black" );
										signUpId = "";
									}
								);
								/*--------------报名弹窗结束--------------------*/
								/*--------------报名设置开始-------------------*/
								// 1.调取报名字段详情接口
								if ( _this.$route.query.editId )
								{
									var url = _this.APIurl.API.api.registration;
									var params = {
										id: _this.$route.query.editId
									};
									_this.$get( url, params ).then( res => {
										if ( res.code == 1 ){
											handleFieldTable = table.render( {
												elem: "#applicationField",
												data: res.posts,
												cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
												page: {
													limit: 10
												},
												cols: [
													[
														{
															field: "list_order",
															title: "排序"
														},
														{
															field: "field",
															title: "报名字段"
														},
														{
															field: "form_type",
															title: "表单类型",
															templet: function (
																d
															) {
																if (
																	d.form_type ==
																	"1"
																)
																{
																	return "文本";
																} else if (
																	d.form_type ==
																	"2"
																)
																{
																	return "多行文本";
																} else if (
																	d.form_type ==
																	"3"
																)
																{
																	return "单选";
																} else if (
																	d.form_type ==
																	"4"
																)
																{
																	return "复选";
																} else if (
																	d.form_type ==
																	"5"
																)
																{
																	return "下拉";
																} else if (
																	d.form_type ==
																	"6"
																)
																{
																	return "时间";
																} else if (
																	d.form_type ==
																	"7"
																)
																{
																	return "搜索下拉";
																} else if (
																	d.form_type ==
																	"8"
																)
																{
																	return "分组标识";
																}
															}
														},
														{
															field:
																"is_required",
															width: 140,
															title: "是否必填",
															templet: function (
																d
															) {
																return d.is_required ==
																	"1"
																	? "是"
																	: "否";
															}
														},
														{
															field:
																"is_pishu_group",
															width: 140,
															title: "皮书匹配",
															templet: function (
																d
															) {
																return d.is_pishu_group ==
																	"1"
																	? "是"
																	: "否";
															}
														},
														{
															fixed: "right",
															title: "操作",
															templet: function (
																d
															) {
																if (
																	d.field !==
																	"姓名" &&
																	d.field !==
																	"手机号"
																)
																{
																	return ` <a
                              class="layui-btn layui-btn-xs"
                              lay-event="applicationFieldsedit"
                              style="color: #FFFFFF;"
                             >编辑</a>
                            <a
                              class="layui-btn layui-btn-danger layui-btn-xs"
                              lay-event="applicationFieldsdel"
                              style="color: #FFFFFF;"
                            >删除</a>  `;
																} else
																{
																	return ``;
																}
															},
															width: 160
														}
													]
												],
												done: function (
													res,
													curr,
													count
												) {
													res.data.forEach( function (
														item,
														index
													) {
														if (
															item.form_type ==
															"8"
														)
															$(
																'div[lay-id="applicationField"]'
															)
																.find(
																	'tr[data-index="' +
																	index +
																	'"]'
																)
																.find(
																	'td[data-field="field"]'
																)
																.html(
																	`<span style="padding: 0px 15px;color: #1E9FFF;">${ item.field }<i class="layui-icon layui-icon-flag" style="margin-left:5px;color: #1E9FFF;"></i></span>`
																);
														else
															$(
																'div[lay-id="applicationField"]'
															)
																.find(
																	'tr[data-index="' +
																	index +
																	'"]'
																)
																.find(
																	'td[data-field="field"]'
																)
																.css(
																	"background-color",
																	"white"
																);
													} );
												}
											} );
										}
									} );
								} else
								{
									var url = _this.APIurl.API.api.registration;
									var params = {
										id: sessionStorage.getItem(
											"theMeetingId"
										)
									};
									_this.$get( url, params ).then( res => {
										if ( res.code == 1 ){
											handleFieldTable = table.render( {
												elem: "#applicationField",
												data: res.posts,
												cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
												page: {
													limit: 10
												},
												cols: [
													[
														{
															field: "list_order",
															title: "排序"
														},
														{
															field: "field",
															title: "报名字段"
														},
														{
															field: "form_type",
															title: "表单类型",
															templet: function (
																d
															) {
																if (
																	d.form_type ==
																	"1"
																)
																{
																	return "文本";
																} else if (
																	d.form_type ==
																	"2"
																)
																{
																	return "多行文本";
																} else if (
																	d.form_type ==
																	"3"
																)
																{
																	return "单选";
																} else if (
																	d.form_type ==
																	"4"
																)
																{
																	return "复选";
																} else if (
																	d.form_type ==
																	"5"
																)
																{
																	return "下拉";
																} else if (
																	d.form_type ==
																	"6"
																)
																{
																	return "时间";
																} else if (
																	d.form_type ==
																	"7"
																)
																{
																	return "搜索下拉";
																} else if (
																	d.form_type ==
																	"8"
																)
																{
																	return "分组标识";
																}
															}
														},
														{
															field:
																"is_required",
															width: 140,
															title: "是否必填",
															templet: function ( d ) {
																return d.is_required == "1" ? "是" : "否";
															}
														},
														{
															field:
																"is_pishu_group",
															width: 140,
															title: "皮书匹配",
															templet: function (
																d
															) {
																return d.is_pishu_group ==
																	"1"
																	? "是"
																	: "否";
															}
														},
														{
															fixed: "right",
															title: "操作",
															templet: function (
																d
															) {
																if (
																	d.field !==
																	"姓名" &&
																	d.field !==
																	"手机号"
																)
																{
																	return ` <a
                              class="layui-btn layui-btn-xs"
                              lay-event="applicationFieldsedit"
                              style="color: #FFFFFF;"
                             >编辑</a>
                            <a
                              class="layui-btn layui-btn-danger layui-btn-xs"
                              lay-event="applicationFieldsdel"
                              style="color: #FFFFFF;"
                            >删除</a>  `;
																} else
																{
																	return ``;
																}
															},
															width: 160
														}
													]
												],
												done: function (
													res,
													curr,
													count
												) {
													res.data.forEach( function (
														item,
														index
													) {
														if (
															item.form_type ==
															"8"
														)
															$(
																'div[lay-id="applicationField"]'
															)
																.find(
																	'tr[data-index="' +
																	index +
																	'"]'
																)
																.find(
																	'td[data-field="field"]'
																)
																.html(
																	`<span style="padding: 0px 15px;color: #1E9FFF;">${ item.field }<i class="layui-icon layui-icon-flag" style="margin-left:5px;color: #1E9FFF;"></i></span>`
																);
														else
															$(
																'div[lay-id="applicationField"]'
															)
																.find(
																	'tr[data-index="' +
																	index +
																	'"]'
																)
																.find(
																	'td[data-field="field"]'
																)
																.css(
																	"background-color",
																	"white"
																);
													} );
												}
											} );
										}
									} );
								}
								//监听提交
								form.on( "submit(formDemo)", function ( data ) {
									var url =
										_this.APIurl.API.api.registration_save;
									var params;
									if ( _this.$route.query.editId ){
										console.log(
											"value: ",
											$( "#formtype option:selected" ).val()
										);
										console.log( "data.field", data.field );
										//编辑
										if (
											$(
												"#formtype option:selected"
											).val() == "1"
										){
											//单行
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][relation_status]": !!data
													.field["relation_status"]
													? 1
													: 0,
												"data[0][relation_field_id]":
													data.field[
													"relation_field_id"
													],
												"data[0][relation_field_val]":
													data.field[
													"relation_field_val"
													],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["setting_width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field[
													"setting_height"
													],

												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "2"
										){
											//多行
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["setting_width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field[
													"setting_height"
													],

												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "3"
										){
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][relation_status]": !!data
													.field["relation_status"]
													? 1
													: 0,
												"data[0][relation_field_id]":
													data.field[
													"relation_field_id"
													],
												"data[0][relation_field_val]":
													data.field[
													"relation_field_val"
													],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "4"
										){
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "5"
										){
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "6"
										){
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "7"
										){
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][relation_status]": !!data
													.field["relation_status"]
													? 1
													: 0,
												"data[0][relation_field_id]":
													data.field[
													"relation_field_id"
													],
												"data[0][relation_field_val]":
													data.field[
													"relation_field_val"
													],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "8"
										){
											params = {
												"data[0][remake]": data.field['remake'],
												"data[0][id]": signUpId,
												"data[0][field]":
													data.field["field"],
												"data[0][conference_id]":
													_this.$route.query.editId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][is_pishu_group]":
													data.field["is_pishu_group"],
												"data[0][max_select_num]":
													data.field["max_select_num"]
											};
										}
										if (
											data.field["minlength"] >
											data.field["maxlength"] ||
											data.field["minlength"] < 0
										){
											layer.msg( "长度输入有误" );
										} else
										{
											_this
												.$post( url, params )
												.then( res => {
													if ( res.code == "1" ){
														var url =
															_this.APIurl.API.api
																.registration;
														var params = {
															id:
																_this.$route
																	.query
																	.editId
														};
														_this
															.$get( url, params )
															.then( res => {
																handleFieldTable = table.render(
																	{
																		elem:
																			"#applicationField",
																		data:
																			res.posts,
																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																		cols: [
																			[
																				{
																					field:
																						"list_order",
																					title:
																						"排序"
																				},
																				{
																					field:
																						"field",
																					title:
																						"报名字段"
																				},
																				{
																					field:
																						"form_type",
																					title:
																						"表单类型",
																					templet: function (
																						d
																					) {
																						if (
																							d.form_type ==
																							"1"
																						)
																						{
																							return "文本";
																						} else if (
																							d.form_type ==
																							"2"
																						)
																						{
																							return "多行文本";
																						} else if (
																							d.form_type ==
																							"3"
																						)
																						{
																							return "单选";
																						} else if (
																							d.form_type ==
																							"4"
																						)
																						{
																							return "复选";
																						} else if (
																							d.form_type ==
																							"5"
																						)
																						{
																							return "下拉";
																						} else if (
																							d.form_type ==
																							"6"
																						)
																						{
																							return "时间";
																						} else if (
																							d.form_type ==
																							"7"
																						)
																						{
																							return "搜索下拉";
																						} else if (
																							d.form_type ==
																							"8"
																						)
																						{
																							return "分组标识";
																						}
																					}
																				},
																				{
																					field:
																						"is_required",
																					width: 140,
																					title:
																						"是否必填",
																					templet: function (
																						d
																					) {
																						return d.is_required ==
																							"1"
																							? "是"
																							: "否";
																					}
																				},
																				{
																					field:
																						"is_pishu_group",
																					width: 140,
																					title:
																						"皮书匹配",
																					templet: function (
																						d
																					) {
																						return d.is_pishu_group ==
																							"1"
																							? "是"
																							: "否";
																					}
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					templet: function (
																						d
																					) {
																						if (
																							d.field !==
																							"姓名" &&
																							d.field !==
																							"手机号"
																						)
																						{
																							return ` <a
                              class="layui-btn layui-btn-xs"
                              lay-event="applicationFieldsedit"
                              style="color: #FFFFFF;"
                             >编辑</a>
                            <a
                              class="layui-btn layui-btn-danger layui-btn-xs"
                              lay-event="applicationFieldsdel"
                              style="color: #FFFFFF;"
                            >删除</a>  `;
																						} else
																						{
																							return ``;
																						}
																					},
																					width: 160
																				}
																			]
																		],
																		page: true,
																		done: function (
																			res,
																			curr,
																			count
																		) {
																			res.data.forEach(
																				function (
																					item,
																					index
																				) {
																					if (
																						item.form_type ==
																						"8"
																					)
																						$(
																							'div[lay-id="applicationField"]'
																						)
																							.find(
																								'tr[data-index="' +
																								index +
																								'"]'
																							)
																							.find(
																								'td[data-field="field"]'
																							)
																							.html(
																								`<span style="padding: 0px 15px;color: #1E9FFF;">${ item.field }<i class="layui-icon layui-icon-flag" style="margin-left:5px;color: #1E9FFF;"></i></span>`
																							);
																					else
																						$(
																							'div[lay-id="applicationField"]'
																						)
																							.find(
																								'tr[data-index="' +
																								index +
																								'"]'
																							)
																							.find(
																								'td[data-field="field"]'
																							)
																							.css(
																								"background-color",
																								"white"
																							);
																				}
																			);
																		}
																	}
																);
															} );
														_this.$message( {
															message: "保存成功",
															type: "success",
															duration: 1000
														} );
														$(
															"#formtype"
														).removeAttr(
															"disabled"
														);
														$(
															"#name_text "
														).removeAttr(
															"disabled"
														);
														$( "#name_text " ).css(
															"color",
															"black"
														);
														signUpId = "";
														// /*关闭弹出层*/
														_this.dialogFormVisibleFour = false;
														$(
															"#signupfield"
														)[0].reset();
													} else{
														if (
															res.msg ==
															"参数错误"
														)
														{
															layer.msg(
																"请填写完整参数"
															);
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													}
												} )
												.catch( error => {
													console.log( error );
												} );
											return false;
										}
									} else{
										//新建
										if (
											$(
												"#formtype option:selected"
											).val() == "1"
										){
											//单行
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["setting_width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field[
													"setting_height"
													],

												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "2"
										){
											//多行
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["setting_width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field[
													"setting_height"
													],

												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "3"
										){
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "4"
										){
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "5"
										){
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "6"
										){
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],

												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "7"
										){
											params = {
												"data[0][id]": signUpId,
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][field]":
													data.field["field"],
												"data[0][field_name]":
													data.field["field_name"],
												"data[0][list_order]":
													data.field["list_order"],
												"data[0][tips]":
													data.field["tips"],
												"data[0][setting_ispassword]":
													data.field["is_password"],
												"data[0][formattribute]":
													data.field["formattribute"],
												"data[0][css]":
													data.field["css"],
												"data[0][minlength]":
													data.field["minlength"],
												"data[0][maxlength]":
													data.field["maxlength"],
												"data[0][pattern]":
													data.field["pattern"],
												"data[0][errortips]":
													data.field["errortips"],
												"data[0][setting_width]":
													data.field["width"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][placeholder]": "1",
												"data[0][setting_height]":
													data.field["height"],
												"data[0][options]":
													data.field["options"],
												"data[0][is_required]":
													data.field["is_required"],
												"data[0][defaultvalue]":
													data.field["defaultvalue"]
											};
										} else if (
											$(
												"#formtype option:selected"
											).val() == "8"
										){
											params = {
												"data[0][id]": signUpId,
												"data[0][field]":
													data.field["field"],
												"data[0][conference_id]": sessionStorage.getItem(
													"theMeetingId"
												),
												"data[0][form_type]":
													data.field["form_type"],
												"data[0][list_order]":
													data.field["list_order"]
											};
										}
										if (
											data.field["minlength"] >
											data.field["maxlength"] ||
											data.field["minlength"] < 0
										){
											layer.msg( "长度输入有误" );
										} else
										{
											_this
												.$post( url, params )
												.then( res => {
													if ( res.code == "1" ){
														var url =
															_this.APIurl.API.api
																.registration;
														var params = {
															id: sessionStorage.getItem(
																"theMeetingId"
															)
														};
														_this
															.$get( url, params )
															.then( res => {
																handleFieldTable = table.render(
																	{
																		elem:
																			"#applicationField",
																		data:
																			res.posts,
																		cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																		cols: [
																			[
																				{
																					field:
																						"list_order",
																					title:
																						"排序"
																				},
																				{
																					field:
																						"field",
																					title:
																						"报名字段"
																				},
																				{
																					field:
																						"form_type",
																					title:
																						"表单类型",
																					templet: function (
																						d
																					) {
																						if (
																							d.form_type ==
																							"1"
																						)
																						{
																							return "文本";
																						} else if (
																							d.form_type ==
																							"2"
																						)
																						{
																							return "多行文本";
																						} else if (
																							d.form_type ==
																							"3"
																						)
																						{
																							return "单选";
																						} else if (
																							d.form_type ==
																							"4"
																						)
																						{
																							return "复选";
																						} else if (
																							d.form_type ==
																							"5"
																						)
																						{
																							return "下拉";
																						} else if (
																							d.form_type ==
																							"6"
																						)
																						{
																							return "时间";
																						} else if (
																							d.form_type ==
																							"7"
																						)
																						{
																							return "搜索下拉";
																						} else if (
																							d.form_type ==
																							"8"
																						)
																						{
																							return "分组标识";
																						}
																					}
																				},
																				{
																					field:
																						"is_required",
																					width: 140,
																					title:
																						"是否必填",
																					templet: function (
																						d
																					) {
																						return d.is_required ==
																							"1"
																							? "是"
																							: "否";
																					}
																				},
																				{
																					field:
																						"is_pishu_group",
																					width: 140,
																					title:
																						"皮书匹配",
																					templet: function (
																						d
																					) {
																						return d.is_pishu_group ==
																							"1"
																							? "是"
																							: "否";
																					}
																				},
																				{
																					fixed:
																						"right",
																					title:
																						"操作",
																					templet: function (
																						d
																					) {
																						if (
																							d.field !==
																							"姓名" &&
																							d.field !==
																							"手机号"
																						)
																						{
																							return ` <a
                              class="layui-btn layui-btn-xs"
                              lay-event="applicationFieldsedit"
                              style="color: #FFFFFF;"
                             >编辑</a>
                            <a
                              class="layui-btn layui-btn-danger layui-btn-xs"
                              lay-event="applicationFieldsdel"
                              style="color: #FFFFFF;"
                            >删除</a>  `;
																						} else
																						{
																							return ``;
																						}
																					},
																					width: 160
																				}
																			]
																		],
																		page: true,
																		done: function (
																			res,
																			curr,
																			count
																		) {
																			res.data.forEach(
																				function (
																					item,
																					index
																				) {
																					if (
																						item.form_type ==
																						"8"
																					)
																						$(
																							'div[lay-id="applicationField"]'
																						)
																							.find(
																								'tr[data-index="' +
																								index +
																								'"]'
																							)
																							.find(
																								'td[data-field="field"]'
																							)
																							.html(
																								`<span style="padding: 0px 15px;color: #1E9FFF;">${ item.field }<i class="layui-icon layui-icon-flag" style="margin-left:5px;color: #1E9FFF;"></i></span>`
																							);
																					else
																						$(
																							'div[lay-id="applicationField"]'
																						)
																							.find(
																								'tr[data-index="' +
																								index +
																								'"]'
																							)
																							.find(
																								'td[data-field="field"]'
																							)
																							.css(
																								"background-color",
																								"white"
																							);
																				}
																			);
																		}
																	}
																);
															} );
														_this.$message( {
															message: "保存成功",
															type: "success",
															duration: 1000
														} );
														$(
															"#formtype"
														).removeAttr(
															"disabled"
														);
														$(
															"#name_text "
														).removeAttr(
															"disabled"
														);
														$( "#name_text " ).css(
															"color",
															"black"
														);
														signUpId = "";
														// /*关闭弹出层*/
														_this.dialogFormVisibleFour = false;

														$(
															"#signupfield"
														)[0].reset();
													} else{
														if (
															res.msg ==
															"参数错误"
														)
														{
															layer.msg(
																"请填写必填项"
															);
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													}
												} )
												.catch( error => {
													console.log( error );
												} );
											return false;
										}
									}
								} );
								/*编辑/删除报名*/
								table.on( "tool(applicationField)", function (
									obj
								) {
									setTimeout( function () {
										$( "#formtype" ).attr( "disabled", "true" );
										$( "#name_text " ).attr(
											"disabled",
											"disabled"
										);
										$( "#name_text " ).css(
											"color",
											"#cfcece"
										);
									}, 0 );
									var data = obj.data; //获得当前行数据
									var layEvent = obj.event; //获得 lay-event 对应的值（也可以是表头的 event 参数对应的值）
									var tr = obj.tr; //获得当前行 tr 的 DOM 对象（如果有的话）
									if ( layEvent === "applicationFieldsedit" ){
										if (
											/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
												sUserAgent
											)
										){
											handlefField = layer.open( {
												type: 1,
												title: "编辑模型",
												area: ["100%", "100vh"], //宽高
												content: $( "#signupfield" ), //调到新增页面
												end: function ( res ) {
													$( "#signupfield" ).css(
														"display",
														"none"
													);
													$( ".layui-layer-shade" ).css(
														"display",
														"none"
													);
												},
												success: function ( index ) {
													$( ".layui-layer-page" ).css(
														"z-index",
														"1000"
													);
													let url =
														_this.APIurl.API.api
															.signup_list;
													let params;
													if (
														_this.$route.query
															.editId
													){
														params = {
															id:
																_this.$route
																	.query
																	.editId
														};
													} else{
														params = {
															id: sessionStorage.getItem(
																"theMeetingId"
															)
														};
													}
													_this
														.$get( url, params )
														.then( res => {
															if (
																parseInt(
																	res.code
																) === 1
															)
															{
																for (
																	let i = 0;
																	i <
																	res.posts
																		.length;
																	i++
																)
																{
																	if (
																		res
																			.posts[
																			i
																		].id ==
																		data.id
																	)
																	{
																		let dataFrm =
																			res
																				.posts[
																			i
																			];
																		signUpId =
																			dataFrm.id;
																		form.val(
																			"dataApplicationField",
																			dataFrm
																		); //赋值表单的
																	}
																}
															} else
															{
																_this.$message( {
																	message:
																		res.msg,
																	type:
																		"warning",
																	duration: 1000
																} );
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												}
											} );
										} else
										{
											_this.titleFour = "编辑模型";
											_this.dialogFormVisibleFour = true;
											let url =
												_this.APIurl.API.api
													.signup_list;
											let params;
											if ( _this.$route.query.editId ){
												params = {
													id:
														_this.$route.query
															.editId
												};
											} else
											{
												params = {
													id: sessionStorage.getItem(
														"theMeetingId"
													)
												};
											}
											_this
												.$get( url, params )
												.then( res => {
													let dataFrm;
													if (
														parseInt( res.code ) === 1
													){
														for (
															let i = 0;
															i <
															res.posts.length;
															i++
														)
														{
															if (
																res.posts[i]
																	.id ==
																data.id
															)
															{
																if (
																	data.form_type ==
																	1 ||
																	data.form_type ==
																	2
																)
																{
																	$(
																		"#singletext"
																	).show();
																	$(
																		"#textField"
																	).show();
																} else
																{
																	$(
																		"#singletext"
																	).hide();
																	$(
																		"#textField"
																	).hide();
																}
																if (
																	data.form_type ==
																	1
																)
																{
																	$(
																		"#mima"
																	).show();
																} else
																{
																	$(
																		"#mima"
																	).hide();
																}
																if (
																	data.form_type ==
																	1 ||
																	data.form_type ==
																	2 ||
																	data.form_type ==
																	7
																)
																{
																	$(
																		"#text_length"
																	).show();
																} else
																{
																	$(
																		"#text_length"
																	).hide();
																}
																if (
																	data.form_type ==
																	3 ||
																	data.form_type ==
																	4 ||
																	data.form_type ==
																	5 ||
																	data.form_type ==
																	7
																)
																{
																	setTimeout(function(){
																		$(
																		"#comprehensive"
																	).show();
																	},1000)
																	$(
																		"#zze"
																	).hide();
																} else
																{
																	$(
																		"#comprehensive"
																	).hide();
																	$(
																		"#zze"
																	).show();
																}
																if (
																	data.form_type ==
																	6
																)
																{
																	$(
																		"#zze"
																	).hide();
																} else
																{
																	$(
																		"#zze"
																	).show();
																}
																if (
																	data.form_type ==
																	8
																)
																{
																	$(
																		"#singletext"
																	).hide();
																	$(
																		"#textField"
																	).hide();
																	$(
																		"#mima"
																	).hide();
																	$(
																		"#thedateof"
																	).hide();
																	$(
																		"#comprehensive"
																	).hide();
																	$(
																		"#onehundredpercent"
																	).val(
																		"100%"
																	);
																	$(
																		"#comprehensive"
																	).hide();
																	$(
																		"#zze"
																	).hide();
																	$(
																		"#text_length"
																	).hide();
																	$(
																		"#one_zd"
																	).show();
																	$(
																		"#two_zd"
																	).show();
																	$(
																		"#three_zd"
																	).hide();
																	$(
																		"#four_zd"
																	).hide();
																	$(
																		"#five_zd"
																	).hide();
																	$(
																		"#six_zd"
																	).hide();
																	$(
																		"#seven_zd"
																	).hide();
																	$(
																		"#eight_zd"
																	).show();
																	$(
																		"#nine_zd"
																	).hide();
																} 
																signUpId =
																	res.posts[i]
																		.id;
																dataFrm =
																	res.posts[
																	i
																	];
															}
														}
														/* akakakakkak */
														var opt =
															dataFrm.setting
																.options;
														let objs = {
															css: dataFrm.css,
															errortips:
																dataFrm.errortips,
															field:
																dataFrm.field,
															field_name:
																dataFrm.field_name,
															remake:
																dataFrm.remake,
															relation_status:
																dataFrm.relation_status,
															relation_field_id:
																dataFrm.relation_field_id,
															tips: dataFrm.tips,
															form_type:
																dataFrm.form_type,
															formattribute:
																dataFrm.formattribute,
															id: dataFrm.id,
															list_order:
																dataFrm.list_order,
															is_required:
																dataFrm.is_required,
															is_system:
																dataFrm.is_system,
															maxlength:
																dataFrm.maxlength,
															minlength:
																dataFrm.minlength,
															pattern:
																dataFrm.pattern,
															defaultvalue:
																dataFrm.setting
																	.defaultvalue,
															setting_width:
																dataFrm.setting
																	.width,
															setting_height:
																dataFrm.setting
																	.height,
															is_password:
																dataFrm.setting
																	.is_password,
															options: opt,
															is_pishu_group:
																dataFrm.is_pishu_group,
																max_select_num:dataFrm.max_select_num,
														};

														form.val(
															"dataApplicationField",
															objs
														); //赋值表单的

														_this.relation_params.relation_field_id =
															dataFrm.relation_field_id;
														_this.relation_params.relation_field_id_options = res.posts.filter(
															i =>
																i.id !=
																dataFrm.id
														);
														_this.relation_params.relation_field_val_selected =
															dataFrm.relation_field_val;
														_this.relation_params.relation_field_val_options =
															( res.posts.find(
																i =>
																	i.id ==
																	dataFrm.relation_field_id
															) &&
																res.posts.find(
																	i =>
																		i.id ==
																		dataFrm.relation_field_id
																).setting
																	.options ) ||
															[];
													} else{
														_this.$message( {
															message: res.msg,
															type: "warning",
															duration: 1000
														} );
													}
												} )
												.catch( error => {
													console.log( error );
												} );
										}
									} else if (
										layEvent === "applicationFieldsdel"
									){
										layer.confirm(
											"确定删除此行么",
											function ( index ) {
												//向服务端发送删除指令
												let url =
													_this.APIurl.API.api
														.del_signup;
												let params = {
													id: data.id
												};
												_this
													.$delet( url, params )
													.then( res => {
														if (
															parseInt(
																res.code
															) === 1
														)
														{
															_this.$message( {
																message:
																	"删除成功",
																type: "success",
																duration: 1000
															} );
															obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
															layer.close( index );
															if (
																_this.$route
																	.query
																	.editId
															)
															{
																var url =
																	_this.APIurl
																		.API.api
																		.registration;
																var params = {
																	id:
																		_this
																			.$route
																			.query
																			.editId
																};
																_this
																	.$get(
																		url,
																		params
																	)
																	.then(
																		res => {
																			if (
																				res.code ==
																				1
																			)
																			{
																				handleFieldTable = table.render(
																					{
																						elem:
																							"#applicationField",
																						data:
																							res.posts,
																						cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																						cols: [
																							[
																								{
																									field:
																										"list_order",
																									title:
																										"排序"
																								},
																								{
																									field:
																										"field",
																									title:
																										"报名字段"
																								},
																								{
																									field:
																										"form_type",
																									title:
																										"表单类型",
																									templet: function (
																										d
																									) {
																										if (
																											d.form_type ==
																											"1"
																										)
																										{
																											return "文本";
																										} else if (
																											d.form_type ==
																											"2"
																										)
																										{
																											return "多行文本";
																										} else if (
																											d.form_type ==
																											"3"
																										)
																										{
																											return "单选";
																										} else if (
																											d.form_type ==
																											"4"
																										)
																										{
																											return "复选";
																										} else if (
																											d.form_type ==
																											"5"
																										)
																										{
																											return "下拉";
																										} else if (
																											d.form_type ==
																											"6"
																										)
																										{
																											return "时间";
																										} else if (
																											d.form_type ==
																											"7"
																										)
																										{
																											return "搜索下拉";
																										} else if (
																											d.form_type ==
																											"8"
																										)
																										{
																											return "分组标识";
																										}
																									}
																								},
																								{
																									field:
																										"is_required",
																									width: 140,
																									title:
																										"是否必填",
																									templet: function (
																										d
																									) {
																										return d.is_required ==
																											"1"
																											? "是"
																											: "否";
																									}
																								},
																								{
																									field:
																										"is_pishu_group",
																									width: 140,
																									title:
																										"皮书匹配",
																									templet: function (
																										d
																									) {
																										return d.is_pishu_group ==
																											"1"
																											? "是"
																											: "否";
																									}
																								},
																								{
																									fixed:
																										"right",
																									title:
																										"操作",
																									templet: function (
																										d
																									) {
																										if (
																											d.field !==
																											"姓名" &&
																											d.field !==
																											"手机号"
																										)
																										{
																											return ` <a
                              class="layui-btn layui-btn-xs"
                              lay-event="applicationFieldsedit"
                              style="color: #FFFFFF;"
                             >编辑</a>
                            <a
                              class="layui-btn layui-btn-danger layui-btn-xs"
                              lay-event="applicationFieldsdel"
                              style="color: #FFFFFF;"
                            >删除</a>  `;
																										} else
																										{
																											return ``;
																										}
																									},
																									width: 160
																								}
																							]
																						],
																						page: true,
																						done: function (
																							res,
																							curr,
																							count
																						) {
																							res.data.forEach(
																								function (
																									item,
																									index
																								) {
																									if (
																										item.form_type ==
																										"8"
																									)
																										$(
																											'div[lay-id="applicationField"]'
																										)
																											.find(
																												'tr[data-index="' +
																												index +
																												'"]'
																											)
																											.find(
																												'td[data-field="field"]'
																											)
																											.html(
																												`<span style="padding: 0px 15px;color: #1E9FFF;">${ item.field }<i class="layui-icon layui-icon-flag" style="margin-left:5px;color: #1E9FFF;"></i></span>`
																											);
																									else
																										$(
																											'div[lay-id="applicationField"]'
																										)
																											.find(
																												'tr[data-index="' +
																												index +
																												'"]'
																											)
																											.find(
																												'td[data-field="field"]'
																											)
																											.css(
																												"background-color",
																												"white"
																											);
																								}
																							);
																						}
																					}
																				);
																			}
																		}
																	);
															} else
															{
																var url =
																	_this.APIurl
																		.API.api
																		.registration;
																var params = {
																	id: sessionStorage.getItem(
																		"theMeetingId"
																	)
																};
																_this
																	.$get(
																		url,
																		params
																	)
																	.then(
																		res => {
																			if (
																				res.code ==
																				1
																			)
																			{
																				handleFieldTable = table.render(
																					{
																						elem:
																							"#applicationField",
																						data:
																							res.posts,
																						cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																						cols: [
																							[
																								{
																									field:
																										"list_order",
																									title:
																										"排序"
																								},
																								{
																									field:
																										"field",
																									title:
																										"报名字段"
																								},
																								{
																									field:
																										"form_type",
																									title:
																										"表单类型",
																									templet: function (
																										d
																									) {
																										if (
																											d.form_type ==
																											"1"
																										)
																										{
																											return "文本";
																										} else if (
																											d.form_type ==
																											"2"
																										)
																										{
																											return "多行文本";
																										} else if (
																											d.form_type ==
																											"3"
																										)
																										{
																											return "单选";
																										} else if (
																											d.form_type ==
																											"4"
																										)
																										{
																											return "复选";
																										} else if (
																											d.form_type ==
																											"5"
																										)
																										{
																											return "下拉";
																										} else if (
																											d.form_type ==
																											"6"
																										)
																										{
																											return "时间";
																										} else if (
																											d.form_type ==
																											"7"
																										)
																										{
																											return "搜索下拉";
																										} else if (
																											d.form_type ==
																											"8"
																										)
																										{
																											return "分组标识";
																										}
																									}
																								},
																								{
																									field:
																										"is_required",
																									width: 140,
																									title:
																										"是否必填",
																									templet: function (
																										d
																									) {
																										return d.is_required ==
																											"1"
																											? "是"
																											: "否";
																									}
																								},
																								{
																									fixed:
																										"right",
																									title:
																										"操作",
																									templet: function (
																										d
																									) {
																										if (
																											d.field !==
																											"姓名" &&
																											d.field !==
																											"手机号"
																										)
																										{
																											return ` <a
                              class="layui-btn layui-btn-xs"
                              lay-event="applicationFieldsedit"
                              style="color: #FFFFFF;"
                             >编辑</a>
                            <a
                              class="layui-btn layui-btn-danger layui-btn-xs"
                              lay-event="applicationFieldsdel"
                              style="color: #FFFFFF;"
                            >删除</a>  `;
																										} else
																										{
																											return ``;
																										}
																									},
																									width: 160
																								}
																							]
																						],
																						page: true,
																						done: function (
																							res,
																							curr,
																							count
																						) {
																							res.data.forEach(
																								function (
																									item,
																									index
																								) {
																									if (
																										item.form_type ==
																										"8"
																									)
																										$(
																											'div[lay-id="applicationField"]'
																										)
																											.find(
																												'tr[data-index="' +
																												index +
																												'"]'
																											)
																											.find(
																												'td[data-field="field"]'
																											)
																											.html(
																												`<span style="padding: 0px 15px;color: #1E9FFF;">${ item.field }<i class="layui-icon layui-icon-flag" style="margin-left:5px;color: #1E9FFF;"></i></span>`
																											);
																									else
																										$(
																											'div[lay-id="applicationField"]'
																										)
																											.find(
																												'tr[data-index="' +
																												index +
																												'"]'
																											)
																											.find(
																												'td[data-field="field"]'
																											)
																											.css(
																												"background-color",
																												"white"
																											);
																								}
																							);
																						}
																					}
																				);
																			}
																		}
																	);
															}
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													} )
													.catch( error => {
														console.log( error );
													} );
											}
										);
									}
								} );

								/*--------------报名设置结束-------------------*/
							} else if ( data.index == "3" )
							{
								var editId = "";
								/*--------------栏目管理开始------------------*/
								/* 获取父列表 */
								let url = _this.APIurl.API.api.father_column;
								var params = {};
								if ( _this.$route.query.editId )
								{
									params = {
										id: _this.$route.query.editId
									};
								} else
								{
									params = {
										id: sessionStorage.getItem(
											"theMeetingId"
										)
									};
								}
								_this.$get( url, params ).then( res => {
									_this.fu_lan = res.posts;
								} );
								/* 获取父栏目 */
								let urlmm = "/ac1/conference/column/topList";
								var paramsmm = {};
								if ( _this.$route.query.editId )
								{
									paramsmm = {
										conference_id: _this.$route.query.editId
									};
								} else
								{
									paramsmm = {
										conference_id: sessionStorage.getItem(
											"theMeetingId"
										)
									};
								}
								_this.$get( urlmm, paramsmm ).then( res => {
									console.log( res );
									_this.fu_lans = res.posts;
								} );
								/* 获取视频 */
								let urls = _this.APIurl.API.api.video_list;
								_this.$get( urls ).then( res => {
									_this.video_all = res.posts;
								} );
								/* 监听栏目类型 */
								form.on( "select(columnType)", function ( data ) {
									if ( data.value == "1" ){
										$( "#synchronizeWeChat" ).css(
											"display",
											"block"
										);
										$( "#skipLinks" ).css( "display", "none" );
										$( "#lan_x" ).show();
										$( "#lan_xx" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#ziliao" ).hide();
										$( ".sp_img" ).hide();
										$( "#fathers" ).show();
										$( "#jiejian" ).show();
										$( "#father" ).show();
										$( "#lan_time" ).show();
										$( "#fxy" ).show();
										$( ".icon" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										$( "#paixu" ).show();
										_this.zhibo = false;
									} else if ( data.value == "2" ){
										$( "#synchronizeWeChat" ).css(
											"display",
											"none"
										);
										$( "#attachments" ).css(
											"display",
											"none"
										);
										$( "#skipLinks" ).css( "display", "none" );
										$( "#lan_x" ).hide();
										$( "#lan_xx" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#ziliao" ).hide();
										$( "#fathers" ).show();
										$( ".sp_img" ).hide();
										$( "#jiejian" ).hide();
										$( "#father" ).hide();
										$( "#lan_time" ).hide();
										$( "#fxy" ).show();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "3" ){
										$( "#attachments" ).css(
											"display",
											"block"
										);
										$( "#synchronizeWeChat" ).show();
										$( "#skipLinks" ).css( "display", "block" );
										$( "#attachments" ).css(
											"display",
											"none"
										);
										$( "#lan_x" ).hide();
										$( "#lan_xx" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#ziliao" ).hide();
										$( "#fathers" ).show();
										$( ".sp_img" ).hide();
										$( "#jiejian" ).hide();
										$( "#father" ).show();
										$( "#fxy" ).show();
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "4" ){
										$( "#skipLinks" ).css( "display", "none" );
										$( "#attachments" ).css(
											"display",
											"block"
										);
										$( "#synchronizeWeChat" ).css(
											"display",
											"none"
										);
										$( "#skipLinks" ).css( "display", "none" );
										$( "#lan_x" ).hide();
										$( "#lan_xx" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#ziliao" ).hide();
										$( ".sp_img" ).hide();
										$( "#fathers" ).show();
										$( "#jiejian" ).hide();
										$( "#father" ).hide();
										$( "#fxy" ).show();
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "5" ){
										$( "#lan_xx" ).show();
										$( "#jiejian" ).hide();
										$( "#attachments" ).hide();
										$( "#skipLinks" ).css( "display", "none" );
										$( "#synchronizeWeChat" ).show();
										$( "#lan_x" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#ziliao" ).hide();
										$( ".sp_img" ).hide();
										$( "#fathers" ).show();
										$( "#fxy" ).show();
										$( "#father" ).hide();
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "9" ){
										$( "#synchronizeWeChat" ).show();
										$( "#attachments" ).hide();
										$( "#jiejian" ).hide();
										$( "#lan_xx" ).hide();
										$( "#lan_x" ).hide();
										$( "#skipLinks" ).css( "display", "none" );
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#ziliao" ).hide();
										$( "#fxy" ).show();
										$( ".sp_img" ).hide();
										$( "#fathers" ).show();
										$( "#father" ).hide();
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "10" ){
										$( "#lan_xx" ).hide();
										$( "#jiejian" ).hide();
										$( "#attachments" ).hide();
										$( "#synchronizeWeChat" ).show();
										$( "#lan_x" ).hide();
										$( "#out_people" ).show();
										$( "#fxy" ).show();
										$( "#ship" ).hide();
										$( "#skipLinks" ).css( "display", "none" );
										$( "#ziliao" ).show();
										$( ".sp_img" ).hide();
										$( "#fathers" ).show();
										$( "#father" ).hide();
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "11" ){
										$( "#lan_xx" ).hide();
										$( "#jiejian" ).show();
										$( "#attachments" ).hide();
										$( "#synchronizeWeChat" ).show();
										$( "#lan_x" ).hide();
										$( "#out_people" ).show();
										$( "#fxy" ).show();
										$( "#ship" ).show();
										$( "#skipLinks" ).css( "display", "none" );
										$( "#ziliao" ).hide();
										$( ".sp_img" ).show();
										$( "#father" ).hide();
										$( "#fathers" ).show();
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										$( "#paixu" ).show();
										_this.zhibo = false;
									} else if ( data.value == "13" ){
										$( "#lan_xx" ).hide();
										$( "#jiejian" ).hide();
										$( "#attachments" ).hide();
										$( "#synchronizeWeChat" ).show();
										$( "#lan_x" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#skipLinks" ).show();
										$( "#ziliao" ).hide();
										$( ".sp_img" ).hide();
										$( "#father" ).hide();
										$( "#fathers" ).hide();
										$( "#lan_time" ).hide();
										$( "#fxy" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `发布时间
            <i style="color:red">*</i>`);
										_this.zhibo = false;
									} else if ( data.value == "14" ){
										$( "#lan_xx" ).hide();
										$( "#jiejian" ).hide();
										$( "#attachments" ).hide();
										$( "#synchronizeWeChat" ).hide();
										$( "#lan_x" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#skipLinks" ).hide();
										$( "#ziliao" ).hide();
										$( ".sp_img" ).hide();
										$( "#father" ).hide();
										$( "#fathers" ).hide();
										$( "#lan_time" ).show();
										$( "#fxy" ).show();
										$( ".icon" ).hide();
										$( "#paixu" ).show();
										$( "#lan_time label" ).html( `直播开始时间
            <i style="color:red">*</i>`);
										_this.zhibo = true;
									} else{
										$( "#fathers" ).show();
										$( "#attachments" ).hide();
										$( "#jiejian" ).hide();
										$( "#lan_xx" ).hide();
										$( "#synchronizeWeChat" ).hide();
										$( "#lan_x" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										$( "#fxy" ).show();
										$( "#skipLinks" ).css( "display", "none" );
										$( "#ziliao" ).hide();
										$( ".sp_img" ).hide();
										$( "#father" ).hide();
										$( "#lan_time label" ).html( `发布时间
                    <i style="color:red">*</i>`);
										$( "#lan_time" ).hide();
										$( ".icon" ).show();
										$( "#paixu" ).show();
										_this.zhibo = false;
									}
								} );
								/* 监听关联的嘉宾删除 */
								table.on( "tool(test_jiabin)", function ( obj ) {
									var layEvent = obj.event;
									if ( layEvent === "del" ){
										layer.confirm( "真的删除行么", function (
											index
										) {
											obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
											layer.close( index );
										} );
									}
								} );
								_this.zhibolist();
								var columnmanagementables;
								var handleCloseLayer;
								var newcolumnIndexPc = function () {
									$( "#addColumn" ).on( "click", function () {
										_this.dialogFormVisibleFive = true;
										_this.zhibo = false;
										_this.titleFive = "新增栏目";
										editId = "";
										let urls =
											_this.APIurl.API.api.father_column;
										var paramsk = {};
										if ( _this.$route.query.editId ){
											paramsk = {
												id: _this.$route.query.editId
											};
										} else
										{
											paramsk = {
												id: sessionStorage.getItem(
													"theMeetingId"
												)
											};
										}
										_this.$get( urls, paramsk ).then( res => {
											_this.fu_lan = res.posts;
										} );
										/* 获取父栏目 */
										let urlmm =
											"/ac1/conference/column/topList";
										var paramsmm = {};
										if ( _this.$route.query.editId ){
											paramsmm = {
												conference_id:
													_this.$route.query.editId
											};
										} else
										{
											paramsmm = {
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												)
											};
										}
										_this
											.$get( urlmm, paramsmm )
											.then( res => {
												_this.fu_lans = res.posts;
												_this.lan_d = false;
												_this.couponSelecteds = null;
											} );
										_this.contenthave = "";
										//清空上传图片的值
										$( "#columnIcon_img" ).css(
											"display",
											"none"
										);
										$( "#columnIcon_img" ).attr( "src", "" );
										$( "#demosGuests" ).css(
											"display",
											"none"
										);
										$( "#demosGuests" ).attr( "src", "" );
										$( "#lan_xx" ).hide();
										$( "#lan_x" ).hide();
										$( "#skipLinks" ).hide();
										$( "#synchronizeWeChat" ).hide();
										$( "#out_people" ).hide();
										$( "#ship" ).hide();
										// $("#demokk").text("");
										$( "#ziliao" ).hide();
										$( "#jiejian" ).hide();
										$( ".sp_img" ).css( "display", "none" );
										$( ".sp_img" ).attr( "src", "" );
										$( "#attachments" ).hide();
										$( "#father" ).hide();
										// table.render({
										//   elem: "#test_jiabin",
										//   data: [], //数据
										//   page: true, //开启分页
										//   cols: [
										//     [
										//       //表头
										//       { field: "id", title: "id", width: 80, sort: true },
										//       {
										//         field: "head_img",
										//         title: "嘉宾头像",
										//         width: 80,
										//         templet: function (d) {
										//           return `<img src=${d.head_img}>`;
										//         },
										//       },
										//       {
										//         field: "name",
										//         title: "姓名",
										//         width: 80,
										//         sort: true,
										//       },
										//       { field: "tel", title: "电话", width: 80 },
										//       { field: "ssapid", title: "ssapid", width: 177 },
										//       {
										//         field: "description",
										//         title: "简介",
										//         width: 80,
										//         sort: true,
										//       },
										//       {
										//         field: "sccompanyore",
										//         title: "研究领域",
										//         width: 80,
										//         sort: true,
										//       },
										//       {
										//         fixed: "right",
										//         title: "操作",
										//         toolbar: "#bar_jiabin",
										//       },
										//     ],
										//   ],
										//   page: true,
										// });
									} );
								};
								var newcolumnIndex = function () {
									$( "#addColumn" ).on( "click", function () {
										handleCloseLayer = layer.open( {
											type: 1,
											title: "新增栏目",
											area: ["100%", "100vh"], //宽高
											content: $( "#newcolumn" ), //调到新增页面
											end: function ( res ) {
												$( "#newcolumn" ).css(
													"display",
													"none"
												);
												$( ".layui-layer-shade" ).css(
													"display",
													"none"
												);
											},
											success: function ( index ) {
												$( ".layui-layer-page" ).css(
													"z-index",
													"1000"
												);
												_this.contenthave = "";
												//清空上传图片的值
												$( "#columnIcon_img" ).css(
													"display",
													"none"
												);
												$( "#columnIcon_img" ).attr(
													"src",
													""
												);
												$( "#demosGuests" ).css(
													"display",
													"none"
												);
												$( "#demosGuests" ).attr(
													"src",
													""
												);
												$( "#ziliao" ).hide();
												//清空文本域
											}
										} );
									} );
								};
								if (
									/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
										sUserAgent
									)
								)
								{
									handleTicket();
								} else
								{
									newcolumnIndexPc();
								}
								/* 栏目初始渲染数据  判断是新建会议 还是已有会议 */
								if ( _this.$route.query.editId )
								{
									let url = _this.APIurl.API.api.column_list;
									let params = {
										id: _this.$route.query.editId
									};
									_this.$get( url, params ).then( res => {
										var q_arr = [];
										var val = res.posts;
										for ( let k = 0; k < val.length; k++ ){
											var li_val = val[k];

											q_arr.push( li_val );
											if (
												li_val.type == 2 ||
												li_val.type == 13
											){
												for (
													let c = 0;
													c < li_val.child.length;
													c++
												){
													var child = li_val.child[c];
													var obj = {
														id: child.id,
														title:
															"&nbsp;└─&nbsp;&nbsp;" +
															child.title,
														pid: li_val.id,
														type: child.type,
														status: child.status,
														display: child.display,
														share_show:
															child.share_show
													};
													q_arr.push( obj );
													var childs =
														li_val.child[c].child;
													if ( childs ){
														for (
															let sx = 0;
															sx < childs.length;
															sx++
														)
														{
															var child_li =
																childs[sx];
															var objkr = {
																id: child_li.id,
																title:
																	"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└─&nbsp;&nbsp;" +
																	child_li.title,
																pid:
																	child.title,
																type:
																	child_li.type,
																status:
																	child_li.status,
																display:
																	child_li.display,
																share_show:
																	child_li.share_show
															};
															q_arr.push( objkr );
														}
													}
												}
											}
										}
										columnmanagementables = table.render( {
											elem: "#columnmanagementables",
											data: q_arr,
											cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
											cols: [
												[{
														field: "title",
														title: "栏目名称"
													},{
														field: "type",
														title: "栏目类型",
														templet: function ( res ) {
															if (
																res.type == "1"
															)
															{
																return "内容单页";
															} else if (
																res.type == "2"
															)
															{
																return "内容列表";
															} else if (
																res.type == "3"
															)
															{
																return "跳转链接";
															} else if (
																res.type == "4"
															)
															{
																return "附件下载";
															} else if (
																res.type == "5"
															)
															{
																return "关联嘉宾";
															} else if (
																res.type == "6"
															)
															{
																return "会议详情";
															} else if (
																res.type == "7"
															)
															{
																return "我的报名";
															} else if (
																res.type == "8"
															)
															{
																return "发票开票";
															} else if (
																res.type == "9"
															)
															{
																return "会后-媒体报道";
															} else if (
																res.type == "10"
															)
															{
																return "会后-会议资料";
															} else if (
																res.type == "11"
															)
															{
																return "会后会议回顾";
															} else if (
																res.type == "12"
															)
															{
																return "查找座位";
															} else if (
																res.type == "13"
															)
															{
																return "顶级栏目";
															} else if (
																res.type == "14"
															)
															{
																return "图文直播";
															}
														}
													},{
														field: "status",
														title: "状态",
														templet: function ( res ) {
															return res.status ==
																1
																? "正常"
																: "禁用";
														}
													},{
														field: "display",
														title:
															"是否在会议详情页显示",
														templet: function ( res ) {
															return res.display ==
																1
																? "显示"
																: "不显示";
														}
													},{
														field: "share_show",
														title:
															"是否在分享页显示",
														templet: function ( res ) {
															return res.share_show ==
																1
																? "显示"
																: "不显示";
														}
													},{
														fixed: "right",
														title: "操作",
														toolbar:
															"#columnmanagementableDemo",
														width: 140
													}
												]
											],
											page: false,
											limit: q_arr.length
										} );
									} );
								} else
								{
									let url = _this.APIurl.API.api.column_list;
									let params = {
										id: sessionStorage.getItem(
											"theMeetingId"
										)
									};
									_this.$get( url, params ).then( res => {
										var q_arr = [];
										var val = res.posts;
										for ( let k = 0; k < val.length; k++ ){
											var li_val = val[k];
											q_arr.push( li_val );
											if (
												li_val.type == 2 ||
												li_val.type == 13
											){
												for (
													let c = 0;
													c < li_val.child.length;
													c++
												){
													var child = li_val.child[c];
													var obj = {
														id: child.id,
														title:
															"&nbsp;└─&nbsp;&nbsp;" +
															child.title,
														pid: li_val.id,
														type: child.type,
														status: child.status,
														display: child.display,
														share_show:
															child.share_show
													};
													q_arr.push( obj );
													var childs =
														li_val.child[c].child;
													if ( childs ){
														for (
															let sx = 0;
															sx < childs.length;
															sx++
														)
														{
															var child_li =
																childs[sx];
															var objkr = {
																id: child_li.id,
																title:
																	"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└─&nbsp;&nbsp;" +
																	child_li.title,
																pid:
																	child.title,
																type:
																	child_li.type,
																status:
																	child_li.status,
																display:
																	child_li.display,
																share_show:
																	child_li.share_show
															};
															q_arr.push( objkr );
														}
													}
												}
											}
										}
										columnmanagementables = table.render( {
											elem: "#columnmanagementables",

											data: q_arr,
											where: {
												id: sessionStorage.getItem(
													"theMeetingId"
												)
											}, //_this.theMeetingId

											cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
											cols: [
												[{
														field: "title",
														title: "栏目名称"
													},{
														field: "type",
														title: "栏目类型",
														templet: function ( res ) {
															if (
																res.type == "1"
															)
															{
																return "内容单页";
															} else if (
																res.type == "2"
															)
															{
																return "内容列表";
															} else if (
																res.type == "3"
															)
															{
																return "跳转链接";
															} else if (
																res.type == "4"
															)
															{
																return "附件下载";
															} else if (
																res.type == "5"
															)
															{
																return "关联嘉宾";
															} else if (
																res.type == "6"
															)
															{
																return "会议详情";
															} else if (
																res.type == "7"
															)
															{
																return "我的报名";
															} else if (
																res.type == "8"
															)
															{
																return "发票开票";
															} else if (
																res.type == "9"
															)
															{
																return "会后-媒体报道";
															} else if (
																res.type == "10"
															)
															{
																return "会后-会议资料";
															} else if (
																res.type == "11"
															)
															{
																return "会后会议回顾";
															} else if (
																res.type == "12"
															)
															{
																return "查找座位";
															} else if (
																res.type == "13"
															)
															{
																return "顶级栏目";
															} else if (
																res.type == "14"
															)
															{
																return "图文直播";
															}
														}
													},{
														field: "status",
														title: "状态",
														templet: function ( res ) {
															return res.status ==
																1
																? "正常"
																: "禁用";
														}
													},{
														field: "display",
														title:
															"是否在会议详情页显示",
														templet: function ( res ) {
															return res.display ==
																1
																? "显示"
																: "不显示";
														}
													},{
														field: "share_show",
														title:
															"是否在分享页显示",
														templet: function ( res ) {
															return res.share_show ==
																1
																? "显示"
																: "不显示";
														}
													},{
														fixed: "right",
														title: "操作",
														toolbar:
															"#columnmanagementableDemo",
														width: 140
													}
												]
											],
											page: false,
											limit: q_arr.length
										} );
									} );
								}
								/*4.编辑、删除栏目*/
								table.on(
									"tool(columnmanagementables)",
									function ( obj ) {
										var data = obj.data; //获得当前行数据
										var layEvent = obj.event; //获得 lay-event 对应的值（也可以是表头的 event 参数对应的值）
										var tr = obj.tr; //获得当前行 tr 的 DOM 对象（如果有的话）
										if (
											layEvent ===
											"columnmanagementabedit"
										){
											if (
												/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(
													sUserAgent
												)
											){
												handleCloseLayer = layer.open( {
													type: 1,
													title: "编辑栏目",
													area: ["100%", "100vh"], //宽高
													content: $( "#newcolumn" ), //调到新增页面
													end: function ( res ) {
														$( "#newcolumn" ).css(
															"display",
															"none"
														);
														$(
															".layui-layer-shade"
														).css(
															"display",
															"none"
														);
													},
													success: function ( index ) {
														$(
															".layui-layer-page"
														).css(
															"z-index",
															"1000"
														);
														$( "#lan_xx" ).hide();
														//栏目详情
														let url =
															_this.APIurl.API.api
																.colum_set;
														let params = {
															id: data.id,
															type: data.id
														};
														_this
															.$get( url, params )
															.then( res => {
																if (
																	res.code ==
																	"1"
																)
																{
																	let dataFrm =
																		res.posts;
																	dataFrm.publish_time = moment(
																		dataFrm.publish_time
																	).format(
																		"YYYY-MM-DD HH:mm:ss"
																	);
																	editId =
																		res
																			.posts
																			.id;
																	if (
																		res
																			.posts
																			.type ==
																		"1"
																	)
																	{
																		$(
																			"#lan_time"
																		).show();
																		$(
																			"#synchronizeWeChat"
																		).css(
																			"display",
																			"block"
																		);
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#lan_x"
																		).show();
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#jiejian"
																		).show();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"2"
																	)
																	{
																		$(
																			"#synchronizeWeChat"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#attachments"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"3"
																	)
																	{
																		$(
																			"#attachments"
																		).css(
																			"display",
																			"block"
																		);
																		$(
																			"#synchronizeWeChat"
																		).show();
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"block"
																		);
																		$(
																			"#attachments"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			"#father"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"4"
																	)
																	{
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#attachments"
																		).css(
																			"display",
																			"block"
																		);

																		$(
																			"#synchronizeWeChat"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"5"
																	)
																	{
																		$(
																			"#lan_xx"
																		).show();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#synchronizeWeChat"
																		).show();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"9"
																	)
																	{
																		$(
																			"#synchronizeWeChat"
																		).show();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"10"
																	)
																	{
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#synchronizeWeChat"
																		).show();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			"#out_people"
																		).show();
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).show();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"11"
																	)
																	{
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#fxy"
																		).show();
																		$(
																			"#jiejian"
																		).show();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#synchronizeWeChat"
																		).show();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#out_people"
																		).show();
																		$(
																			"#ship"
																		).show();
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			".sp_img"
																		).show();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).show();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"13"
																	)
																	{
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#synchronizeWeChat"
																		).show();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#skipLinks"
																		).show();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			"#fathers"
																		).hide();
																		$(
																			"#father"
																		).hide();
																		$(
																			"#fxy"
																		).hide();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	} else if (
																		res
																			.posts
																			.type ==
																		"14"
																	)
																	{
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#synchronizeWeChat"
																		).hide();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#skipLinks"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#father"
																		).hide();
																		$(
																			"#fathers"
																		).hide();
																		$(
																			"#lan_time"
																		).show();
																		$(
																			"#fxy"
																		).show();
																		$(
																			".icon"
																		).hide();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `直播开始时间
            <i style="color:red">*</i>`);
																		_this.zhibo = true;
																	} else
																	{
																		$(
																			"#fxy"
																		).show();
																		$(
																			"#fathers"
																		).show();
																		$(
																			"#attachments"
																		).hide();
																		$(
																			"#jiejian"
																		).hide();
																		$(
																			"#lan_xx"
																		).hide();
																		$(
																			"#synchronizeWeChat"
																		).hide();
																		$(
																			"#lan_x"
																		).hide();
																		$(
																			"#out_people"
																		).hide();
																		$(
																			"#ship"
																		).hide();
																		$(
																			"#ziliao"
																		).hide();
																		$(
																			"#skipLinks"
																		).css(
																			"display",
																			"none"
																		);
																		$(
																			".sp_img"
																		).hide();
																		$(
																			"#lan_time"
																		).hide();
																		$(
																			".icon"
																		).show();
																		$(
																			"#paixu"
																		).show();
																		$(
																			"#lan_time label"
																		)
																			.html( `发布时间
            <i style="color:red">*</i>`);
																		_this.zhibo = false;
																	}

																	form.val(
																		"dataColumn",
																		dataFrm
																	); //赋值表单的
																} else
																{
																	_this.$message(
																		{
																			message:
																				res.msg,
																			type:
																				"warning",
																			duration: 1000
																		}
																	);
																}
															} )
															.catch( error => {
																console.log(
																	error
																);
															} );
													}
												} );
											} else
											{
												_this.titleFive = "编辑栏目";
												_this.dialogFormVisibleFive = true;
												$( "#lan_xx" ).hide();
												let urls =
													_this.APIurl.API.api
														.father_column;
												var paramsk = {};
												if ( _this.$route.query.editId ){
													paramsk = {
														id:
															_this.$route.query
																.editId
													};
												} else{
													paramsk = {
														id: sessionStorage.getItem(
															"theMeetingId"
														)
													};
												}
												_this
													.$get( urls, paramsk )
													.then( res => {
														_this.fu_lan =
															res.posts;
													} );
												/* 获取父栏目 */
												let urlmm =
													"/ac1/conference/column/topList";
												var paramsmm = {};
												if ( _this.$route.query.editId ){
													paramsmm = {
														conference_id:
															_this.$route.query
																.editId
													};
												} else{
													paramsmm = {
														conference_id: sessionStorage.getItem(
															"theMeetingId"
														)
													};
												}
												_this
													.$get( urlmm, paramsmm )
													.then( res => {
														console.log( res );
														_this.fu_lans =
															res.posts;
													} );
												if ( data.type == 5 ){
													setTimeout( function () {
														$( "#lan_xx" ).show();
													}, 0 );
												}
												//栏目详情
												let url =
													_this.APIurl.API.api.lan_mu;
												let params = {
													id: data.id,
													type: data.type
												};
												_this
													.$get( url, params )
													.then( res => {
														console.log( res );
														if ( res.code == "1" )
														{
															let dataFrm =
																res.posts;
															/* 赋值父栏目 */
															var cnumbers = Number(
																dataFrm.column_pid
															);
															if (
																dataFrm.column_pid !=
																""
															)
															{
																_this.couponSelecteds = cnumbers;
																_this.lian_d = true;
															} else
															{
																_this.couponSelecteds =
																	"";
																_this.lian_d = false;
															}
															/* 赋值父id */
															var cnumber = Number(
																dataFrm.pid
															);
															if (
																dataFrm.pid !=
																""
															)
															{
																_this.couponSelected = cnumber;
																_this.lan_d = true;
															} else
															{
																_this.couponSelected =
																	"";
																_this.lan_d = false;
															}
															if (
																dataFrm.icon_id !=
																""
															)
															{
																$(
																	"#columnIcon_img"
																).css(
																	"display",
																	"block"
																);
																$(
																	"#columnIcon_img"
																).attr(
																	"src",
																	dataFrm.icon_url
																);
																_this.icon_id =
																	dataFrm.icon_id;
															} else
															{
																$(
																	"#columnIcon_img"
																).hide();
															}
															if (
																dataFrm.column_icon_id !=
																""
															)
															{
																$(
																	"#columnIcon_imgs"
																).css(
																	"display",
																	"block"
																);
																$(
																	"#columnIcon_imgs"
																).attr(
																	"src",
																	dataFrm.column_icon_url
																);
																_this.lanicon_id =
																	dataFrm.column_icon_id;
															} else
															{
																$(
																	"#columnIcon_imgs"
																).hide();
															}

															$(
																"#demosGuests"
															).css(
																"display",
																"block"
															);
															$(
																"#demosGuests"
															).attr(
																"src",
																dataFrm.video_cover_url
															);
															$(
																"#mh_demosGuests"
															).attr(
																"src",
																dataFrm.video_cover_url
															);
															_this.contenthave =
																dataFrm.content;
															var anumber = Number(
																dataFrm.video_id
															);
															_this.video_id = anumber;
															/* 赋值是否公开 */
															var bnumber = String(
																dataFrm.is_public
															);
															if (
																res.posts
																	.type ==
																"10" ||
																res.posts
																	.type ==
																"11"
															)
															{
																_this.out_peoples = bnumber;
															}

															_this.video_cover_url = $(
																"#demosGuests"
															).attr( "src" );
															_this.meet_video_cover_url = $(
																"#mh_demosGuests"
															).attr( "src" );
															dataFrm.publish_time = moment
																.unix(
																	dataFrm.publish_time
																)
																.format(
																	"YYYY-MM-DD HH:mm:ss"
																);
															editId =
																res.posts.id;
															if (
																res.posts
																	.type == "1"
															)
															{
																$(
																	"#synchronizeWeChat"
																).css(
																	"display",
																	"block"
																);
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#lan_x"
																).show();
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#jiejian"
																).show();
																$(
																	"#fathers"
																).show();
																$(
																	"#father"
																).show();
																$(
																	"#attachments"
																).hide();
																$(
																	"#lan_time"
																).show();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type == "2"
															)
															{
																$(
																	"#synchronizeWeChat"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#lan_x"
																).hide();
																$(
																	"#fathers"
																).show();
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#attachments"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type == "3"
															)
															{
																$(
																	"#attachments"
																).css(
																	"display",
																	"block"
																);
																$(
																	"#synchronizeWeChat"
																).show();
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"block"
																);
																$(
																	"#lan_x"
																).hide();
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#fathers"
																).show();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#father"
																).show();
																$(
																	"#attachments"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type == "4"
															)
															{
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#attachments"
																).css(
																	"display",
																	"block"
																);
																$(
																	"#synchronizeWeChat"
																).css(
																	"display",
																	"none"
																);

																$(
																	"#lan_x"
																).hide();
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#fathers"
																).show();
																$(
																	"#ship"
																).hide();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type == "5"
															)
															{
																$(
																	"#lan_xx"
																).show();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#attachments"
																).hide();
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#synchronizeWeChat"
																).show();
																$(
																	"#lan_x"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#fathers"
																).show();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type == "9"
															)
															{
																$(
																	"#synchronizeWeChat"
																).show();
																$(
																	"#attachments"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#lan_x"
																).hide();
																$(
																	"#fathers"
																).show();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type ==
																"10"
															)
															{
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#attachments"
																).hide();
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#synchronizeWeChat"
																).show();
																$(
																	"#lan_x"
																).hide();
																$(
																	"#out_people"
																).show();
																$(
																	"#ship"
																).hide();
																$(
																	"#ziliao"
																).show();
																$(
																	"#fathers"
																).show();
																$(
																	".sp_img"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type ==
																"11"
															)
															{
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#jiejian"
																).show();
																$(
																	"#attachments"
																).hide();
																$(
																	"#synchronizeWeChat"
																).show();
																$(
																	"#lan_x"
																).hide();
																$(
																	"#out_people"
																).show();
																$(
																	"#ship"
																).show();
																$(
																	"#fathers"
																).show();
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).show();
																$(
																	"#father"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type ==
																"13"
															)
															{
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#attachments"
																).hide();
																$(
																	"#synchronizeWeChat"
																).show();
																$(
																	"#lan_x"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#skipLinks"
																).show();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	"#fathers"
																).hide();
																$(
																	"#fxy"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															} else if (
																res.posts
																	.type ==
																"14"
															)
															{
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#attachments"
																).hide();
																$(
																	"#synchronizeWeChat"
																).hide();
																$(
																	"#lan_x"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#skipLinks"
																).hide();
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#fathers"
																).hide();
																$(
																	"#lan_time"
																).show();
																$(
																	"#fxy"
																).show();
																$(
																	".icon"
																).hide();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																)
																	.html( `直播开始时间
            <i style="color:red">*</i>`);
																_this.zhibo = true;
															} else
															{
																$(
																	"#attachments"
																).hide();
																$(
																	"#fathers"
																).show();
																$(
																	"#jiejian"
																).hide();
																$(
																	"#lan_xx"
																).hide();
																$(
																	"#synchronizeWeChat"
																).hide();
																$(
																	"#lan_x"
																).hide();
																$(
																	"#out_people"
																).hide();
																$(
																	"#ship"
																).hide();
																$(
																	"#skipLinks"
																).css(
																	"display",
																	"none"
																);
																$(
																	"#ziliao"
																).hide();
																$(
																	".sp_img"
																).hide();
																$(
																	"#father"
																).hide();
																$(
																	"#lan_time"
																).hide();
																$(
																	".icon"
																).show();
																$(
																	"#paixu"
																).show();
																$(
																	"#lan_time label"
																).html( `发布时间
            <i style="color:red">*</i>`);
																_this.zhibo = false;
															}
															if (
																res.posts
																	.type == "5"
															)
															{
																for (
																	let m = 0;
																	m <
																	dataFrm
																		.guest
																		.length;
																	m++
																)
																{
																	var asb =
																		dataFrm
																			.guest[
																		m
																		];
																	_this.ids.push(
																		asb
																	);
																}
																table.render( {
																	elem:
																		"#test_jiabin",
																	data:
																		dataFrm.guest,

																	request: {
																		statusName:
																			"status", //规定数据状态的字段名称，默认：code
																		statusCode: 200, //规定成功的状态码，默认：0
																		msgName:
																			"hint", //规定状态信息的字段名称，默认：msg
																		countName:
																			"total", //规定数据总数的字段名称，默认：count
																		dataName:
																			"rows" //规定数据列表的字段名称，默认：data
																	},

																	cols: [
																		[
																			//设置数据表格表头
																			{
																				field:
																					"head_img",
																				title:
																					"嘉宾头像",
																				templet:
																					'<div><img src="{{d.head_img}}"></div>'
																			},
																			{
																				field:
																					"name",
																				title:
																					"姓名"
																			},
																			{
																				field:
																					"tel",
																				title:
																					"电话"
																			},
																			{
																				field:
																					"ssapid",
																				title:
																					"ssapid"
																			},
																			{
																				field:
																					"description",
																				title:
																					"简介",
																				width: 140
																			},
																			{
																				field:
																					"company",
																				title:
																					"研究领域",
																				width: 140
																			},
																			{
																				fixed:
																					"right",
																				title:
																					"操作",
																				toolbar:
																					"#bar_jiabin"
																			}
																		]
																	],
																	page: true
																} );
															}

															/* 赋值附件 */
															if (
																res.posts
																	.type == "4"
															)
															{
																_this.file_url =
																	dataFrm.file_url;
																$( "#fufu" )
																	.append( `
                               <ul>   <li tabindex="0" class="el-upload-list__item is-success"><!----><a class="el-upload-list__item-name"><i class="el-icon-document"></i>${ dataFrm.file_title }
                              </a><label class="el-upload-list__item-status-label"><i class="el-icon-upload-success el-icon-circle-check"></i></label></li>    </ul>
                               `);
															}
															/* 赋值上传资料 */

															if (
																res.posts
																	.type ==
																"10"
															)
															{
																for (
																	let d = 0;
																	d <
																	dataFrm
																		.file_array
																		.length;
																	d++
																)
																{
																	var d_f =
																		dataFrm
																			.file_array[
																		d
																		];
																	_this.file_ids.push(
																		d_f.id
																	);
																	$(
																		"#ziliao_file"
																	).append( `
                               <ul>
                               <li tabindex="0" class="el-upload-list__item is-success"><!----><a class="el-upload-list__item-name"><i class="el-icon-document"></i>${ d_f.title }
                              </a><label class="el-upload-list__item-status-label"><i class="el-icon-upload-success el-icon-circle-check"></i></label></li>   </ul>
                               `);
																}
															}
															form.val(
																"dataColumn",
																dataFrm
															);
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													} )
													.catch( error => {
														console.log( error );
													} );
											}
										} else if (
											layEvent === "columnmanagementabdel"
										){
											layer.confirm(
												"确定删除此行么",
												function ( index ) {
													//向服务端发送删除指令
													let url =
														_this.APIurl.API.api
															.lan_del;
													let params = {
														id: data.id
													};
													_this
														.$delet( url, params )
														.then( res => {
															if (
																parseInt(
																	res.code
																) === 1
															)
															{
																_this.$message( {
																	message:
																		"删除成功",
																	type:
																		"success",
																	duration: 1000
																} );
																obj.del(); //删除对应行（tr）的DOM结构，并更新缓存
																layer.close(
																	index
																);
																if (
																	_this.$route
																		.query
																		.editId
																)
																{
																	let url =
																		_this
																			.APIurl
																			.API
																			.api
																			.column_list;
																	let params = {
																		id:
																			_this
																				.$route
																				.query
																				.editId
																	};
																	_this
																		.$get(
																			url,
																			params
																		)
																		.then(
																			res => {
																				var q_arr = [];
																				var val =
																					res.posts;
																				for (
																					let k = 0;
																					k <
																					val.length;
																					k++
																				)
																				{
																					var li_val =
																						val[
																						k
																						];
																					q_arr.push(
																						li_val
																					);
																					if (
																						li_val.type ==
																						2 ||
																						li_val.type ==
																						13
																					)
																					{
																						for (
																							let c = 0;
																							c <
																							li_val
																								.child
																								.length;
																							c++
																						)
																						{
																							var child =
																								li_val
																									.child[
																								c
																								];
																							var obj = {
																								id:
																									child.id,
																								title:
																									"&nbsp;└─&nbsp;&nbsp;" +
																									child.title,
																								pid:
																									li_val.title,
																								type:
																									child.type,
																								status:
																									child.status
																							};
																							q_arr.push(
																								obj
																							);
																							var childs =
																								li_val
																									.child[
																									c
																								]
																									.child;
																							if (
																								childs
																							)
																							{
																								for (
																									let sx = 0;
																									sx <
																									childs.length;
																									sx++
																								)
																								{
																									var child_li =
																										childs[
																										sx
																										];
																									var objkr = {
																										id:
																											child_li.id,
																										title:
																											"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└─&nbsp;&nbsp;" +
																											child_li.title,
																										pid:
																											child.title,
																										type:
																											child_li.type,
																										status:
																											child_li.status,
																										display:
																											child_li.display,
																										share_show:
																											child_li.share_show
																									};
																									q_arr.push(
																										objkr
																									);
																								}
																							}
																						}
																					}
																				}
																				columnmanagementables = table.render(
																					{
																						elem:
																							"#columnmanagementables",
																						data: q_arr,
																						cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																						cols: [
																							[
																								{
																									field:
																										"title",
																									title:
																										"栏目名称"
																								},
																								{
																									field:
																										"type",
																									title:
																										"栏目类型",
																									templet: function (
																										res
																									) {
																										if (
																											res.type ==
																											"1"
																										)
																										{
																											return "内容单页";
																										} else if (
																											res.type ==
																											"2"
																										)
																										{
																											return "内容列表";
																										} else if (
																											res.type ==
																											"3"
																										)
																										{
																											return "跳转链接";
																										} else if (
																											res.type ==
																											"4"
																										)
																										{
																											return "附件下载";
																										} else if (
																											res.type ==
																											"5"
																										)
																										{
																											return "关联嘉宾";
																										} else if (
																											res.type ==
																											"6"
																										)
																										{
																											return "会议详情";
																										} else if (
																											res.type ==
																											"7"
																										)
																										{
																											return "我的报名";
																										} else if (
																											res.type ==
																											"8"
																										)
																										{
																											return "发票开票";
																										} else if (
																											res.type ==
																											"9"
																										)
																										{
																											return "会后-媒体报道";
																										} else if (
																											res.type ==
																											"10"
																										)
																										{
																											return "会后-会议资料";
																										} else if (
																											res.type ==
																											"11"
																										)
																										{
																											return "会后会议回顾";
																										} else if (
																											res.type ==
																											"12"
																										)
																										{
																											return "查找座位";
																										} else if (
																											res.type ==
																											"13"
																										)
																										{
																											return "顶级栏目";
																										}
																									}
																								},
																								{
																									field:
																										"status",
																									title:
																										"状态",
																									templet: function (
																										res
																									) {
																										return res.status ==
																											1
																											? "正常"
																											: "禁用";
																									}
																								},
																								{
																									fixed:
																										"right",
																									title:
																										"操作",
																									toolbar:
																										"#columnmanagementableDemo",
																									width: 140
																								}
																							]
																						],
																						page: false,
																						limit:
																							q_arr.length
																					}
																				);
																			}
																		);
																} else
																{
																	let url =
																		_this
																			.APIurl
																			.API
																			.api
																			.column_list;
																	let params = {
																		id: sessionStorage.getItem(
																			"theMeetingId"
																		)
																	};
																	_this
																		.$get(
																			url,
																			params
																		)
																		.then(
																			res => {
																				var q_arr = [];
																				var val =
																					res.posts;
																				for (
																					let k = 0;
																					k <
																					val.length;
																					k++
																				)
																				{
																					var li_val =
																						val[
																						k
																						];
																					q_arr.push(
																						li_val
																					);
																					if (
																						li_val.type ==
																						2 ||
																						li_val.type ==
																						13
																					)
																					{
																						for (
																							let c = 0;
																							c <
																							li_val
																								.child
																								.length;
																							c++
																						)
																						{
																							var child =
																								li_val
																									.child[
																								c
																								];
																							var obj = {
																								id:
																									child.id,
																								title:
																									"&nbsp;└─&nbsp;&nbsp;" +
																									child.title,
																								pid:
																									li_val.title,
																								type:
																									child.type,
																								status:
																									child.status
																							};
																							q_arr.push(
																								obj
																							);
																							var childs =
																								li_val
																									.child[
																									c
																								]
																									.child;
																							if (
																								childs
																							)
																							{
																								for (
																									let sx = 0;
																									sx <
																									childs.length;
																									sx++
																								)
																								{
																									var child_li =
																										childs[
																										sx
																										];
																									var objkr = {
																										id:
																											child_li.id,
																										title:
																											"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└─&nbsp;&nbsp;" +
																											child_li.title,
																										pid:
																											child.title,
																										type:
																											child_li.type,
																										status:
																											child_li.status,
																										display:
																											child_li.display,
																										share_show:
																											child_li.share_show
																									};
																									q_arr.push(
																										objkr
																									);
																								}
																							}
																						}
																					}
																				}
																				columnmanagementables = table.render(
																					{
																						elem:
																							"#columnmanagementables",

																						data: q_arr,
																						where: {
																							id: sessionStorage.getItem(
																								"theMeetingId"
																							)
																						}, //_this.theMeetingId

																						cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																						cols: [
																							[
																								{
																									field:
																										"title",
																									title:
																										"栏目名称"
																								},
																								{
																									field:
																										"type",
																									title:
																										"栏目类型",
																									templet: function (
																										res
																									) {
																										if (
																											res.type ==
																											"1"
																										)
																										{
																											return "内容单页";
																										} else if (
																											res.type ==
																											"2"
																										)
																										{
																											return "内容列表";
																										} else if (
																											res.type ==
																											"3"
																										)
																										{
																											return "跳转链接";
																										} else if (
																											res.type ==
																											"4"
																										)
																										{
																											return "附件下载";
																										} else if (
																											res.type ==
																											"5"
																										)
																										{
																											return "关联嘉宾";
																										} else if (
																											res.type ==
																											"6"
																										)
																										{
																											return "会议详情";
																										} else if (
																											res.type ==
																											"7"
																										)
																										{
																											return "我的报名";
																										} else if (
																											res.type ==
																											"8"
																										)
																										{
																											return "发票开票";
																										} else if (
																											res.type ==
																											"9"
																										)
																										{
																											return "会后-媒体报道";
																										} else if (
																											res.type ==
																											"10"
																										)
																										{
																											return "会后-会议资料";
																										} else if (
																											res.type ==
																											"11"
																										)
																										{
																											return "会后会议回顾";
																										} else if (
																											res.type ==
																											"12"
																										)
																										{
																											return "查找座位";
																										} else if (
																											res.type ==
																											"13"
																										)
																										{
																											return "顶级栏目";
																										}
																									}
																								},
																								{
																									field:
																										"status",
																									title:
																										"状态",
																									templet: function (
																										res
																									) {
																										return res.status ==
																											1
																											? "正常"
																											: "禁用";
																									}
																								},
																								{
																									fixed:
																										"right",
																									title:
																										"操作",
																									toolbar:
																										"#columnmanagementableDemo",
																									width: 140
																								}
																							]
																						],
																						page: false,
																						limit:
																							q_arr.length
																					}
																				);
																			}
																		);
																}
															} else
															{
																if (
																	res.msg ==
																	"参数错误：！"
																)
																{
																	layer.msg(
																		"删除错误"
																	);
																	return false;
																} else if (
																	res.msg ==
																	"不支持删除此状态的会议"
																)
																{
																	layer.msg(
																		"不支持删除此状态的会议!"
																	);
																	return false;
																} else
																{
																	layer.msg(
																		"无法删除！"
																	);
																	return false;
																}
															}
														} )
														.catch( error => {
															console.log( error );
														} );
												}
											);
										}
									}
								);
								/*3.保存栏目*/
								form.on( "submit(saveNewcolumn)", function (
									data
								) {
									if ( _this.$route.query.editId ){
										var params;
										let url = _this.APIurl.API.api.lan_save;
										if (
											$(
												"#columnTypes option:selected"
											).val() == "1"
										){
											//内容单页编辑
											params = {
												id: editId,
												pid: String(
													_this.couponSelected
												),
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												/* 这 */
												content: _this.contenthave,
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,
												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "2"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "3"
										){
											params = {
												id: editId,
												pid: String(
													_this.couponSelected
												),
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												jump_url: data.field.jump_url,
												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "4"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												file_url: _this.file_url,
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "5"
										){
											var datas =
												table.cache["test_jiabin"];
											var jiabin_arr = [];
											for (
												let i = 0;
												i < datas.length;
												i++
											){
												jiabin_arr.push( datas[i].id );
											}
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												guest_ids: jiabin_arr,
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "10"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												file_ids: _this.file_ids,
												is_public: _this.out_peoples,
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "11"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,
												title_name:
													data.field.title_name,
												content: _this.contenthave,
												list_order:
													data.field.list_order,
												status: "1",
												is_public: _this.out_peoples,
												video_cover_url:
													_this.video_cover_url,
												video_id: String(
													_this.video_id
												),
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "13"
										){
											params = {
												id: editId,
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												jump_url: data.field.jump_url,
												type: data.field.type,
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,
												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "14"
										){
											params = {
												id: editId,
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												author: data.field.author,
												keyword: data.field.keyword,
												type: data.field.type,
												icon_id: _this.icon_id,
												video_cover_url:
													_this.meet_video_cover_url,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												status: "1",
												share_show:
													data.field.share_show,
												list_order:
													data.field.list_order,
												play_status:
													data.field.play_status
											};
										} else
										{
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										}
										_this
											.$post( url, params )
											.then( res => {
												if ( res.code == "1" ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													_this.ids = [];
													_this.fujian_file();
													_this.file_top();
													_this.fu_lan = [];
													_this.fu_lans = [];
													_this.couponSelected = "";
													_this.couponSelecteds = "";
													editId = "";
													// $("#demokk").text("");
													/*关闭弹出层*/
													_this.dialogFormVisibleFive = false;

													/*刷新数据表格*/
													let url =
														_this.APIurl.API.api
															.column_list;
													let params = {
														id:
															_this.$route.query
																.editId
													};
													_this
														.$get( url, params )
														.then( res => {
															var q_arr = [];
															var val = res.posts;
															for (
																let k = 0;
																k < val.length;
																k++
															)
															{
																var li_val =
																	val[k];
																q_arr.push(
																	li_val
																);
																if (
																	li_val.type ==
																	2 ||
																	li_val.type ==
																	13
																)
																{
																	for (
																		let c = 0;
																		c <
																		li_val
																			.child
																			.length;
																		c++
																	)
																	{
																		var child =
																			li_val
																				.child[
																			c
																			];
																		var obj = {
																			id:
																				child.id,
																			title:
																				"&nbsp;└─&nbsp;&nbsp;" +
																				child.title,
																			pid:
																				li_val.title,
																			type:
																				child.type,
																			status:
																				child.status,
																			display:
																				child.display,
																			share_show:
																				child.share_show,
																			is_full:
																				child.is_full
																		};
																		q_arr.push(
																			obj
																		);
																		var childs =
																			li_val
																				.child[
																				c
																			]
																				.child;
																		if (
																			childs
																		)
																		{
																			for (
																				let sx = 0;
																				sx <
																				childs.length;
																				sx++
																			)
																			{
																				var child_li =
																					childs[
																					sx
																					];
																				var objkr = {
																					id:
																						child_li.id,
																					title:
																						"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└─&nbsp;&nbsp;" +
																						child_li.title,
																					pid:
																						child.title,
																					type:
																						child_li.type,
																					status:
																						child_li.status,
																					display:
																						child_li.display,
																					share_show:
																						child_li.share_show,
																					is_full:
																						child_li.is_full
																				};
																				q_arr.push(
																					objkr
																				);
																			}
																		}
																	}
																}
															}
															columnmanagementables = table.render(
																{
																	elem:
																		"#columnmanagementables",
																	data: q_arr,

																	where: {
																		id:
																			_this
																				.$route
																				.query
																				.editId
																	},

																	cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																	cols: [
																		[
																			// { field: "id", title: "排序" },
																			{
																				field:
																					"title",
																				title:
																					"栏目名称"
																			},
																			{
																				field:
																					"type",
																				title:
																					"栏目类型",
																				templet: function (
																					res
																				) {
																					if (
																						res.type ==
																						"1"
																					)
																					{
																						return "内容单页";
																					} else if (
																						res.type ==
																						"2"
																					)
																					{
																						return "内容列表";
																					} else if (
																						res.type ==
																						"3"
																					)
																					{
																						return "跳转链接";
																					} else if (
																						res.type ==
																						"4"
																					)
																					{
																						return "附件下载";
																					} else if (
																						res.type ==
																						"5"
																					)
																					{
																						return "关联嘉宾";
																					} else if (
																						res.type ==
																						"6"
																					)
																					{
																						return "会议详情";
																					} else if (
																						res.type ==
																						"7"
																					)
																					{
																						return "我的报名";
																					} else if (
																						res.type ==
																						"8"
																					)
																					{
																						return "发票开票";
																					} else if (
																						res.type ==
																						"9"
																					)
																					{
																						return "会后-媒体报道";
																					} else if (
																						res.type ==
																						"10"
																					)
																					{
																						return "会后-会议资料";
																					} else if (
																						res.type ==
																						"11"
																					)
																					{
																						return "会后会议回顾";
																					} else if (
																						res.type ==
																						"12"
																					)
																					{
																						return "查找座位";
																					} else if (
																						res.type ==
																						"13"
																					)
																					{
																						return "顶级栏目";
																					} else if (
																						res.type ==
																						"14"
																					)
																					{
																						return "图文直播";
																					}
																				}
																			},

																			{
																				field:
																					"status",
																				title:
																					"状态",
																				templet: function (
																					res
																				) {
																					return res.status ==
																						1
																						? "正常"
																						: "禁用";
																				}
																			},
																			{
																				field:
																					"display",
																				title:
																					"是否在会议详情页显示",
																				templet: function (
																					res
																				) {
																					return res.display ==
																						1
																						? "显示"
																						: "不显示";
																				}
																			},
																			{
																				field:
																					"share_show",
																				title:
																					"是否在分享页显示",
																				templet: function (
																					res
																				) {
																					return res.share_show ==
																						1
																						? "显示"
																						: "不显示";
																				}
																			},
																			{
																				fixed:
																					"right",
																				title:
																					"操作",
																				toolbar:
																					"#columnmanagementableDemo",
																				width: 140
																			}
																		]
																	],
																	page: false,
																	limit:
																		q_arr.length
																}
															);
														} );
													$( "#newcolumn" )[0].reset();
													table.reload( "test_jiabin" );
												} else{
													_this.$message( {
														message: res.msg,
														type: "warning"
													} );
												}
											} )
											.catch( error => {
												_this.$message( {
													message: error,
													type: "danger"
												} );
											} );
									} else{
										var params;
										let url = _this.APIurl.API.api.lan_save;
										if (
											$(
												"#columnTypes option:selected"
											).val() == "1"
										){
											//内容单页编辑
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												pid: String(
													_this.couponSelected
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												content: _this.contenthave,
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "2"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "3"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												jump_url: data.field.jump_url,
												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "4"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												file_url: _this.file_url,
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "5"
										){
											var datas =
												table.cache["test_jiabin"];
											var jiabin_arr = [];
											for (
												let i = 0;
												i < datas.length;
												i++
											){
												jiabin_arr.push( datas[i].id );
											}
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												guest_ids: jiabin_arr,
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "10"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												file_ids: _this.file_ids,
												is_public: _this.out_peoples,
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "11"
										){
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												is_public: _this.out_peoples,
												video_cover_url:
													_this.video_cover_url,
												video_id: String(
													_this.video_id
												),
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "13"
										){
											params = {
												id: editId,
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												jump_url: data.field.jump_url,
												type: data.field.type,
												icon_id: _this.icon_id,
												title_name:
													data.field.title_name,
												content: _this.contenthave,
												column_icon_id:
													_this.lanicon_id,
												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show,
												is_full: data.field.is_full
											};
										} else if (
											$(
												"#columnTypes option:selected"
											).val() == "14"
										){
											params = {
												id: editId,
												conference_id:
													_this.$route.query.editId,
												title: data.field.title,
												type: data.field.type,
												icon_id: _this.icon_id,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												status: "1",
												video_cover_url:
													_this.meet_video_cover_url,
												share_show:
													data.field.share_show,
												list_order:
													data.field.list_order,
												play_status:
													data.field.play_status
											};
										} else
										{
											params = {
												id: editId,
												column_pid: String(
													_this.couponSelecteds
												),
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												),
												title: data.field.title,
												type: data.field.type,
												publish_time: _this.get_time(
													new Date(
														data.field.publish_time
													)
												),
												icon_id: _this.icon_id,
												column_icon_id:
													_this.lanicon_id,

												list_order:
													data.field.list_order,
												status: "1",
												display: data.field.display,
												share_show:
													data.field.share_show
											};
										}

										_this
											.$post( url, params )
											.then( res => {
												if ( res.code == "1" ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													_this.ids = [];
													_this.fujian_file();
													_this.file_top();
													editId = "";
													_this.fu_lan = [];
													_this.fu_lans = [];
													_this.couponSelected = "";
													_this.couponSelecteds = "";
													// $("#demokk").text("");
													_this.file_ids = [];
													/* 获取父栏目 */

													/*关闭弹出层*/
													_this.dialogFormVisibleFive = false;
													/*刷新数据表格*/
													let url =
														_this.APIurl.API.api
															.column_list;
													let paramss = {
														id: sessionStorage.getItem(
															"theMeetingId"
														)
													};
													_this
														.$get( url, paramss )
														.then( res => {
															var q_arr = [];
															var val = res.posts;
															for (
																let k = 0;
																k < val.length;
																k++
															)
															{
																var li_val =
																	val[k];
																q_arr.push(
																	li_val
																);
																if (
																	li_val.type ==
																	2 ||
																	li_val.type ==
																	13
																)
																{
																	for (
																		let c = 0;
																		c <
																		li_val
																			.child
																			.length;
																		c++
																	)
																	{
																		var child =
																			li_val
																				.child[
																			c
																			];
																		var obj = {
																			id:
																				child.id,
																			title:
																				"&nbsp;└─&nbsp;&nbsp;" +
																				child.title,
																			pid:
																				li_val.title,
																			type:
																				child.type,
																			status:
																				child.status,
																			display:
																				child.display,
																			share_show:
																				child.share_show
																		};
																		q_arr.push(
																			obj
																		);
																		var childs =
																			li_val
																				.child[
																				c
																			]
																				.child;
																		if (
																			childs
																		)
																		{
																			for (
																				let sx = 0;
																				sx <
																				childs.length;
																				sx++
																			)
																			{
																				var child_li =
																					childs[
																					sx
																					];
																				var objkr = {
																					id:
																						child_li.id,
																					title:
																						"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;└─&nbsp;&nbsp;" +
																						child_li.title,
																					pid:
																						child.title,
																					type:
																						child_li.type,
																					status:
																						child_li.status,
																					display:
																						child_li.display,
																					share_show:
																						child_li.share_show
																				};
																				q_arr.push(
																					objkr
																				);
																			}
																		}
																	}
																}
															}
															columnmanagementables = table.render(
																{
																	elem:
																		"#columnmanagementables",

																	data: q_arr,
																	where: {
																		id: sessionStorage.getItem(
																			"theMeetingId"
																		)
																	},

																	cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
																	cols: [
																		[
																			// { field: "id", title: "排序" },
																			{
																				field:
																					"title",
																				title:
																					"栏目名称"
																			},
																			{
																				field:
																					"type",
																				title:
																					"栏目类型",
																				templet: function (
																					res
																				) {
																					if (
																						res.type ==
																						"1"
																					)
																					{
																						return "内容单页";
																					} else if (
																						res.type ==
																						"2"
																					)
																					{
																						return "内容列表";
																					} else if (
																						res.type ==
																						"3"
																					)
																					{
																						return "跳转链接";
																					} else if (
																						res.type ==
																						"4"
																					)
																					{
																						return "附件下载";
																					} else if (
																						res.type ==
																						"5"
																					)
																					{
																						return "关联嘉宾";
																					} else if (
																						res.type ==
																						"6"
																					)
																					{
																						return "会议详情";
																					} else if (
																						res.type ==
																						"7"
																					)
																					{
																						return "我的报名";
																					} else if (
																						res.type ==
																						"8"
																					)
																					{
																						return "发票开票";
																					} else if (
																						res.type ==
																						"9"
																					)
																					{
																						return "会后-媒体报道";
																					} else if (
																						res.type ==
																						"10"
																					)
																					{
																						return "会后-会议资料";
																					} else if (
																						res.type ==
																						"11"
																					)
																					{
																						return "会后会议回顾";
																					} else if (
																						res.type ==
																						"12"
																					)
																					{
																						return "查找座位";
																					} else if (
																						res.type ==
																						"13"
																					)
																					{
																						return "顶级栏目";
																					} else if (
																						res.type ==
																						"14"
																					)
																					{
																						return "图文直播";
																					}
																				}
																			},

																			{
																				field:
																					"status",
																				title:
																					"状态",
																				templet: function (
																					res
																				) {
																					return res.status ==
																						1
																						? "正常"
																						: "禁用";
																				}
																			},
																			{
																				field:
																					"display",
																				title:
																					"是否在会议详情页显示",
																				templet: function (
																					res
																				) {
																					return res.display ==
																						1
																						? "显示"
																						: "不显示";
																				}
																			},
																			{
																				field:
																					"share_show",
																				title:
																					"是否在分享页显示",
																				templet: function (
																					res
																				) {
																					return res.share_show ==
																						1
																						? "显示"
																						: "不显示";
																				}
																			},
																			{
																				fixed:
																					"right",
																				title:
																					"操作",
																				toolbar:
																					"#columnmanagementableDemo",
																				width: 140
																			}
																		]
																	],
																	page: false,
																	limit:
																		q_arr.length
																}
															);
														} );
													$( "#newcolumn" )[0].reset();
													table.reload( "test_jiabin" );
												} else{
													if (
														res.msg ==
														"参数错误：！"
													){
														layer.msg(
															"请填写完整的内容"
														);
													} else{
														layer.msg(
															"请填写完整的内容"
														);
													}
												}
											} )
											.catch( error => {
												console.log( error );
											} );
									}
									return false;
								} );
								/*--------------栏目管理结束------------------*/
							} else if ( data.index == "4" )
							{
								//分享设置
								/*---------------分享管理开始-----------------*/
								// 1.获取机构模板
								let getUrl = _this.APIurl.API.api.mechanism;
								_this
									.$get( getUrl )
									.then( res => {
										if ( parseInt( res.code ) === 1 ){
											_this.organizationTemplate =
												res.posts;
										} else
										{
											_this.$message( {
												message: res.msg,
												type: "warning",
												duration: 1000
											} );
										}
									} )
									.catch( error => {
										console.log( error );
									} );

								//新建保存分享设置
								if ( _this.$route.query.editId )
								{
									//分享设置详情
									let url = _this.APIurl.API.api.mechanism_xq;
									let params = {
										id: _this.$route.query.editId
									};
									_this
										.$get( url, params )
										.then( res => {
											_this.lan_id = res.posts.id;

											if ( res.code == "1" ){
												$( "#weChatFiles_img" ).css(
													"display",
													"block"
												);
												$( "#weChatFiles_img" ).attr(
													"src",
													res.posts.background
												);
												// $("#weChatShareIcon").css("display", "block");
												// $("#weChatShareIcon").attr("src", res.posts.share_img);
												var obj = {
													template_id:
														res.posts.template_id,
													shareTitle:
														res.posts.shareTitle,
													shareDesc:
														res.posts.shareDesc,
													share_url_type:res.posts.share_url_type,
													onlineUrl: res.posts.online_url,
													sceneUrl: res.posts.scene_url,
													scene_jump_enroll_url:res.posts.scene_jump_enroll_url,
													shareImg: res.posts.shareImg,
													
												}; 
												setTimeout( function () {
													if (
														res.posts.shareImg != ""
													){
														$(
															"#shareFiles_img"
														).attr(
															"src",
															res.posts.shareImg
														);
													}
													form.val(
														"dataShareManagement",
														obj
													); //赋值表单的
												}, 0 );
											} else
											{
												console.log( res.mag );
											}
										} )
										.catch( error => {
											console.log( error );
										} );
									form.on(
										"submit(saveDataShareManagement)",
										function ( data ) {
											if ( !data.field.template_id ){
												return false;
											} else
											{
												var weChatFiles_img = $(
													"#weChatFiles_img"
												).attr( "src" );

												var weChatShareIcon = $(
													"#weChatShareIcon"
												).attr( "src" );

												var shareFiles_img = $(
													"#shareFiles_img"
												).attr( "src" );
												let url =
													_this.APIurl.API.api
														.mechanism_save;
												let params = {
													id: _this.lan_id,
													background: weChatFiles_img,
													share_img: "1",
													template_id:
														data.field.template_id,
													conference_id:
														_this.$route.query
															.editId,
													shareDesc:
														data.field.shareDesc,
													share_url_type:data.field.share_url_type,
													shareImg: shareFiles_img,
													shareTitle:
														data.field.shareTitle
												};
												if ( params.background == "" ){
													return layer.msg(
														"微信首页背景图不能为空",
														{
															time: 1000 //1秒关闭（如果不配置，默认是3秒）
														}
													);
												} else if (
													params.share_img == ""
												){
													return layer.msg(
														"微信分享图标不能为空",
														{
															time: 1000 //1秒关闭（如果不配置，默认是3秒）
														}
													);
												}
												_this
													.$post( url, params )
													.then( res => {
														if ( res.code == "1" )
														{
															_this.$message( {
																message:
																	res.msg,
																type: "success",
																duration: 1000
															} );
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 3000
															} );
														}
													} )
													.catch( error => {
														_this.$message( {
															message: res.msg,
															type: "error",
															duration: 3000
														} );
													} );
												return false;
											}
										}
									);
								} else
								{
									form.on(
										"submit(saveDataShareManagement)",
										function ( data ) {
											var weChatFiles_img = $(
												"#weChatFiles_img"
											).attr( "src" );
											// var weChatShareIcon = $("#weChatShareIcon").attr("src");

											let url =
												_this.APIurl.API.api
													.mechanism_save;
											let params = {
												id: _this.lan_id,
												background: weChatFiles_img,
												share_img: "1",
												template_id:
													data.field.template_id,
												conference_id: sessionStorage.getItem(
													"theMeetingId"
												)
											};
											if ( params.background == "" ){
												return layer.msg(
													"微信首页背景图不能为空",{
														time: 1000 //1秒关闭（如果不配置，默认是3秒）
													}
												);
											}

											_this
												.$post( url, params )
												.then( res => {
													if ( res.code == "1" ){
														_this.$message( {
															message: "保存成功",
															type: "success",
															duration: 1000
														} );
														sessionStorage.removeItem(
															"theMeetingId"
														);
														_this.$router.push(
															"/admin/MyMeeting"
														);
													} else{
														console.log( res.msg );
													}
												} )
												.catch( error => {
													console.log( error );
												} );
											return false;
										}
									);
								}

								/*---------------分享管理结束-----------------*/
								/* 权限设置 */
							}
						} );
						element.render();
						upload.render();
						laydate.render();
						form.render();
					}
				);
			} );
		},
		/* 监听会议选择类型 */
		test_type ( e ) {
			if ( e == 2 )
			{
				$( ".tig" ).show();
			} else
			{
				$( ".tig" ).hide();
			}
			if ( e == 1 )
			{
				$( "#shalong_img" ).hide();
			} else
			{
				$( "#shalong_img" ).show();
			}
		},

		/* 会议信息*/
		handlePublicss () {
			let _this = this;
			this.$nextTick( () => {
				//注意：导航 依赖 element 模块，否则无法进行功能性操作
				layui.use(
					[
						"jquery",
						"element",
						"form",
						"laydate",
						"upload",
						"layedit",
						"layer",
						"table"
					],
					function () {
						var layer = layui.layer;
						var $ = layui.jquery;
						var element = layui.element;
						var form = layui.form;
						var laydate = layui.laydate;
						var upload = layui.upload;
						var nowTime = new Date().valueOf();
						var table = layui.table;
						var layedit = layui.layedit;

						form.on( "select(fulan)" ),
							function ( data ) {
								console.log( data );
							};

						/*----------------移动端预览开始-----------------------*/
						$( "#mobilePreview" ).on( "click", function () {
							layer.open( {
								title: "存放二维码",
								content: "存放二维码"
							} );
						} );
						/*----------------移动端预览结束-----------------------*/

						/* 收费设置>住宿管理>单选监听结束 */
						/*--------------会议基本信息  省 市 区 三级联动 开始   --------------*/
						let levelLinkage = function () {
							let url = _this.APIurl.API.api.address;
							_this
								.$get( url )
								.then( res => {
									if ( parseInt( res.code ) === 1 ){
										_this.proList = res;
										let str = "";
										for ( let key in _this.proList.posts ){
											str =
												'<option value="' +
												_this.proList.posts[key].id +
												'">' +
												_this.proList.posts[key].name +
												"</option>";
											$(
												".layui-input-inline .province select"
											).append( str );
										}
										form.render( "select" );
									} else{
										_this.$message( {
											message: res.msg,
											type: "warning",
											duration: 1000
										} );
									}
								} )
								.catch( error => {
									console.log( error );
								} );
						};
						levelLinkage();
						/*城市菜单*/
						form.on( "select(province_id)", data => {
							$( ".layui-input-inline .city_id select" ).empty(); //选择省的时候清空城市地区的值
							$( ".layui-input-inline .city_id select" ).html(
								'<option value="">城市</option>'
							);
							$( ".layui-input-inline .area_id select" ).empty();
							$( ".layui-input-inline .area_id select" ).html(
								'<option value="">区/县</option>'
							);
							if ( data.value )
							{
								let str = "";
								for ( let key in _this.proList.posts[data.value]
									.items )
								{
									str =
										'<option value="' +
										_this.proList.posts[data.value].items[
											key
										].id +
										'">' +
										_this.proList.posts[data.value].items[
											key
										].name +
										"</option>";
									$(
										".layui-input-inline .city_id select"
									).append( str );
								}
								form.render( "select" );
							}
						} );
						/*区县菜单*/
						form.on( "select(city_id)", data => {
							$( ".layui-input-inline .area_id select" ).empty(); //选择市的时候清空区的值
							$( ".layui-input-inline .area_id select" ).html(
								'<option value="">区/县</option>'
							);
							if ( data.value )
							{
								let str = "";
								for ( let key in _this.proList.posts )
								{
									if (
										_this.proList.posts[key].items[
										data.value
										]
									){
										if (
											_this.proList.posts[key].items[
												data.value
											].items
										){
											for ( let i in _this.proList.posts[
												key
											].items[data.value].items ){
												str =
													'<option value="' +
													_this.proList.posts[key]
														.items[data.value]
														.items[i].id +
													'">' +
													_this.proList.posts[key]
														.items[data.value]
														.items[i].name +
													"</option>";
												$(
													".layui-input-inline .area_id select"
												).append( str );
											}
										}
									}
								}
								form.render( "select" );
							}
						} );
						/*-------------- 会议基本信息 省 市 区 三级联动 结束   --------------*/
						/*普通机构，部门树型列表二级联动*/
						let levelLinkages = function () {
							let url = "/ac1/conference/team/depTree";
							_this
								.$get( url )
								.then( res => {
									if ( parseInt( res.code ) === 1 ){
										_this.proLists = res.posts;
										let str = "";
										let strs = `<option value="">请选择</option>`;
										$(
											".layui-input-inline .provinces select"
										).append( strs );
										for ( let key in _this.proLists ){
											str = `
                      <option value="${ _this.proLists[key].id }">${ _this.proLists[key].name }</option>                      `;
											$(
												".layui-input-inline .provinces select"
											).append( str );
										}
										form.render( "select" );
									} else{
										_this.$message( {
											message: res.msg,
											type: "warning",
											duration: 1000
										} );
									}
								} )
								.catch( error => {
									console.log( error );
								} );
						};
						levelLinkages();
						/*部门菜单*/
						form.on( "select(belong_team_id)", data => {
							$( ".layui-input-inline .city_ids select" ).html( "" );
							$( ".layui-input-inline .city_ids input" ).val( "" );
							for ( let i = 0; i < _this.proLists.length; i++ )
							{
								if ( _this.proLists[i].id == data.value )
								{
									let str = "";
									for ( let key in _this.proLists[i].dep ){
										str =
											'<option value="' +
											_this.proLists[i].dep[key].id +
											'">' +
											_this.proLists[i].dep[key].name +
											"</option>";
										$(
											".layui-input-inline .city_ids select"
										).append( str );
									}
									form.render( "select" );
								}
							}
						} );
						/* refund_time */
						/* 退款时间 */
						laydate.render( {
							elem: "#refund_time",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss"
						} );

						//会议信息(举办日期范围)
						var startDate = laydate.render( {
							elem: "#startDate",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" )
								{
									date.month = date.month - 1;
									endDate.config.min = date;
								} else
								{
									endDate.config.min = startDate.config.min;
								}
							}
						} );

						var endDate = laydate.render( {
							elem: "#endDate",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" )
								{
									date.month = date.month - 1;
									startDate.config.max = date;
								} else
								{
									startDate.config.max = endDate.config.max;
								}
							}
						} );

						//会议信息(报名日期范围)
						var upTimeStart = laydate.render( {
							elem: "#upTimeStart",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" )
								{
									date.month = date.month - 1;
									upTimeEnd.config.min = date;
								} else
								{
									upTimeEnd.config.min =
										upTimeStart.config.min;
								}
							}
						} );

						var upTimeEnd = laydate.render( {
							elem: "#upTimeEnd",
							type: "datetime",
							format: "yyyy-MM-dd HH:mm:ss",
							istime: true,
							istoday: true,
							done: function ( value, date ) {
								if ( value != "" )
								{
									date.month = date.month - 1;
									upTimeStart.config.max = date;
								} else
								{
									upTimeStart.config.max =
										upTimeEnd.config.max;
								}
							}
						} );

						/* =======================================收费设置函数结束============================================ */
						//頂頂頂頂頂頂頂頂頂　頂頂頂頂頂頂頂頂頂
						//頂頂頂頂頂頂頂　　　　　頂頂
						//　　　頂頂　　　頂頂頂頂頂頂頂頂頂頂頂
						//　　　頂頂　　　頂頂頂頂頂頂頂頂頂頂頂
						//　　　頂頂　　　頂頂　　　　　　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　頂頂　　頂頂頂　　頂頂
						//　　　頂頂　　　　　　　頂頂頂
						//　　　頂頂　　　　　　頂頂　頂頂　頂頂
						//　頂頂頂頂　　　頂頂頂頂頂　頂頂頂頂頂
						//　頂頂頂頂　　　頂頂頂頂　　　頂頂頂頂
						/*----------会议基本信息表单提交开始--------------*/

						/*-----------------是否关联平行会议选择监听单选框开始-----------------------*/
						form.on( "radio(ChoiceRadio)", function ( data ) {
							if ( data.value == "1" )
							{
								$( "#participant" ).css( "display", "block" );
								$( ".associationParallel" ).css(
									"display",
									"none"
								);
							} else if ( data.value == "0" )
							{
								$( "#participant" ).css( "display", "none" );
								$( ".associationParallel" ).css(
									"display",
									"block"
								);
							}
						} );
						/* 监听是否开发票 */
						form.on( "radio(is_write_invoice)", function ( data ) {
							if ( data.value == "1" )
							{
								$( "#write" ).show();
							} else if ( data.value == "0" )
							{
								$( "#write" ).hide();
							}
						} ); /* 监听退款 */
						form.on( "radio(is_online_pay)", function ( data ) {
							if ( data.value == "1" )
							{
								$( "#tui" ).show();
							} else if ( data.value == "0" )
							{
								$( "#tui" ).hide();
							}
						} );
						/* 监听住宿管理是否收费 */
						form.on( "radio(ChoiceRadio_zhusu)", function ( data ) {
							if ( data.value == "1" )
							{
								$( "#handleRoom" ).show();
								$( "#handleRoom_hotel" ).show();
							} else if ( data.value == "0" )
							{
								$( "#handleRoom" ).hide();
								$( "#handleRoom_hotel" ).hide();
							}
						} );
						/* 监听就餐是否收费 */
						form.on( "radio(ChoiceRadio_eat)", function ( data ) {
							if ( data.value == "1" )
							{
								$( "#handleDining_a" ).show();
								$( "#handleDining_b" ).show();
							} else if ( data.value == "0" )
							{
								$( "#handleDining_a" ).hide();
								$( "#handleDining_b" ).hide();
							}
						} );
						//              新建会议基本信息保存
						form.on( "submit(saveThemeeting)", function ( data ) {
							/*  会议基本信息保存 是否是关联平行会议 params参数*/
							var params = {};
							if ( data.field.belong_team_id != "" ){
								if ( data.field.belong_dep_id != "" ){
									/* 会议基本信息保存里面的图片不能为空 */
									if ( params.logo_url == "" ){
										return layer.msg( "主办方logo不能为空", {
											time: 1000 //1秒关闭（如果不配置，默认是3秒）
										} );
									} else if ( params.cover_url == "" ){
										return layer.msg(
											"上传会议封面不能为空",
											{
												time: 1000 //1秒关闭（如果不配置，默认是3秒）
											}
										);
									} else if (
										params.vertical_cover_url == ""
									){
										return layer.msg(
											"上传会议封面不能为空",
											{
												time: 1000 //1秒关闭（如果不配置，默认是3秒）
											}
										);
									}
									let url = _this.APIurl.API.api.meetsave;
									/*iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii */
									if ( sessionStorage.getItem( "theMeetingId" ) == "" ){
										if ( $( "input[name='parallel']:checked" ).val() == "0" ){
											var checkStatus = layui.table.cache["associationParallel"];
											if ( checkStatus == undefined ){
												checkStatus = [];
											}
											for ( let i = 0; i < checkStatus.length; i++ ){
												let element = checkStatus[i];
												var okb = {
													parallel_id: element.id
												};
												_this.arrt.push( okb );
											}
											params = {
												type: _this.jbxxform.type,
												name: data.field.name,
												start_time: _this.get_time(new Date(data.field.start_time)),
												end_time: _this.get_time(new Date(data.field.end_time)),
												province_id: data.field.province_id,
												city_id: data.field.city_id,
												code: data.field.code,
												area_id: data.field.area_id,
												is_offline: data.field.is_offline,
												offline_pay_finish:data.field.offline_pay_finish,
												scene_pay_type: data.field.scene_pay_type,
												form: _this.xsarr,
												belong_dep_id: data.field.belong_dep_id,
												belong_team_id: data.field.belong_team_id,
												order_no_prefix: data.field.order_no_prefix,
												is_invoice: data.field.is_invoice,
												invoice_type: _this.invoice_type,
												jump_page: data.field.jump_page,
												logo_url: _this.logo_url,
												pc_detail_banner_url: JSON.stringify(_this.fileLists),
												informant: data.field.informant,
												informant_link: data.field.informant_link,
												previous_id:data.field.previous_id,
												previous_field:data.field.previous_field,
												longitude: data.field.longitude,
												latitude: data.field.latitude,
												is_dep: data.field.is_dep,
												is_show_price: data.field.is_show_price,
												list_display: data.field.list_display,
												cover_url: _this.cover_url,
												vertical_cover_url: _this.vertical_cover_url,
												detail: _this.detail,
												salon_cover_url: _this.salon_cover_url,
												modify_time: _this.modify_time / 1000,
												refund_endtime:_this.refund_endtime / 1000,
												modify_hour: data.field.modify_hour,
												refund_reminder:data.field.refund_reminder,
												remittance_info: _this.remittance_info,
												company: data.field.company,
												theme: data.field.theme,
												contact_name: data.field.contact_name,
												contact_address: data.field.contact_address,
												ticket_desc: data.field.ticket_desc,
												specific_address: data.field.specific_address,
												desc: _this.msgok,
												organizers: data.field.organizers,guide_company: data.field.guide_company,
												sign_location: data.field.sign_location,
												maxmember: data.field.maxmember,
												tel: data.field.tel,
												parallel: data.field.parallel,
												enroll_start_time: _this.get_time(new Date(data.field.enroll_start_time)),
												enroll_end_time: _this.get_time(new Date(data.field.enroll_end_time)),
												ticket: _this.arrt
											};
										} else if ( $( "input[name='parallel']:checked" ).val() == "1" ){
											params = {
												type: _this.jbxxform.type,
												name: data.field.name,
												start_time: _this.get_time(new Date(data.field.start_time)),
												end_time: _this.get_time(new Date(data.field.end_time)),
												province_id: data.field.province_id,
												city_id: data.field.city_id,
												area_id: data.field.area_id,
												logo_url: _this.logo_url,
												order_no_prefix: data.field.order_no_prefix,
												is_invoice: data.field.is_invoice,
												invoice_type: _this.invoice_type,
												is_offline: data.field.is_offline,
												offline_pay_finish:data.field.offline_pay_finish,
											    scene_pay_type: data.field.scene_pay_type,
												cover_url: _this.cover_url,
												vertical_cover_url: _this.vertical_cover_url,
												code: data.field.code,
												form: _this.xsarr,
												pc_detail_banner_url: JSON.stringify(_this.fileLists),
												modify_time: _this.modify_time / 1000,
												refund_endtime:_this.refund_endtime / 1000,
												modify_hour: data.field.modify_hour,
												refund_reminder:data.field.refund_reminder,
												belong_dep_id: data.field.belong_dep_id,
												belong_team_id: data.field.belong_team_id,
												jump_page: data.field.jump_page,
												is_dep: data.field.is_dep,
												is_show_price: data.field.is_show_price,
												list_display: data.field.list_display,
												longitude: data.field.longitude,
												salon_cover_url: _this.salon_cover_url,
												latitude: data.field.latitude,
												detail: _this.detail,
												remittance_info: _this.remittance_info,
												company: data.field.company,
												theme: data.field.theme,
												ticket_desc: data.field.ticket_desc,
												specific_address: data.field.specific_address,
												desc: _this.msgok,
												contact_name: data.field.contact_name,
												contact_address: data.field.contact_address,
												organizers: data.field.organizers,guide_company: data.field.guide_company,
												sign_location: data.field.sign_location,
												maxmember: data.field.maxmember,
												tel: data.field.tel,
												parallel: data.field.parallel,
												independence: data.field.independence,
												enroll_start_time: _this.get_time(new Date(data.field.enroll_start_time)),
												enroll_end_time: _this.get_time(new Date(data.field.enroll_end_time))
											};
										}
										_this
											.$post( url, params )
											.then( res => {
												if ( parseInt( res.code ) === 1 ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													_this.arrt = [];
													table.render( {
														elem:
															"#associationParallel",
														data: [], //数据
														cols: [
															[
																{
																	field:
																		"name",
																	title:
																		"会议名称"
																},
																{
																	title:
																		"是否收费",
																	templet: function (
																		d
																	) {
																		return `
                           是
                        `;
																	}
																}
															]
														],
														page: true
													} );
													_this.theMeetingId =
														res.posts.id; //会议id
													sessionStorage.setItem(
														"theMeetingId",
														_this.theMeetingId
													);
													sessionStorage.setItem(
														"conferenceId",
														_this.theMeetingId
													);
													element.tabChange(
														"myDemo",
														"222"
													); //切换tab头部的
												} else{
													_this.$message( {
														message: res.msg,
														type: "warning",
														duration: 1000
													} );
												}
											} )
											.catch( error => {
												_this.$message( {
													message: error,
													type: "error",
													duration: 1000
												} );
											} );
										return false;
									} else{
										if ( $( "input[name='parallel']:checked" ).val() == "0" ){
											var demo1 = $( "#demo1" )
												.attr( "src" )
												.split( "/" );
											var demos = $( "#demos" )
												.attr( "src" )
												.split( "/" );
											var demoimg = $( "#demos_img" )
												.attr( "src" )
												.split( "/" );
											var demoss = $( "#demoss" )
												.attr( "src" )
												.split( "/" );
											var vertical_cover_url =
												demoss[3] +
												"/" +
												demoss[4] +
												"/" +
												demoss[5];
											var logo_url =
												demo1[3] +
												"/" +
												demo1[4] +
												"/" +
												demo1[5];
											var cover_url =
												demos[3] +
												"/" +
												demos[4] +
												"/" +
												demos[5];
											var salon_cover_url =
												demoimg[3] +
												"/" +
												demoimg[4] +
												"/" +
												demoimg[5];
											var checkStatus =
												layui.table.cache[
												"associationParallel"
												];
											if ( checkStatus == undefined ){
												checkStatus = [];
											} else
											{
												for (
													let i = 0;
													i < checkStatus.length;
													i++
												){
													let element =
														checkStatus[i];
													var aid = "";
													if (
														element.parallel_id ==
														undefined
													){
														aid = element.id;
													} else{
														aid =
															element.parallel_id;
													}
													var okb = {
														parallel_id: aid
													};
													_this.arrt.push( okb );
												}
											}
											params = {
												id: sessionStorage.getItem(
													"theMeetingId"
												),
												type: _this.jbxxform.type,
												name: data.field.name,
												start_time: _this.get_time(
													new Date(
														data.field.start_time
													)
												),
												end_time: _this.get_time(
													new Date(
														data.field.end_time
													)
												),
												province_id:
													data.field.province_id,
												city_id: data.field.city_id,
												area_id: data.field.area_id,
												ticket_desc:
													data.field.ticket_desc,
												logo_url: logo_url,
												order_no_prefix: data.field.order_no_prefix,
												is_invoice: data.field.is_invoice,
												invoice_type: _this.invoice_type,
												contact_name:
													data.field.contact_name,
												contact_address:
													data.field.contact_address,
												cover_url: cover_url,
												vertical_cover_url: vertical_cover_url,
												form: _this.xsarr,
												pc_detail_banner_url: JSON.stringify(
													_this.fileLists
												),
												salon_cover_url: salon_cover_url,
												modify_time:
													_this.modify_time / 1000,
												refund_endtime:_this.refund_endtime / 1000,
												modify_hour:
													data.field.modify_hour,
												refund_reminder:data.field.refund_reminder,
												informant: data.field.informant,
												informant_link:
													data.field.informant_link,
												previous_id:data.field.previous_id,
												previous_field:data.field.previous_field,
												belong_dep_id:
													data.field.belong_dep_id,
												belong_team_id:
													data.field.belong_team_id,
												is_dep: data.field.is_dep,
												is_show_price:
													data.field.is_show_price,
												is_offline:
													data.field.is_offline,
													offline_pay_finish:data.field.offline_pay_finish,
												scene_pay_type:
												 data.field.scene_pay_type,
												list_display:
													data.field.list_display,
												longitude: data.field.longitude,
												latitude: data.field.latitude,
												detail: _this.detail,
												remittance_info:
													_this.remittance_info,
												company: data.field.company,
												theme: data.field.theme,
												specific_address:
													data.field.specific_address,
												desc: _this.msgok,
												organizers:data.field.organizers,
												guide_company: data.field.guide_company,
												sign_location:data.field.sign_location,
												maxmember: data.field.maxmember,
												tel: data.field.tel,
												parallel: data.field.parallel,
												// parallel_ids:data.field.name,
												enroll_start_time: _this.get_time(
													new Date(
														data.field.enroll_start_time
													)
												),
												enroll_end_time: _this.get_time(
													new Date(
														data.field.enroll_end_time
													)
												),
												ticket: _this.arrt
											};
										} else if ( $( "input[name='parallel']:checked" ).val() == "1" ){
											params = {
												id: sessionStorage.getItem(
													"theMeetingId"
												),
												type: _this.jbxxform.type,
												name: data.field.name,
												start_time: _this.get_time( new Date( data.field.start_time ) ),
												end_time: _this.get_time( new Date( data.field.end_time ) ),
												province_id:
													data.field.province_id,
												city_id: data.field.city_id,
												area_id: data.field.area_id,
												order_no_prefix: data.field.order_no_prefix,
												is_invoice: data.field.is_invoice,
												invoice_type: _this.invoice_type,
												ticket_desc:
													data.field.ticket_desc,
												logo_url: logo_url,
												cover_url: cover_url,
												vertical_cover_url: vertical_cover_url,
												form: _this.xsarr,
												pc_detail_banner_url: JSON.stringify(
													_this.fileLists
												),
												salon_cover_url: salon_cover_url,
												belong_dep_id:
													data.field.belong_dep_id,
												belong_team_id:
													data.field.belong_team_id,
												is_dep: data.field.is_dep,
												is_show_price:
													data.field.is_show_price,
												modify_time:
													_this.modify_time / 1000,
												refund_endtime:_this.refund_endtime / 1000,
												modify_hour:
													data.field.modify_hour,
												refund_reminder:data.field.refund_reminder,
												list_display:
													data.field.list_display,
												informant: data.field.informant,
												informant_link:
													data.field.informant_link,
												previous_id:data.field.previous_id,
												previous_field:data.field.previous_field,
												is_offline:
													data.field.is_offline,
												offline_pay_finish:data.field.offline_pay_finish,
												scene_pay_type: data.field.scene_pay_type,
												longitude: data.field.longitude,
												latitude: data.field.latitude,
												remittance_info:
													_this.remittance_info,
												company: data.field.company,
												theme: data.field.theme,
												contact_name:
													data.field.contact_name,
												contact_address:
													data.field.contact_address,
												detail: _this.detail,
												specific_address:
													data.field.specific_address,
												desc: _this.msgok,
												organizers:data.field.organizers,
												guide_company: data.field.guide_company,
												sign_location:data.field.sign_location,
												maxmember: data.field.maxmember,
												tel: data.field.tel,
												parallel: data.field.parallel,
												independence:
													data.field.independence,
												enroll_start_time: _this.get_time(
													new Date(
														data.field.enroll_start_time
													)
												),
												enroll_end_time: _this.get_time(
													new Date(
														data.field.enroll_end_time
													)
												)
											};
										}
										_this
											.$post( url, params )
											.then( res => {
												if ( parseInt( res.code ) === 1 ){
													_this.$message( {
														message: "保存成功",
														type: "success",
														duration: 1000
													} );
													/* 清空关联会议表格 */
													_this.arrt = [];
													table.render( {
														elem:
															"#associationParallel",
														data: [], //数据
														page: true, //开启分页
														cols: [
															[
																{
																	field: "name",
																	title: "会议名称"
																},
																{
																	title: "是否收费",
																	templet: function (d) {
																		return `是`;
																	}
																}
															]
														],
														page: true
													} );
													element.tabChange(
														"myDemo",
														"222"
													); //切换tab头部的
												} else{
													_this.$message( {
														message: res.msg,
														type: "warning",
														duration: 1000
													} );
												}
											} )
											.catch( error => {
												console.log( error );
											} );
										return false;
									}
								} else
								{
									_this.$message( {
										message: "请选择部门",
										duration: 1000
									} );
								}
							} else
							{
								/* 会议基本信息保存里面的图片不能为空 */
								if ( params.logo_url == "" ){
									return layer.msg( "主办方logo不能为空", {
										time: 1000 //1秒关闭（如果不配置，默认是3秒）
									} );
								} else if ( params.cover_url == "" ){
									return layer.msg( "上传会议封面不能为空", {
										time: 1000 //1秒关闭（如果不配置，默认是3秒）
									} );
								} else if ( params.vertical_cover_url == "" ){
									return layer.msg( "上传会议封面不能为空", {
										time: 1000 //1秒关闭（如果不配置，默认是3秒）
									} );
								}
								let url = _this.APIurl.API.api.meetsave;
								/*iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii */
								if (sessionStorage.getItem( "theMeetingId" ) == ""){
									if (
										$(
											"input[name='parallel']:checked"
										).val() == "0"
									){
										var checkStatus =
											layui.table.cache[
											"associationParallel"
											];
										if ( checkStatus == undefined ){
											checkStatus = [];
										}
										for (
											let i = 0;
											i < checkStatus.length;
											i++
										){
											let element = checkStatus[i];
											var okb = {
												parallel_id: element.id
											};
											_this.arrt.push( okb );
										}
										params = {
											type: _this.jbxxform.type,
											name: data.field.name,
											start_time: _this.get_time(new Date( data.field.start_time )),
											end_time: _this.get_time(new Date( data.field.end_time )),
											province_id: data.field.province_id,
											city_id: data.field.city_id,
											code: data.field.code,
											list_display:data.field.list_display,
											area_id: data.field.area_id,
											order_no_prefix: data.field.order_no_prefix,
											is_invoice: data.field.is_invoice,
											invoice_type: _this.invoice_type,
											belong_dep_id:data.field.belong_dep_id,
											belong_team_id:data.field.belong_team_id,
											jump_page: data.field.jump_page,
											is_offline: data.field.is_offline,
											offline_pay_finish:data.field.offline_pay_finish,
											scene_pay_type: data.field.scene_pay_type,
											logo_url: _this.logo_url,
											longitude: data.field.longitude,
											latitude: data.field.latitude,
											is_dep: data.field.is_dep,
											is_show_price:data.field.is_show_price,
											form: _this.xsarr,
											pc_detail_banner_url: JSON.stringify(_this.fileLists),
											modify_time: _this.modify_time / 1000,
											refund_endtime:_this.refund_endtime / 1000,
											modify_hour: data.field.modify_hour,
											refund_reminder:data.field.refund_reminder,
											cover_url: _this.cover_url,
											vertical_cover_url: _this.vertical_cover_url,
											salon_cover_url: _this.salon_cover_url,
											detail: _this.detail,
											informant: data.field.informant,
											informant_link:data.field.informant_link,
											previous_id:data.field.previous_id,
											previous_field:data.field.previous_field,
											remittance_info: _this.remittance_info,
											company: data.field.company,
											theme: data.field.theme,
											contact_name:data.field.contact_name,
											contact_address:data.field.contact_address,
											ticket_desc: data.field.ticket_desc,
											specific_address:data.field.specific_address,
											desc: _this.msgok,
											organizers: data.field.organizers,
											guide_company: data.field.guide_company,
											sign_location:data.field.sign_location,
											maxmember: data.field.maxmember,
											tel: data.field.tel,
											parallel: data.field.parallel,
											enroll_start_time: _this.get_time(new Date(data.field.enroll_start_time)),
											enroll_end_time: _this.get_time(new Date(data.field.enroll_end_time)),
											ticket: _this.arrt
										};
									} else if ( $( "input[name='parallel']:checked" ).val() == "1" ){
										params = {
											type: _this.jbxxform.type,
											name: data.field.name,
											start_time: _this.get_time(new Date( data.field.start_time )),
											end_time: _this.get_time(new Date( data.field.end_time )),
											province_id: data.field.province_id,
											city_id: data.field.city_id,
											area_id: data.field.area_id,
											logo_url: _this.logo_url,
											cover_url: _this.cover_url,
											vertical_cover_url: _this.vertical_cover_url,
											is_offline: data.field.is_offline,
											offline_pay_finish:data.field.offline_pay_finish,
											scene_pay_type: data.field.scene_pay_type,
											code: data.field.code,
											order_no_prefix: data.field.order_no_prefix,
											is_invoice: data.field.is_invoice,
											invoice_type: _this.invoice_type,
											form: _this.xsarr,
											modify_time: _this.modify_time / 1000,
											refund_endtime:_this.refund_endtime / 1000,
											modify_hour: data.field.modify_hour,
											refund_reminder:data.field.refund_reminder,
											list_display:data.field.list_display,
											belong_dep_id:data.field.belong_dep_id,
											belong_team_id:data.field.belong_team_id,
											jump_page: data.field.jump_page,
											pc_detail_banner_url: JSON.stringify(_this.fileLists),
											is_dep: data.field.is_dep,
											is_show_price:data.field.is_show_price,
											longitude: data.field.longitude,
											latitude: data.field.latitude,
											detail: _this.detail,
											salon_cover_url: _this.salon_cover_url,
											informant: data.field.informant,
											informant_link:data.field.informant_link,
											previous_id:data.field.previous_id,
											previous_field:data.field.previous_field,
											remittance_info: _this.remittance_info,
											company: data.field.company,
											theme: data.field.theme,
											ticket_desc: data.field.ticket_desc,
											specific_address:data.field.specific_address,
											desc: _this.msgok,
											contact_name:data.field.contact_name,
											contact_address:data.field.contact_address,
											organizers: data.field.organizers,
											guide_company: data.field.guide_company,
											sign_location:data.field.sign_location,
											maxmember: data.field.maxmember,
											tel: data.field.tel,
											parallel: data.field.parallel,
											independence:data.field.independence,
											enroll_start_time: _this.get_time(new Date(data.field.enroll_start_time)),
											enroll_end_time: _this.get_time(new Date(data.field.enroll_end_time))
										};
									}
									_this
										.$post( url, params )
										.then( res => {
											if ( parseInt( res.code ) === 1 ){
												_this.$message( {
													message: "保存成功",
													type: "success",
													duration: 1000
												} );
												_this.arrt = [];
												table.render( {
													elem:
														"#associationParallel",
													data: [], //数据
													cols: [
														[
															{
																field: "name",
																title:
																	"会议名称"
															},
															{
																title:
																	"是否收费",
																templet: function (d) {
																	return `是`;
																}
															}
														]
													],
													page: true
												} );
												_this.theMeetingId =
													res.posts.id; //会议id
												sessionStorage.setItem(
													"theMeetingId",
													res.posts.id
												);
												sessionStorage.setItem(
													"conferenceId",
													res.posts.id
												);
												element.tabChange(
													"myDemo",
													"222"
												); //切换tab头部的
											} else
											{
												_this.$message( {
													message: res.msg,
													type: "warning",
													duration: 1000
												} );
											}
										} )
										.catch( error => {
											_this.$message( {
												message: error,
												type: "error",
												duration: 1000
											} );
										} );
									return false;
								} else
								{
									if ( $( "input[name='parallel']:checked" ).val() == "0" ){
										var demo1 = $( "#demo1" )
											.attr( "src" )
											.split( "/" );
										var demos = $( "#demos" )
											.attr( "src" )
											.split( "/" );
										var demoimg = $( "#demos_img" )
											.attr( "src" )
											.split( "/" );
										var demoss = $( "#demoss" )
											.attr( "src" )
											.split( "/" );
										var vertical_cover_url =
											demoss[3] +
											"/" +
											demoss[4] +
											"/" +
											demoss[5];
										var logo_url =
											demo1[3] +
											"/" +
											demo1[4] +
											"/" +
											demo1[5];
										var cover_url =
											demos[3] +
											"/" +
											demos[4] +
											"/" +
											demos[5];
										var salon_cover_url =
											demoimg[3] +
											"/" +
											demoimg[4] +
											"/" +
											demoimg[5];
										var checkStatus =
											layui.table.cache[
											"associationParallel"
											];
										if ( checkStatus == undefined ){
											checkStatus = [];
										} else
										{
											for (
												let i = 0;
												i < checkStatus.length;
												i++
											){
												let element = checkStatus[i];
												var aid = "";
												if (
													element.parallel_id ==
													undefined
												){
													aid = element.id;
												} else{
													aid = element.parallel_id;
												}
												var okb = {
													parallel_id: aid
												};
												_this.arrt.push( okb );
											}
										}
										params = {
											id: sessionStorage.getItem("theMeetingId"),
											type: _this.jbxxform.type,name: data.field.name,start_time: _this.get_time(new Date( data.field.start_time )),end_time: _this.get_time(new Date( data.field.end_time )),
											province_id: data.field.province_id,
											city_id: data.field.city_id,
											area_id: data.field.area_id,
											order_no_prefix: data.field.order_no_prefix,
											is_invoice: data.field.is_invoice,
											invoice_type: _this.invoice_type,
											ticket_desc: data.field.ticket_desc,
											is_offline: data.field.is_offline,
											offline_pay_finish:data.field.offline_pay_finish,
											scene_pay_type: data.field.scene_pay_type,
											logo_url: logo_url,
											pc_detail_banner_url: JSON.stringify(_this.fileLists),
											modify_time: _this.modify_time / 1000,
											refund_endtime:_this.refund_endtime / 1000,
											modify_hour: data.field.modify_hour,
											refund_reminder:data.field.refund_reminder,
											contact_name: data.field.contact_name,
											contact_address: data.field.contact_address,
											cover_url: cover_url,
											vertical_cover_url: vertical_cover_url,
											form: _this.xsarr,
											salon_cover_url: salon_cover_url,
											belong_dep_id: data.field.belong_dep_id,
											belong_team_id: data.field.belong_team_id,
											is_dep: data.field.is_dep,
											is_show_price: data.field.is_show_price,
											list_display: data.field.list_display,
											longitude: data.field.longitude,
											latitude: data.field.latitude,
											informant: data.field.informant,
											informant_link: data.field.informant_link,
											previous_id:data.field.previous_id,
											previous_field:data.field.previous_field,
											detail: _this.detail,
											remittance_info: _this.remittance_info,
											company: data.field.company,
											theme: data.field.theme,
											specific_address: data.field.specific_address,
											desc: _this.msgok,
											organizers: data.field.organizers,
											guide_company: data.field.guide_company,
											sign_location: data.field.sign_location,
											maxmember: data.field.maxmember,
											tel: data.field.tel,
											parallel: data.field.parallel,
											// parallel_ids:data.field.name,
											enroll_start_time: _this.get_time(new Date(data.field.enroll_start_time)),
											enroll_end_time: _this.get_time(new Date(data.field.enroll_end_time)),
											ticket: _this.arrt,
											hidden_enroll_notes: data.field.hidden_enroll_notes
										};
									} else if ( $( "input[name='parallel']:checked" ).val() == "1" ){
										params = {
											id: sessionStorage.getItem("theMeetingId"),
											type: _this.jbxxform.type,name: data.field.name,start_time: _this.get_time(new Date( data.field.start_time )),end_time: _this.get_time(new Date( data.field.end_time )),
											province_id: data.field.province_id,
											city_id: data.field.city_id,
											area_id: data.field.area_id,
											ticket_desc: data.field.ticket_desc,
											logo_url: logo_url,
											cover_url: cover_url,
											vertical_cover_url: vertical_cover_url,
											form: _this.xsarr,
											order_no_prefix: data.field.order_no_prefix,
											is_invoice: data.field.is_invoice,
											invoice_type: _this.invoice_type,
											pc_detail_banner_url: JSON.stringify(_this.fileLists),
											salon_cover_url: salon_cover_url,
											modify_time: _this.modify_time / 1000,
											refund_endtime:_this.refund_endtime / 1000,
											modify_hour: data.field.modify_hour,
											refund_reminder:data.field.refund_reminder,
											is_offline: data.field.is_offline,
											offline_pay_finish:data.field.offline_pay_finish,
											scene_pay_type: data.field.scene_pay_type,
											belong_dep_id: data.field.belong_dep_id,
											belong_team_id: data.field.belong_team_id,
											is_dep: data.field.is_dep,
											is_show_price: data.field.is_show_price,
											longitude: data.field.longitude,
											latitude: data.field.latitude,
											remittance_info: _this.remittance_info,
											company: data.field.company,
											theme: data.field.theme,
											informant: data.field.informant,
											informant_link: data.field.informant_link,
											previous_id:data.field.previous_id,
											previous_field:data.field.previous_field,
											list_display: data.field.list_display,
											contact_name: data.field.contact_name,
											contact_address: data.field.contact_address,
											detail: _this.detail,
											specific_address: data.field.specific_address,
											desc: _this.msgok,
											organizers: data.field.organizers,
											guide_company: data.field.guide_company,
											sign_location: data.field.sign_location,
											maxmember: data.field.maxmember,
											tel: data.field.tel,
											parallel: data.field.parallel,
											independence: data.field.independence,
											enroll_start_time: _this.get_time(new Date(data.field.enroll_start_time)),
											enroll_end_time: _this.get_time(new Date(data.field.enroll_end_time)),
											hidden_enroll_notes: data.field.hidden_enroll_notes
										};
									}

									_this
										.$post( url, params )
										.then( res => {
											if ( parseInt( res.code ) === 1 ){
												_this.$message( {
													message: "保存成功",
													type: "success",
													duration: 1000
												} );
												/* 清空关联会议表格 */
												_this.arrt = [];
												table.render( {
													elem:
														"#associationParallel",
													data: [], //数据
													page: true, //开启分页
													cols: [
														[
															{
																field: "name",
																title: "会议名称"
															},
															{
																title: "是否收费",
																templet: function (d) {
																	return `是`;
																}
															}
														]
													],
													page: true
												} );
												element.tabChange(
													"myDemo",
													"222"
												); //切换tab头部的
											} else
											{
												_this.$message( {
													message: res.msg,
													type: "warning",
													duration: 1000
												} );
											}
										} )
										.catch( error => {
											console.log( error );
										} );
									return false;
								}
							}
						} );
						/*--------------编辑会议基本信息保存开始--------------*/
						if ( _this.$route.query.editId ){
							let url = _this.APIurl.API.api.meet_set;
							_this.fileListkk = [];
							_this.fileLists = [];
							_this.arrsurl = [];
							let params = {
								id: _this.$route.query.editId
							};
							_this
								.$get( url, params )
								.then( res => {
									if ( res.code == "1" ){
										/* 编辑进入是对第一页会议信息的数据进行显示===== */
										let dataFrm = res.posts;
										var bannerurl =
											dataFrm.conference
												.pc_detail_banner_url;
										_this.fileListkk = bannerurl;
										_this.arrsurl = bannerurl;
										if ( dataFrm.conference.parallel == 1 ){
											$( "#participant" ).show();
											$( "#pingxin" ).hide();
										} else if (
											dataFrm.conference.parallel == 0
										){
											$( "#participant" ).hide();
											$( "#pingxin" ).show();
										}
											( _this.modify_time = dataFrm.conference.modify_time * 1000 ),
											( _this.refund_endtime = dataFrm.conference.refund_endtime * 1000 ), 
											( dataFrm.conference.end_time = moment.unix(dataFrm.conference.end_time).format( "YYYY-MM-DD HH:mm:ss" ) );
											dataFrm.conference.enroll_end_time = moment.unix(dataFrm.conference.enroll_end_time).format( "YYYY-MM-DD HH:mm:ss" );
											dataFrm.conference.enroll_start_time = moment.unix(dataFrm.conference.enroll_start_time).format( "YYYY-MM-DD HH:mm:ss" );
											dataFrm.conference.start_time = moment.unix( dataFrm.conference.start_time ).format( "YYYY-MM-DD HH:mm:ss" );

										if (dataFrm.conference.area_name == undefined){
											dataFrm.conference.area_name = "";
										}
										if (dataFrm.conference.city_name == undefined){
											dataFrm.conference.city_name = "";
										}
										if (dataFrm.conference.province_name == undefined){
											dataFrm.conference.province_name = "";
										}
										if (dataFrm.conference.belong_dep_name == undefined){
											dataFrm.conference.belong_dep_name =
												"";
										}
										_this.jbxxform.type = String(
											dataFrm.conference.type
										);

										var obj = {
											//元素的name属性值：元素的value属性值
											id: dataFrm.conference.id,
											type: dataFrm.conference.type,
											name: dataFrm.conference.name,
											start_time: dataFrm.conference.start_time,
											end_time: dataFrm.conference.end_time,
											code: dataFrm.conference.code,
											jump_page: dataFrm.conference.jump_page,
											organizers: dataFrm.conference.organizers,
											guide_company: dataFrm.conference.guide_company,
											remittance_info: dataFrm.conference.remittance_info,
											sign_location: dataFrm.conference.sign_location,
											maxmember: dataFrm.conference.maxmember,
											longitude: dataFrm.conference.longitude,
											is_offline: dataFrm.conference.is_offline,
											offline_pay_finish:dataFrm.conference.offline_pay_finish,
											scene_pay_type: dataFrm.conference.scene_pay_type,
											pay_desc: dataFrm.conference.pay_desc,
											latitude: dataFrm.conference.latitude,
											order_no_prefix: dataFrm.conference.order_no_prefix,
											is_invoice: dataFrm.conference.is_invoice,
											// invoice_type: dataFrm.conference.invoice_type,
											ticket_type: dataFrm.conference.ticket_type,
											is_show_residue: dataFrm.conference.is_show_residue,
											hidden_ticket_name: dataFrm.conference.hidden_ticket_name,
											show_date_format: dataFrm.conference.show_date_format,
											conf_ticket_num: dataFrm.conference.conf_ticket_num,
											is_dep: dataFrm.conference.is_dep,
											is_show_price: dataFrm.conference.is_show_price,
											tel: dataFrm.conference.tel,
											modify_hour: dataFrm.conference.modify_hour,
											refund_reminder:dataFrm.conference.refund_reminder,
											list_display: dataFrm.conference.list_display,
											informant: dataFrm.conference.informant,
											informant_link: dataFrm.conference.informant_link,
											previous_id:dataFrm.conference.previous_id,
											previous_field:dataFrm.conference.previous_field,
											desc: dataFrm.conference.desc,
											detail: dataFrm.conference.detail,
											ticket_desc: dataFrm.conference.ticket_desc,
											province_id: dataFrm.conference.province_id,
											area_id: dataFrm.conference.area_id,
											city_id: dataFrm.conference.city_id,
											company: dataFrm.conference.company,
											theme: dataFrm.conference.theme,
											contact_name: dataFrm.conference.contact_name,
											contact_address: dataFrm.conference.contact_address,
											specific_address: dataFrm.conference.specific_address,
											parallel: dataFrm.conference.parallel,
											belong_team_id: dataFrm.conference.belong_team_id,
											belong_dep_id: dataFrm.conference.belong_dep_id,
											publish_status: dataFrm.conference.publish_status,
											enroll_end_time: dataFrm.conference.enroll_end_time,
											enroll_start_time: dataFrm.conference.enroll_start_time,
											independence: dataFrm.conference.independent,
											hidden_enroll_notes: dataFrm.conference.hidden_enroll_notes
										};
										/* 开 */
										if ( dataFrm.conference.type == 2 ){
											$( "#shalong_img" ).show();
											$( ".tig" ).show();
										} else
										{
											$( "#shalong_img" ).hide();
											$( ".tig" ).hide();
										}
										_this.msgok = dataFrm.conference.desc;
										_this.detail =
											dataFrm.conference.detail;
										_this.remittance_info =
											dataFrm.conference.remittance_info;
										_this.mapName =
											dataFrm.conference.specific_address;
										_this.longitude =
											dataFrm.conference.longitude;
										_this.latitude =
											dataFrm.conference.latitude;
										_this.xsarr = dataFrm.conference.form;
										if ( dataFrm.conference.invoice_type ){
											_this.invoice_type = dataFrm.conference.invoice_type?.map( i => Number( i ) )
										}
										if (
											dataFrm.conference
												.belong_team_name == undefined
										){
											dataFrm.conference.belong_team_name =
												"";
										}
										$( "#province_ids" ).each( function () {
											$( this )
												.children( "option" )
												.each( function () {
													// 判断需要对那个选项进行回显
													if (
														this.value ==
														dataFrm.conference
															.belong_team_id
													){
														// 进行回显
														$( this ).attr(
															"selected",
															"selected"
														);
													}
												} );
										} );
										$( "#city_idss" ).html( "" );
										$( "#city_idss" ).append(
											`
												<select
													name=" belong_dep_id"
													lay-filter="belong_dep_id"
													id="city_idss"
												>
												<option value="${ dataFrm.conference.belong_dep_id }">${ dataFrm.conference.belong_dep_name }</option>
                       						`
										);
										/* 赋值城市 */

										$( "#province_id" ).append(
											"<option value=" +
											dataFrm.conference.province_id +
											">" +
											dataFrm.conference
												.province_name +
											"</option>"
										); //赋值省
										$( "#city_id" ).append(
											"<option value=" +
											dataFrm.conference.city_id +
											">" +
											dataFrm.conference.city_name +
											"</option>"
										); //赋值市
										$( "#area_id" ).append(
											"<option value=" +
											dataFrm.conference.area_id +
											">" +
											dataFrm.conference.area_name +
											"</option>"
										); //赋值县/区

										$( "#demo1" ).attr(
											"src",
											dataFrm.conference.logo_url
										);
										$( "#demos" ).attr(
											"src",
											dataFrm.conference.cover_url
										);
										$( "#demoss" ).attr(
											"src",
											dataFrm.conference
												.vertical_cover_url
										);
										$( "#demos_img" ).attr(
											"src",
											dataFrm.conference.salon_cover_url
										);
										$( "#demo1" ).css( "display", "block" );
										$( "#demos" ).css( "display", "block" );
										$( "#demoss" ).css( "display", "block" );
										$( "#demos_img" ).css( "display", "block" );
										var checkStatuss = dataFrm.parallel;
										/* 去掉域名 */
										var okbb = {};
										var arrbl = [];
										if ( _this.arrsurl != "" ){
											for (
												let j = 0;
												j < _this.arrsurl.length;
												j++
											){
												arrbl = _this.arrsurl[
													j
												].url.split( "uploadpic" );
												okbb = {
													name: _this.arrsurl[j].name,
													url: "uploadpic" + arrbl[1]
												};
												_this.fileLists.push( okbb );
											}
										}
										table.render( {
											elem: "#associationParallel",
											data: checkStatuss, //数据
											page: true, //开启分页
											cols: [
												[{
														field: "name",
														title: "会议名称"
													},{
														title: "是否收费",
														templet: function ( d ) {
															return `是`;
														}
													}
												]
											],
											page: true
										} );
										form.val( "dataInfo", obj ); //赋值表单的
									} else{
										_this.$message( {
											message: res.msg,
											type: "warning",
											duration: 1000
										} );
									}
									/* 编辑会议表单提交时====== 平行会议平行会议*/
									form.on( "submit(saveThemeeting)", function (data) {
										var demo1 = $( "#demo1" )
											.attr( "src" )
											.split( "/" );
										var demos = $( "#demos" )
											.attr( "src" )
											.split( "/" );
										var demoimg = $( "#demos_img" )
											.attr( "src" )
											.split( "/" );
										var demoss = $( "#demoss" )
											.attr( "src" )
											.split( "/" );
										var vertical_cover_url =
											demoss[3] +
											"/" +
											demoss[4] +
											"/" +
											demoss[5];
										var logo_url =
											demo1[3] +
											"/" +
											demo1[4] +
											"/" +
											demo1[5];
										var cover_url =
											demos[3] +
											"/" +
											demos[4] +
											"/" +
											demos[5];
										var salon_cover_url =
											demoimg[3] +
											"/" +
											demoimg[4] +
											"/" +
											demoimg[5];
										var params = {};
										if ( data.field.belong_team_id != "" ){
											if (data.field.belong_dep_id != ""){
												if ($("input[name='parallel']:checked").val() == "0"){
													var checkStatus =
														layui.table.cache[
														"associationParallel"
														];

													if (
														checkStatus == undefined
													){
														checkStatus = [];
													} else{
														for (
															let i = 0;
															i <
															checkStatus.length;
															i++
														)
														{
															let element =
																checkStatus[i];
															var aid = "";
															if (
																element.parallel_id ==
																undefined
															)
															{
																aid =
																	element.id;
															} else
															{
																aid =
																	element.parallel_id;
															}
															var okb = {
																parallel_id: aid
															};
															_this.arrt.push(
																okb
															);
														}
													}
													params = {
														id: _this.$route.query.editId,
														type: _this.jbxxform.type,
														name: data.field.name,
														start_time: _this.get_time( new Date( data.field.start_time ) ),
														end_time: _this.get_time( new Date( data.field.end_time ) ),
														province_id: data.field.province_id,
														city_id: data.field.city_id, area_id: data.field.area_id, list_display: data.field.list_display,
														ticket_desc: data.field.ticket_desc,
														is_offline: data.field.is_offline,
														offline_pay_finish:data.field.offline_pay_finish,
														scene_pay_type:data.field.scene_pay_type,
														pay_desc: data.field.pay_desc, logo_url: logo_url,
														order_no_prefix: data.field.order_no_prefix,
														form: _this.xsarr,
														salon_cover_url: salon_cover_url,
														company: data.field.company, theme: data.field.theme,
														belong_dep_id: data.field.belong_dep_id,
														belong_team_id: data.field.belong_team_id,
														is_dep: data.field.is_dep, is_show_price: data.field.is_show_price,
														pc_detail_banner_url: JSON.stringify( _this.fileLists ),
														modify_time: _this.modify_time / 1000,
														refund_endtime:_this.refund_endtime / 1000,
														modify_hour: data.field.modify_hour,
														refund_reminder:data.field.refund_reminder,
														jump_page: data.field.jump_page,
														informant: data.field.informant,
														informant_link: data.field.informant_link,
														previous_id:data.field.previous_id,
										             	previous_field:data.field.previous_field,
														contact_name: data.field.contact_name,
														contact_address: data.field.contact_address,
														cover_url: cover_url,
														vertical_cover_url: vertical_cover_url,
														code: data.field.code,
														detail: _this.detail,
														longitude: data.field.longitude,
														latitude: data.field.latitude,
														remittance_info: _this.remittance_info,
														specific_address: data.field.specific_address,
														desc: _this.msgok,
														organizers: data.field.organizers,guide_company: data.field.guide_company,
														sign_location: data.field.sign_location,
														maxmember: data.field.maxmember,
														tel: data.field.tel,
														parallel:
															data.field.parallel,
														// parallel_ids:data.field.name,
														enroll_start_time: _this.get_time( new Date( data.field.enroll_start_time ) ),
														enroll_end_time: _this.get_time( new Date( data.field.enroll_end_time ) ),
														ticket: _this.arrt,
														invoice_type: _this.invoice_type,
														hidden_enroll_notes: data.field.hidden_enroll_notes
													};
												} else if ($("input[name='parallel']:checked").val() == "1"){
													params = {
														id: _this.$route.query.editId,
														type: _this.jbxxform.type,
														name: data.field.name,
														start_time: _this.get_time( new Date( data.field.start_time ) ),
														end_time: _this.get_time( new Date( data.field.end_time ) ),
														province_id: data.field.province_id,
														city_id: data.field.city_id,
														area_id: data.field.area_id,
														order_no_prefix: data.field.order_no_prefix,
														informant: data.field.informant,
														informant_link: data.field.informant_link,
														previous_id:data.field.previous_id,
											            previous_field:data.field.previous_field,
														ticket_desc: data.field.ticket_desc,
														is_dep: data.field.is_dep,
														is_show_price: data.field.is_show_price,
														is_offline: data.field.is_offline,
														offline_pay_finish:data.field.offline_pay_finish,
														scene_pay_type:data.field.scene_pay_type,
														logo_url: logo_url,
														cover_url: cover_url,
														vertical_cover_url: vertical_cover_url,
														form: _this.xsarr,
														salon_cover_url: salon_cover_url,
														code: data.field.code,
														modify_time: _this.modify_time / 1000,
														refund_endtime:_this.refund_endtime / 1000,
														modify_hour: data.field.modify_hour,
														refund_reminder:data.field.refund_reminder,
														list_display: data.field.list_display,
														belong_dep_id: data.field.belong_dep_id,
														belong_team_id: data.field.belong_team_id,
														jump_page: data.field.jump_page,
														company: data.field.company,
														theme: data.field.theme,
														remittance_info: _this.remittance_info,
														longitude: data.field.longitude,
														latitude: data.field.latitude,
														pc_detail_banner_url: JSON.stringify( _this.fileLists ),
														contact_name: data.field.contact_name,
														contact_address: data.field.contact_address,
														detail: _this.detail,
														specific_address: data.field.specific_address,
														desc: _this.msgok,
														organizers: data.field.organizers,guide_company: data.field.guide_company,
														sign_location: data.field.sign_location,
														maxmember: data.field.maxmember,
														tel: data.field.tel,
														parallel: data.field.parallel,
														independence: data.field.independence,
														enroll_start_time: _this.get_time( new Date( data.field.enroll_start_time ) ),
														enroll_end_time: _this.get_time( new Date( data.field.enroll_end_time ) ),
														invoice_type: _this.invoice_type,
														hidden_enroll_notes: data.field.hidden_enroll_notes
													};
												}
												if ( params.logo_url == "" ){
													return layer.msg(
														"主办方logo不能为空",
														{
															time: 1000 //1秒关闭（如果不配置，默认是3秒）
														}
													);
												} else if (
													params.cover_url == ""
												){
													return layer.msg(
														"上传会议封面不能为空",
														{
															time: 1000 //1秒关闭（如果不配置，默认是3秒）
														}
													);
												} else if (
													params.vertical_cover_url ==
													""
												){
													return layer.msg(
														"上传会议封面不能为空",
														{
															time: 1000 //1秒关闭（如果不配置，默认是3秒）
														}
													);
												}

												let url = _this.APIurl.API.api.meetsave;
												_this
													.$post( url, params )
													.then( res => {
														if (
															parseInt(
																res.code
															) === 1
														)
														{
															_this.$message( {
																message:
																	"保存成功",
																type: "success",
																duration: 1000
															} );
															/* 清空关联会议表格 */
															_this.arrt = [];
															table.render( {
																elem:
																	"#associationParallel",
																data: [], //数据
																page: true, //开启分页
																cols: [
																	[
																		{
																			field:
																				"name",
																			title:
																				"会议名称"
																		},
																		{
																			title:
																				"是否收费",
																			templet: function (
																				d
																			) { return `是`; }
																		}
																	]
																],
																page: true
															} );
															element.tabChange(
																"myDemo",
																"222"
															); //切换tab头部的
														} else
														{
															_this.$message( {
																message:
																	res.msg,
																type: "warning",
																duration: 1000
															} );
														}
													} )
													.catch( error => {
														console.log( error );
													} );
												return false;
											} else {
												_this.$message( {
													message: "请选择部门",
													duration: 1000
												} );
											}
										} else {
											if ( $( "input[name='parallel']:checked" ).val() == "0" ){
												console.log( "here", data );
												var checkStatus = layui.table.cache["associationParallel"];

												if ( checkStatus == undefined ){
													checkStatus = [];
												} else {
													for (
														let i = 0;
														i < checkStatus.length;
														i++
													){
														let element =
															checkStatus[i];
														var aid = "";
														if (
															element.parallel_id ==
															undefined
														)
														{
															aid = element.id;
														} else
														{
															aid =
																element.parallel_id;
														}
														var okb = {
															parallel_id: aid
														};
														_this.arrt.push( okb );
													}
												}
												params = {
													id: _this.$route.query.editId,
													type: _this.jbxxform.type,
													name: data.field.name,
													start_time: _this.get_time( new Date( data.field.start_time ) ),
													end_time: _this.get_time( new Date( data.field.end_time ) ),
													province_id: data.field.province_id,
													city_id: data.field.city_id,
													area_id: data.field.area_id,
													ticket_desc: data.field.ticket_desc,
													logo_url: logo_url,
													form: _this.xsarr,
													salon_cover_url: salon_cover_url,
													order_no_prefix: data.field.order_no_prefix,
													informant: data.field.informant,
													informant_link: data.field.informant_link,
													previous_id:data.field.previous_id,
										         	previous_field:data.field.previous_field,
													company: data.field.company,
													theme: data.field.theme,
													is_offline: data.field.is_offline,
													offline_pay_finish:data.field.offline_pay_finish,
													scene_pay_type:data.field.scene_pay_type,
													pay_desc: data.field.pay_desc,
													belong_dep_id: data.field.belong_dep_id,
													belong_team_id: data.field.belong_team_id,
													is_invoice: data.field.is_invoice,
													invoice_type: _this.invoice_type,
													ticket_type: data.field.ticket_type,
													is_show_residue: data.field.is_show_residue,
													hidden_ticket_name: data.field.hidden_ticket_name,
													show_date_format: data.field.show_date_format,
													conf_ticket_num: data.field.conf_ticket_num,
													is_dep: data.field.is_dep,
													is_show_price: data.field.is_show_price,
													pc_detail_banner_url: JSON.stringify( _this.fileLists ),
													modify_time: _this.modify_time / 1000,
													refund_endtime:_this.refund_endtime / 1000,
													modify_hour: data.field.modify_hour,
													refund_reminder:data.field.refund_reminder,
													list_display: data.field.list_display,
													jump_page: data.field.jump_page,
													contact_name: data.field.contact_name,
													contact_address: data.field.contact_address,
													cover_url: cover_url,
													vertical_cover_url: vertical_cover_url,
													code: data.field.code,
													detail: _this.detail,
													longitude: data.field.longitude,
													latitude: data.field.latitude,
													remittance_info: _this.remittance_info,
													specific_address: data.field.specific_address,
													desc: _this.msgok,
													organizers: data.field.organizers,guide_company: data.field.guide_company,
													sign_location: data.field.sign_location,
													maxmember: data.field.maxmember,
													tel: data.field.tel,
													parallel: data.field.parallel,
													// parallel_ids:data.field.name,
													enroll_start_time: _this.get_time( new Date( data.field.enroll_start_time ) ),
													enroll_end_time: _this.get_time( new Date( data.field.enroll_end_time ) ),
													ticket: _this.arrt,
													hidden_enroll_notes: data.field.hidden_enroll_notes
												};
											} else if ( $( "input[name='parallel']:checked" ).val() == "1" ){
												params = {
													id: _this.$route.query.editId,
													type: _this.jbxxform.type,
													name: data.field.name,
													start_time: _this.get_time( new Date( data.field.start_time ) ),
													end_time: _this.get_time( new Date( data.field.end_time ) ),
													province_id: data.field.province_id,
													city_id: data.field.city_id,
													area_id: data.field.area_id,
													ticket_desc: data.field.ticket_desc,
													is_invoice: data.field.is_invoice,
													invoice_type: _this.invoice_type,
													ticket_type: data.field.ticket_type,
													is_show_residue: data.field.is_show_residue,
													hidden_ticket_name: data.field.hidden_ticket_name,
													show_date_format: data.field.show_date_format,
													conf_ticket_num: data.field.conf_ticket_num,
													is_dep: data.field.is_dep,
													is_show_price: data.field.is_show_price,
													logo_url: logo_url,
													form: _this.xsarr,
													order_no_prefix: data.field.order_no_prefix,
													pc_detail_banner_url: JSON.stringify( _this.fileLists ),
													salon_cover_url: salon_cover_url,
													cover_url: cover_url,
													vertical_cover_url: vertical_cover_url,
													code: data.field.code,
													modify_time: _this.modify_time / 1000,
													refund_endtime:_this.refund_endtime / 1000,
													modify_hour: data.field.modify_hour,
													refund_reminder:data.field.refund_reminder,
													is_offline: data.field.is_offline,
													offline_pay_finish:data.field.offline_pay_finish,
													scene_pay_type:data.field.scene_pay_type,
													pay_desc: data.field.pay_desc,
													informant: data.field.informant,
													informant_link: data.field.informant_link,
													previous_id:data.field.previous_id,
										        	previous_field:data.field.previous_field,
													belong_dep_id: data.field.belong_dep_id,
													belong_team_id: data.field.belong_team_id,
													jump_page: data.field.jump_page,
													company: data.field.company,
													theme: data.field.theme,
													list_display: data.field.list_display,
													remittance_info: _this.remittance_info,
													longitude: data.field.longitude,
													latitude: data.field.latitude,
													contact_name: data.field.contact_name,
													contact_address: data.field.contact_address,
													detail: _this.detail,
													specific_address: data.field.specific_address,
													desc: _this.msgok,
													organizers: data.field.organizers,guide_company: data.field.guide_company,
													sign_location: data.field.sign_location,
													maxmember: data.field.maxmember,
													tel: data.field.tel,
													parallel: data.field.parallel,
													independence: data.field.independence,
													enroll_start_time: _this.get_time( new Date( data.field.enroll_start_time ) ),
													enroll_end_time: _this.get_time( new Date( data.field.enroll_end_time ) ),
													invoice_type: _this.invoice_type,
													hidden_enroll_notes: data.field.hidden_enroll_notes
												};
											}
											if ( params.logo_url == "" ){
												return layer.msg(
													"主办方logo不能为空",{
														time: 1000 //1秒关闭（如果不配置，默认是3秒）
													}
												);
											} else if ( params.cover_url == "" ){
												return layer.msg(
													"上传会议封面不能为空",{
														time: 1000 //1秒关闭（如果不配置，默认是3秒）
													}
												);
											} else if (
												params.vertical_cover_url == ""
											){
												return layer.msg(
													"上传会议封面不能为空",{
														time: 1000 //1秒关闭（如果不配置，默认是3秒）
													}
												);
											}

											let url = _this.APIurl.API.api.meetsave;
											_this.$post( url, params ).then( res => {
													if (parseInt( res.code ) === 1){
														_this.$message( {
															message: "保存成功",
															type: "success",
															duration: 1000
														} );
														/* 清空关联会议表格 */
														_this.arrt = [];
														table.render( {
															elem:
																"#associationParallel",
															data: [], //数据
															page: true, //开启分页
															cols: [
																[
																	{
																		field:
																			"name",
																		title:
																			"会议名称"
																	},
																	{
																		title:
																			"是否收费",
																		templet: function (
																			d
																		) { return `是`; }
																	}
																]
															],
															page: true
														} );
														element.tabChange(
															"myDemo",
															"222"
														); //切换tab头部的
													} else{
														_this.$message( {
															message: res.msg,
															type: "warning",
															duration: 1000
														} );
													}
												} )
												.catch( error => {
													console.log( error );
												} );
											return false;
										}
									} );
								} )
								.catch( error => {
									console.log( error );
								} );
						}
						/*----------------------编辑会议信息结束------*/
						/*----------会议基本信息表单提交结束--------------*/

						element.render();
						upload.render();
						laydate.render();
						form.render();
					}
				);
			} );
		},
		/* 下一步 */
		two () {
			layui.use( ["element"], function () {
				var element = layui.element;
				element.tabChange( "myDemo", "222" ); //切换tab头部的
				element.render();
			} );
		},
		three () {
			layui.use( ["element"], function () {
				var element = layui.element;
				element.tabChange( "myDemo", "333" ); //切换tab头部的
				element.render();
			} );
		},
		four () {
			layui.use( ["element"], function () {
				var element = layui.element;
				element.tabChange( "myDemo", "444" ); //切换tab头部的
				element.render();
			} );
		},
		five () {
			layui.use( ["element"], function () {
				var element = layui.element;
				element.tabChange( "myDemo", "555" ); //切换tab头部的
				element.render();
			} );
		},
		/* 上传视频封面 */
		handleUploadConferenceCovers () {
			$( "#testlogoss" ).click();
		},
		/* 上传直播封面 */
		mh_handleUploadConferenceCovers () {
			$( "#mh_testlogoss" ).click();
		},
		uploadss ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "保存成功",
								type: "success",
								duration: 1000
							} );
							$( "#demosGuests" ).css( { display: "block" } );
							$( "#demosGuests" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
							_this.video_cover_url = $( "#demosGuests" ).attr(
								"src"
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		mh_uploadss ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "保存成功",
								type: "success",
								duration: 1000
							} );
							$( "#mh_demosGuests" ).css( { display: "block" } );
							$( "#mh_demosGuests" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
							_this.meet_video_cover_url = $(
								"#mh_demosGuests"
							).attr( "src" );
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		/* 上传附件 */
		handleTopFile ( res ) {
			var _this = this;
			layui.use( "layer", function () {
				if ( res.code == 1 )
				{
					_this.$message( {
						message: "上传成功",
						type: "success",
						duration: 1000
					} );
					_this.file_url = res.posts.id;
				} else
				{
					_this.$message( {
						message: res.msg,
						type: "warning",
						duration: 1000
					} );
				}
			} );
		},
		/* @click="fujian_file" */
		fujian_file () {
			var _this = this;
			_this.file_url = "";
			_this.clearFiles();
			$( "#fufu ul" ).html( "" );
		},
		handleExceed ( files, fileList ) {
			this.$message.warning(
				`当前限制选择 1 个文件，本次选择了 ${ files.length
				} 个文件，共选择了 ${ files.length + fileList.length } 个文件`
			);
		},
		/* 清除上传 */
		clearFiles () {
			this.$refs["my-upload"] && this.$refs["my-upload"].clearFiles();
		},
		/* 上传失败 */
		handleerr ( err ) {
			console.log( err );
		},
		/* 上传资料文件 */
		handleTopFiles ( res ) {
			var _this = this;
			layui.use( "layer", function () {
				if ( res.code == 1 )
				{
					_this.$message( {
						message: "上传成功",
						type: "success",
						duration: 1000
					} );
					var ids = res.posts.id;
					_this.file_ids.push( ids );
				} else
				{
					_this.$message( {
						message: res.msg,
						type: "warning",
						duration: 1000
					} );
				}
			} );
		},
		/* @click="file_top" */
		file_top () {
			var _this = this;
			_this.file_ids = [];
			_this.clearFiless();
			$( "#ziliao_file ul" ).html( "" );
		},
		/* 清除已上传 */
		clearFiless () {
			this.$refs["my-uploads"].clearFiles();
		},
		/* 移除资料文件 */
		remove_file ( res ) {
			var _this = this;
			if ( res.response.code == 1 )
			{
				var id = res.response.posts.id;
				var index = _this.file_ids.indexOf( id );
				if ( index > -1 )
				{
					_this.file_ids.splice( index, 1 );
				}
			}
		},
		/* 关闭栏目编辑框 */
		nos () {
			var _this = this;
			_this.dialogFormVisibleFive = false;
			_this.file_top();
			_this.ids = [];
			_this.fujian_file();
			_this.out_peoples = "";
			_this.video_id = "";
		},
		/* 监听栏目的右上角关闭 */
		handleDialogClose () {
			var _this = this;
			layui.use( "layer", function () {
				$( "#newcolumn" )[0].reset();
				_this.dialogFormVisibleFive = false;
				_this.file_top();
				_this.ids = [];
				_this.fujian_file();
				_this.out_peoples = "";
				_this.video_id = "";
			} );
		},
		/* 选择酒店 */
		popup () {
			var _this = this;
			let arrss = [];
			layui.use( ["table", "layer"], function () {
				var table = layui.table;
				let url = _this.APIurl.API.api.hotel_get;
				_this.$get( url ).then( res => {
					if ( res.code == "1" )
					{
						_this.room = res.posts;
					}
					layer.open( {
						type: 1,
						area: ["900px", "430px"],
						title: "房间选择",
						content:
							'<div><table id="templateTabless" lay-filter="templateTabless"></table></div>', //先定义一个数据表格的div框
						success: function ( index, layero ) {
							table.render( {
								elem: "#templateTabless",
								data: _this.room,

								request: {
									statusName: "status", //规定数据状态的字段名称，默认：code
									statusCode: 200, //规定成功的状态码，默认：0
									msgName: "hint", //规定状态信息的字段名称，默认：msg
									countName: "total", //规定数据总数的字段名称，默认：count
									dataName: "rows" //规定数据列表的字段名称，默认：data
								},

								cols: [
									[
										//设置数据表格表头
										{ checkbox: true }, //开启复选框
										{ field: "hotel_id", title: "id" },
										{
											field: "hotel_name",
											title: "酒店名称"
										},
										{
											field: "hotel_type",
											title: "酒店房型"
										},
										{ field: "price", title: "价格" },
										// { field: "quantity", title: "数量" },
										{
											field: "start_time",
											title: "入住开始时间",
											width: 140,
											templet: function ( d ) {
												return moment
													.unix( d.start_time )
													.format(
														"YYYY-MM-DD HH:mm:ss"
													);
											}
										},
										{
											field: "end_time",
											title: "入住结束时间",
											width: 140,
											templet: function ( d ) {
												return moment
													.unix( d.end_time )
													.format(
														"YYYY-MM-DD HH:mm:ss"
													);
											}
										},
										{ field: "explain", title: "说明" }
										// { field: "sold_num", title: "已售数量" }
									]
								],
								page: true
							} );
						},
						btn: ["确定", "关闭"],
						yes: function ( index, layero ) {
							var arrsss = layui.table.checkStatus(
								"templateTabless"
							).data;

							if ( arrsss == "" )
							{
								layer.msg( "请选择酒店", {
									time: 1000
								} );
							} else
							{
								for ( let k = 0; k < arrsss.length; k++ )
								{
									arrss.push( arrsss[k].id );
								}
								let url = _this.APIurl.API.api.add_hotel;
								let params;
								if ( _this.$route.query.editId )
								{
									params = {
										conference_id:
											_this.$route.query.editId,
										hotel: arrss
									};
								} else
								{
									params = {
										conference_id: sessionStorage.getItem(
											"theMeetingId"
										),
										hotel: arrss
									};
								}
								_this.$post( url, params ).then( res => {
									if ( res.code == "1" ){
										_this.$message( {
											message: "保存成功",
											type: "success",
											duration: 1000
										} );
										layer.close( index );
										let params;
										let url = _this.APIurl.API.api.meet_xq;
										if ( _this.$route.query.editId ){
											params = {
												id: _this.$route.query.editId
											};
										} else
										{
											params = {
												id: sessionStorage.getItem(
													"theMeetingId"
												)
											};
										}
										_this.$get( url, params ).then( res => {
											let hotel = res.posts.hotel;
											let tabaleArr = [];
											for (
												let i = 0;
												i < hotel.length;
												i++
											){
												var t = {};
												t = {
													id:
														hotel[i].hotel_info[
														"id"
														],
													hotel_id: hotel[i].id,
													h_name:
														hotel[i].hotel_info[
														"h_name"
														],
													hotel_type:
														hotel[i].hotel_info[
														"hotel_type"
														],
													price:
														hotel[i].hotel_info[
														"price"
														],
													quantity:
														hotel[i].hotel_info[
														"quantity"
														],
													start_time:
														hotel[i].hotel_info[
														"start_time"
														],
													end_time:
														hotel[i].hotel_info[
														"end_time"
														],
													explain:
														hotel[i].hotel_info[
														"explain"
														],
													sold_num:
														hotel[i].sold_quantity
												};
												tabaleArr.push( t );
											}

											table.render( {
												elem: "#dormmanager",
												data: tabaleArr,
												response: {
													statusName: "code", //规定数据状态的字段名称，默认：code
													statusCode: 1, //规定成功的状态码，默认：0
													msgName: "hint", //规定状态信息的字段名称，默认：msg
													countName: "total", //规定数据总数的字段名称，默认：count
													dataName: "posts" //规定数据列表的字段名称，默认：data
												},

												cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
												cols: [
													[
														{
															field: "id",
															title: "id"
														},
														{
															field: "h_name",
															title: "酒店名称"
														},
														{
															field: "hotel_type",
															title: "酒店房型"
														},
														{
															field: "price",
															title: "价格"
														},
														{
															field: "quantity",
															title: "数量"
														},
														{
															field: "start_time",
															title:
																"入住开始时间",
															width: 140,
															templet: function (
																d
															) {
																return moment
																	.unix(
																		d.start_time
																	)
																	.format(
																		"YYYY-MM-DD HH:mm:ss"
																	);
															}
														},
														{
															field: "end_time",
															title:
																"入住结束时间",
															width: 140,
															templet: function (
																d
															) {
																return moment
																	.unix(
																		d.end_time
																	)
																	.format(
																		"YYYY-MM-DD HH:mm:ss"
																	);
															}
														},
														{
															field: "explain",
															title: "说明"
														},
														{
															field: "sold_num",
															title: "已售数量"
														},
														{
															fixed: "right",
															title: "操作",
															toolbar:
																"#barDemos",
															width: 140,
															align: "center"
														}
													]
												],
												page: true
											} );
										} );
									}
								} );
							}
						}
					} );
				} );
			} );
		},
		/* 选择就餐 */
		popups () {
			var _this = this;
			let arrsss = [];
			layui.use( "table", function () {
				var table = layui.table;
				let url = _this.APIurl.API.api.eat_list;
				_this.$get( url ).then( res => {
					if ( res.code == "1" )
					{
						_this.repast = res.posts;
					}
					layer.open( {
						type: 1,
						area: ["900px", "430px"],
						title: "就餐选择",
						// maxmin: false,
						content:
							'<div><table id="templateTablesss" lay-filter="templateTablesss"></table></div>', //先定义一个数据表格的div框
						success: function ( index, layero ) {
							table.render( {
								elem: "#templateTablesss",
								data: _this.repast,

								request: {
									statusName: "status", //规定数据状态的字段名称，默认：code
									statusCode: 200, //规定成功的状态码，默认：0
									msgName: "hint", //规定状态信息的字段名称，默认：msg
									countName: "total", //规定数据总数的字段名称，默认：count
									dataName: "rows" //规定数据列表的字段名称，默认：data
								},

								cols: [
									[
										//设置数据表格表头
										{ checkbox: true }, //开启复选框
										{ field: "id", title: "id" },
										{ field: "address", title: "就餐地点" },
										{
											field: "is_muslim",
											title: "是否清真",
											templet: function ( d ) {
												if ( d.is_muslim == 1 ){
													return "是";
												} else if ( d.is_muslim == 0 ){
													return "否";
												}
											}
										},
										{ field: "price", title: "价格" },
										// { field: "number", title: "预定数" },
										{
											field: "start_time",
											title: "开始时间",
											width: 140,
											templet: function ( d ) {
												return moment
													.unix( d.start_time )
													.format(
														"YYYY-MM-DD HH:mm:ss"
													);
											}
										},
										{
											field: "end_time",
											title: "结束时间",
											width: 140,
											templet: function ( d ) {
												return moment
													.unix( d.end_time )
													.format(
														"YYYY-MM-DD HH:mm:ss"
													);
											}
										}
									]
								],
								page: true
							} );
						},
						btn: ["确定", "关闭"],
						yes: function ( index, layero ) {
							var arrssss = layui.table.checkStatus(
								"templateTablesss"
							).data;
							if ( arrssss == "" )
							{
								layer.msg( "请选择就餐", {
									time: 1000
								} );
							} else
							{
								for ( let k = 0; k < arrssss.length; k++ )
								{
									arrsss.push( arrssss[k].id );
								}
								let url = _this.APIurl.API.api.add_eat;
								let params;
								if ( _this.$route.query.editId )
								{
									params = {
										conference_id:
											_this.$route.query.editId,
										repast: arrsss
									};
								} else
								{
									params = {
										conference_id: sessionStorage.getItem(
											"theMeetingId"
										),
										repast: arrsss
									};
								}
								_this.$post( url, params ).then( res => {
									if ( res.code == "1" ){
										_this.$message( {
											message: "保存成功",
											type: "success",
											duration: 1000
										} );
										layer.close( index );
										let params;
										let url = _this.APIurl.API.api.meet_xq;
										if ( _this.$route.query.editId ){
											params = {
												id: _this.$route.query.editId
											};
										} else
										{
											params = {
												id: sessionStorage.getItem(
													"theMeetingId"
												)
											};
										}
										_this.$get( url, params ).then( res => {
											let repast = res.posts.repast;
											let tabaleArrs = [];
											for (
												let i = 0;
												i < repast.length;
												i++
											){
												var tt = {};
												tt = {
													id:
														repast[i].repast_info[
														"id"
														],
													hotel_id: repast[i].id,
													number:
														repast[i].repast_info[
														"number"
														],
													address:
														repast[i].repast_info[
														"address"
														],
													is_muslim:
														repast[i].repast_info[
														"is_muslim"
														],
													price:
														repast[i].repast_info[
														"price"
														],
													explain:
														repast[i].repast_info[
														"explain"
														],
													start_time:
														repast[i].repast_info[
														"start_time"
														],
													end_time:
														repast[i].repast_info[
														"end_time"
														],
													list_order:
														repast[i].repast_info[
														"list_order"
														],
													status:
														repast[i].repast_info[
														"status"
														],
												};
												tabaleArrs.push( tt );
											}
											table.render( {
												elem: "#diningManagement",
												data: tabaleArrs,
												response: {
													statusName: "code", //规定数据状态的字段名称，默认：code
													statusCode: 1, //规定成功的状态码，默认：0
													msgName: "hint", //规定状态信息的字段名称，默认：msg
													countName: "total", //规定数据总数的字段名称，默认：count
													dataName: "posts" //规定数据列表的字段名称，默认：data
												},

												cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
												cols: [
													[
														{
															field: "id",
															title: "id"
														},
														{
															field: "address",
															title: "就餐地点"
														},
														{
															field: "is_muslim",
															title: "是否清真",
															templet: function (
																d
															) {
																if (
																	d.is_muslim ==
																	1
																)
																{
																	return "是";
																} else if (
																	d.is_muslim ==
																	0
																)
																{
																	return "否";
																}
															}
														},
														{
															field: "price",
															title: "价格"
														},
														{
															field: "number",
															title: "预定数"
														},
														{
															field: "start_time",
															title: "开始时间",
															width: 140,
															templet: function (
																d
															) {
																return moment
																	.unix(
																		d.start_time
																	)
																	.format(
																		"YYYY-MM-DD HH:mm:ss"
																	);
															}
														},
														{
															field: "end_time",
															title: "结束时间",
															width: 140,
															templet: function (
																d
															) {
																return moment
																	.unix(
																		d.end_time
																	)
																	.format(
																		"YYYY-MM-DD HH:mm:ss"
																	);
															}
														},
														{
															fixed: "right",
															title: "操作",
															toolbar:
																"#barDemos",
															width: 140,
															align: "center"
														}
													]
												],
												page: true
											} );
										} );
									}
								} );
							}
						}
					} );
				} );
			} );
		},
		/* 选择嘉宾 */
		change_people () {
			var _this = this;
			//记录选中的数据:做缓存使用,作为参数传递给后台,然后生成pdf ,压缩
			//当前表格中的全部数据:在表格的checkbox全选的时候没有得到数据, 因此用全局存放变量
			var table_data = new Array();
			layui.use( "table", function () {
				var table = layui.table;
				let url = _this.APIurl.API.api.guest_list;
				_this.$get( url ).then( res => {
					if ( res.code == 1 )
					{
						layer.open( {
							type: 1,
							area: ["900px", "430px"],
							title: "嘉宾选择",
							// maxmin: false,
							content:
								'<div><table id="jiabingc" lay-filter="jiabingc"></table></div>', //先定义一个数据表格的div框
							success: function ( index, layero ) {
								table.render( {
									elem: "#jiabingc",
									data: res.posts.data,

									request: {
										statusName: "status", //规定数据状态的字段名称，默认：code
										statusCode: 200, //规定成功的状态码，默认：0
										msgName: "hint", //规定状态信息的字段名称，默认：msg
										countName: "total", //规定数据总数的字段名称，默认：count
										dataName: "rows" //规定数据列表的字段名称，默认：data
									},

									cols: [
										[
											//设置数据表格表头
											{ checkbox: true }, //开启复选框
											// { field: "id", title: "id" },
											{
												field: "head_img",
												title: "嘉宾头像",
												templet:
													'<div><img src="{{d.head_img}}"></div>'
											},
											{ field: "name", title: "姓名" },
											{ field: "tel", title: "电话" },
											{
												field: "ssapid",
												title: "ssapid"
											},
											{
												field: "description",
												title: "简介",
												width: 140
											},
											{
												field: "company",
												title: "研究领域",
												width: 140
											}
										]
									],
									page: true,
									done: function ( res, curr, count ) {
										//设置全部数据到全局变量
										table_data = res.data;
										console.log( table_data, _this.ids );
										for (
											var i = 0;
											i < res.data.length;
											i++
										){
											for (
												var j = 0;
												j < _this.ids.length;
												j++
											){
												//数据id和要勾选的id相同时checkbox选中
												if (
													res.data[i].id ==
													_this.ids[j]
												){
													//这里才是真正的有效勾选
													res.data[i]["LAY_CHECKED"] =
														"true";
													//找到对应数据改变勾选样式，呈现出选中效果
													var index =
														res.data[i][
														"LAY_TABLE_INDEX"
														];
													$(
														".layui-table-fixed-l tr[data-index=" +
														index +
														'] input[type="checkbox"]'
													).prop( "checked", true );
													$(
														".layui-table-fixed-l tr[data-index=" +
														index +
														'] input[type="checkbox"]'
													)
														.next()
														.addClass(
															"layui-form-checked"
														);
												}
											}
										}
										//设置全选checkbox的选中状态，只有改变LAY_CHECKED的值， table.checkStatus才能抓取到选中的状态
										var checkStatus = table.checkStatus(
											"my-table"
										);
										if ( checkStatus.isAll ){
											$(
												' .layui-table-header th[data-field="0"] input[type="checkbox"]'
											).prop( "checked", true );
											$(
												'.layui-table-header th[data-field="0"] input[type="checkbox"]'
											)
												.next()
												.addClass( "layui-form-checked" );
										}
									}
								} );
							},

							btn: ["确定", "关闭"],
							yes: function ( index, layero ) {
								// let checkStatus = layui.table.checkStatus("jiabingc").data;
								console.log( _this.ids );
								_this.$message( {
									message: "保存成功",
									type: "success",
									duration: 1000
								} );
								layer.close( index );
								table.render( {
									elem: "#test_jiabin",
									data: _this.ids, //数据
									page: true, //开启分页
									cols: [
										[
											//表头
											// { field: "id", title: "id", width: 80, sort: true },
											{
												field: "head_img",
												title: "嘉宾头像",
												width: 80,
												templet:
													'<div><img src="{{d.head_img}}"></div>'
											},
											{
												field: "name",
												title: "姓名",
												width: 80,
												sort: true
											},
											{
												field: "tel",
												title: "电话",
												width: 80
											},
											{
												field: "ssapid",
												title: "ssapid",
												width: 177
											},
											{
												field: "description",
												title: "简介",
												width: 80,
												sort: true
											},
											{
												field: "company",
												title: "研究领域",
												width: 80,
												sort: true
											},
											{
												fixed: "right",
												title: "操作",
												toolbar: "#bar_jiabin"
											}
										]
									],
									page: true
								} );
							}
						} );
						/* 监听复选框 */
						table.on( "checkbox(jiabingc)", function ( obj ) {
							if ( obj.checked == true )
							{
								if ( obj.type == "one" )
								{
									_this.ids.push( obj.data );
								} else
								{
									for (
										var i = 0;
										i < table_data.length;
										i++
									){
										_this.ids.push( table_data[i] );
									}
								}
							} else
							{
								if ( obj.type == "one" )
								{
									for ( var i = 0; i < _this.ids.length; i++ ){
										if ( _this.ids[i].id == obj.data.id ){
											_this.ids.splice(
												_this.ids.indexOf( _this.ids[i] ),
												1
											);
										}
									}
								} else
								{
									for ( var i = 0; i < _this.ids.length; i++ ){
										for (
											var j = 0;
											j < table_data.length;
											j++
										){
											if (
												_this.ids[i].id ==
												table_data[j].id
											){
												_this.ids.splice(
													_this.ids.indexOf(
														_this.ids[i]
													),
													1
												);
											}
										}
									}
								}
							}
						} );
					}
				} );
			} );
		},
		/* 选择平行会议 */
		meet_have () {
			var _this = this;
			//记录选中的数据:做缓存使用,作为参数传递给后台,然后生成pdf ,压缩
			var ids = new Array();
			//当前表格中的全部数据:在表格的checkbox全选的时候没有得到数据, 因此用全局存放变量
			var table_data = new Array();
			layui.use( "table", function () {
				var table = layui.table;
				let url = _this.APIurl.API.api.pin_meetlist;
				_this.$get( url ).then( res => {
					if ( res.code == 1 )
					{
						layer.open( {
							type: 1,
							area: ["900px", "430px"],
							title: "平行会议选择",
							content:
								'<div><table id="meet_p" lay-filter="meet_p"></table></div>', //先定义一个数据表格的div框
							success: function ( index, layero ) {
								table.render( {
									elem: "#meet_p",
									data: res.posts,

									request: {
										statusName: "status", //规定数据状态的字段名称，默认：code
										statusCode: 200, //规定成功的状态码，默认：0
										msgName: "hint", //规定状态信息的字段名称，默认：msg
										countName: "total", //规定数据总数的字段名称，默认：count
										dataName: "rows" //规定数据列表的字段名称，默认：data
									},

									cols: [
										[
											{ type: "checkbox" },
											// { field: "id", width: 140, title: "排序" },
											{
												field: "name",
												title: "会议名称"
											},
											{
												title: "是否收费",
												templet: function ( d ) {
													return `
                           是
                        `;
												}
											}
										]
									],
									page: true,
									done: function ( res, curr, count ) {
										//设置全部数据到全局变量
										table_data = res.data;
										for (
											var i = 0;
											i < res.data.length;
											i++
										){
											for (
												var j = 0;
												j < ids.length;
												j++
											){
												//数据id和要勾选的id相同时checkbox选中
												if ( res.data[i].id == ids[j] ){
													//这里才是真正的有效勾选
													res.data[i]["LAY_CHECKED"] =
														"true";
													//找到对应数据改变勾选样式，呈现出选中效果
													var index =
														res.data[i][
														"LAY_TABLE_INDEX"
														];
													$(
														".layui-table-fixed-l tr[data-index=" +
														index +
														'] input[type="checkbox"]'
													).prop( "checked", true );
													$(
														".layui-table-fixed-l tr[data-index=" +
														index +
														'] input[type="checkbox"]'
													)
														.next()
														.addClass(
															"layui-form-checked"
														);
												}
											}
										}
										//设置全选checkbox的选中状态，只有改变LAY_CHECKED的值， table.checkStatus才能抓取到选中的状态
										var checkStatus = table.checkStatus(
											"my-table"
										);
										if ( checkStatus.isAll ){
											$(
												' .layui-table-header th[data-field="0"] input[type="checkbox"]'
											).prop( "checked", true );
											$(
												'.layui-table-header th[data-field="0"] input[type="checkbox"]'
											)
												.next()
												.addClass( "layui-form-checked" );
										}
									}
								} );
							},
							btn: ["确定", "关闭"],
							yes: function ( index, layero ) {
								table.render( {
									elem: "#associationParallel",
									data: ids, //数据
									page: true, //开启分页
									cols: [
										[
											// { field: "id", width: 140, title: "排序" },
											{
												field: "name",
												title: "会议名称"
											},
											{
												title: "是否收费",
												templet: function ( d ) {
													return `
                           是
                        `;
												}
											}
										]
									],
									page: true
								} );
								layer.close( index );
							}
						} );
						/* 监听复选框 */
						table.on( "checkbox(meet_p)", function ( obj ) {
							if ( obj.checked == true )
							{
								if ( obj.type == "one" )
								{
									ids.push( obj.data );
								} else
								{
									for (
										var i = 0;
										i < table_data.length;
										i++
									){
										ids.push( table_data[i] );
									}
								}
							} else
							{
								if ( obj.type == "one" )
								{
									for ( var i = 0; i < ids.length; i++ ){
										if ( ids[i].id == obj.data.id ){
											ids.splice( ids.indexOf( ids[i] ), 1 );
										}
									}
								} else
								{
									for ( var i = 0; i < ids.length; i++ ){
										for (
											var j = 0;
											j < table_data.length;
											j++
										){
											if ( ids[i].id == table_data[j].id ){
												ids.splice(
													ids.indexOf( ids[i] ),
													1
												);
											}
										}
									}
								}
							}
						} );
					}
				} );
			} );
		},
		/* 时间去掉毫秒 */
		get_time ( times ) {
			var mill = times.getTime();
			return mill / 1000;
		},
		// 举办地点
		handleHeld () {
			var _this = this;
			let url = _this.APIurl.API.api.city;
			_this
				.$get( url )
				.then( res => {
					if ( parseInt( res.code ) === 1 )
					{
						_this.proList = res;
					} else
					{
						_this.$message( {
							message: res.msg,
							type: "warning",
							duration: 1000
						} );
					}
				} )
				.catch( error => {
					console.log( error );
				} );
		},
		/*上传图片*/
		handleTestlogo () {
			$( "#testlogo" ).click();
		},
		upload ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#demo1" ).css( { display: "block" } );
							_this.logo_url = res.posts[0].image;
							$( "#demo1" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		handleUploadConferenceCover () {
			$( "#testlogos" ).click();
		},
		handleUploadConferenceCoversss () {
			$( "#testlogossss" ).click();
		},
		/* 上传沙龙会议图 */
		handleUploadConferenceCover_img () {
			$( "#salon_cover_url" ).click();
		},
		uploads_img ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#demos_img" ).css( { display: "block" } );
							_this.salon_cover_url = res.posts[0].image;
							$( "#demos_img" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		uploads ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#demos" ).css( { display: "block" } );
							_this.cover_url = res.posts[0].image;
							$( "#demos" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		uploadssss ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#demoss" ).css( { display: "block" } );
							_this.vertical_cover_url = res.posts[0].image;
							$( "#demoss" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		//上传分享页图标
		handleColumnIcon () {
			$( "#columnIcon_file" ).click();
		},
		handleIcon ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = {
					base64: e.target.result,
					area: 0
				};
				let url = _this.APIurl.API.api.cover_img;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							_this.getIconlist();
							$( "#columnIcon_img" ).css( { display: "block" } );
							_this.icon_id = res.posts.id;
							$( "#columnIcon_img" ).attr(
								"src",
								res.posts.domain + "/" + res.posts.image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		/* 上传栏目图标 */
		handleColumnIcons () {
			$( "#columnIcon_files" ).click();
		},
		handleIcons ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result, area: 1 };
				let url = _this.APIurl.API.api.cover_img;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							_this.getIconlist();
							$( "#columnIcon_imgs" ).css( { display: "block" } );
							_this.lanicon_id = res.posts.id;
							$( "#columnIcon_imgs" ).attr(
								"src",
								res.posts.domain + "/" + res.posts.image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		handleWeChat () {
			$( "#weChats" ).click();
		},
		handleshare () {
			$( "#shareImg" ).click();
		},
		//分享图
		handleShare ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#shareFiles_img" ).css( { display: "block" } );
							$( "#shareFiles_img" ).attr(
								"src",
								"/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		//微信首页背景图
		handleWeChats ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#weChatFiles_img" ).css( { display: "block" } );
							_this.background = res.posts[0].image;
							$( "#weChatFiles_img" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						if ( error == undefined )
						{
							layer.msg( "仅支持上传图片" );
						} else
						{
							_this.$message( {
								message: error,
								type: "error",
								duration: 1000
							} );
						}
					} );
			};
		},
		//微信分享图标
		handleWeChatShareIcon () {
			$( "#weChatShareIcons" ).click();
		},
		handleWeChatShareIcons ( e ) {
			let _this = this;
			let file = e.target.files[0];
			var reader = new FileReader();
			reader.readAsDataURL( file );
			reader.onload = function ( e ) {
				// 读取到的图片base64 数据编码 将此编码字符串传给后台即可
				let params = { base64: e.target.result };
				let url = _this.APIurl.API.api.up_baimg;
				_this
					.$postform( url, params )
					.then( res => {
						if ( parseInt( res.code ) === 1 )
						{
							_this.$message( {
								message: "上传成功",
								type: "success",
								duration: 1000
							} );
							$( "#weChatShareIcon" ).css( { display: "block" } );
							_this.share_img = res.posts[0].image;
							$( "#weChatShareIcon" ).attr(
								"src",
								res.posts[0].domain + "/" + res.posts[0].image
							);
						} else
						{
							_this.$message( {
								message: res.msg,
								type: "warning",
								duration: 1000
							} );
						}
					} )
					.catch( error => {
						console.log( error );
					} );
			};
		},
		//会议详请
		handleMeetingDetailsPlease () {
			var _this = this;
			let url = _this.APIurl.API.api.meet_xq;
			let params = {
				id: _this.$route.query.editId
			};
			_this
				.$get( url, params )
				.then( res => {
					if ( parseInt( res.code ) === 1 )
					{
						_this.totalData = res.posts;
					} else
					{
						_this.$message( {
							message: res.msg,
							type: "warning",
							duration: 1000
						} );
					}
				} )
				.catch( error => {
					console.log( error );
				} );
		},
		/* 地图 */
		mapNameChange () {
			let that = this,
				point,
				marker = null;
			let local = new BMap.LocalSearch( map, {
				renderOptions: { map: map },
				onSearchComplete: res => {
					if ( local.getResults() != undefined )
					{
						map.clearOverlays(); //清除地图上所有覆盖物
						if ( local.getResults().getPoi( 0 ) )
						{
							point = local.getResults().getPoi( 0 ).point; //获取第一个智能搜索的结果
							map.centerAndZoom( point, 10 );
							marker = new BMap.Marker( point ); // 创建标注
							map.addOverlay( marker ); // 将标注添加到地图中
							marker.enableDragging(); // 可拖拽
							geoc.getLocation( point, function ( rs ) {
								var addComp = rs.addressComponents;

								that.mapPointName =
									addComp.province +
									", " +
									addComp.city +
									", " +
									addComp.district +
									", " +
									addComp.street +
									", " +
									addComp.streetNumber;
								var a = rs.point;
								that.longitude = a.lng;
								that.latitude = a.lat;
							} );
						} else
						{
							alert(
								"未匹配到地点!可拖动地图上的红色图标到精确位置"
							);
						}
					} else
					{
						alert( "未找到搜索结果" );
					}
				}
			} );
			local.search( this.mapName );
		},
		mapBuild () {
			let that = this;
			this.dialogMap = !this.dialogMap;
			setTimeout( function () {
				if ( that.mapGetshow )
				{
					map = new BMap.Map( "container" );
					geoc = new BMap.Geocoder();
					let point = new BMap.Point( 116.3964, 39.9093 );
					map.centerAndZoom( point, 10 );
					map.enableScrollWheelZoom();
					var geolocation = new BMap.Geolocation();
					//定位
					geolocation.getCurrentPosition(
						r => {
							var mk = new BMap.Marker( r.point );
							map.addOverlay( mk );
							map.panTo( r.point );
							geoc.getLocation( r.point, function ( rs ) {
								var addComp = rs.addressComponents;

								that.mapPointName =
									addComp.province +
									addComp.city +
									addComp.district +
									addComp.street +
									addComp.streetNumber;
								that.loading = false;
								that.mapGetshow = false;
							} );
						},
						{ enableHighAccuracy: true }
					);
					//鼠标点击
					map.addEventListener( "click", function ( e ) {
						var pt = e.point;
						var marker = new BMap.Marker( pt ); // 创建标注
						map.clearOverlays();
						map.addOverlay( marker );
						geoc.getLocation( pt, function ( rs ) {
							var addComp = rs.addressComponents;
							var a = rs.point;
							that.longitude = a.lng;
							that.latitude = a.lat;

							that.mapName =
								addComp.province +
								addComp.city +
								addComp.district +
								addComp.street +
								addComp.streetNumber;
						} );
					} );
				}
			}, 1000 );
		},
		//地图显示
		/**
		 * name layui合并tbody中单元格的方法
		 * @param tableId  表格的id属性
		 * @param fieldName 要合并的列field值
		 * @desc 此方式适用于没有列冻结的单元格合并
		 */
		tableRowSpanNoFixedCol ( tableId, fieldName ) {
			if ( !tableId && !fieldName )
			{
				return false;
			}
			// 获取页面中全部的表格元素
			var allTableNode = document.getElementsByClassName(
				"layui-table-view"
			);

			// 获取lay-id属性为tableId的表格元素的
			var targetTableNode = null;
			if ( allTableNode.length > 0 )
			{
				for (
					var index = 0, length = allTableNode.length;
					index < length;
					index++
				)
				{
					// 通过lay-id属性过滤表格元素
					var tableLayId = allTableNode[index].getAttribute( "lay-id" );
					if ( tableLayId === tableId )
					{
						targetTableNode = allTableNode[index];
						break;
					}
				}
			}
			if ( !targetTableNode )
			{
				console.log(
					"没有找到ID为：" + tableId + "的表格, 请升级您的layui版本"
				);
				return false;
			}

			// 开始合并单元格操作
			var tBodyNode = targetTableNode.getElementsByClassName(
				"layui-table-body"
			)[0];

			var tdNodes = tBodyNode.getElementsByTagName( "td" );
			var childFilterArr = [];
			// 获取data-field属性为fieldName的td
			for ( var i = 0; i < tdNodes.length; i++ )
			{
				if ( tdNodes[i].getAttribute( "data-field" ) === fieldName )
				{
					childFilterArr.push( tdNodes[i] );
				}
			}

			// 获取td的个数和种类
			var childFilterTextObj = {};
			var childFilterArrLength = childFilterArr.length;
			for ( var j = 0; j < childFilterArrLength; j++ )
			{
				var childText = childFilterArr[j].textContent;
				if ( childFilterTextObj[childText] === undefined )
				{
					childFilterTextObj[childText] = 1;
				} else
				{
					var num = childFilterTextObj[childText];
					childFilterTextObj[childText] = num * 1 + 1;
				}
			}
			// 给获取到的td设置合并单元格属性
			for ( var key in childFilterTextObj )
			{
				var tdNum = childFilterTextObj[key];
				var canRowSpan = true;
				var needChangeBackGroundNodes = [];
				var addEventNode = null;
				for ( var h = 0; h < childFilterArrLength; h++ )
				{
					if ( childFilterArr[h].textContent === key )
					{
						needChangeBackGroundNodes.push( childFilterArr[h] );
						if ( canRowSpan )
						{
							childFilterArr[h].setAttribute( "rowspan", tdNum );
							addEventNode = childFilterArr[h];
							canRowSpan = false;
						} else
						{
							childFilterArr[h].style.display = "none";
						}
					}
				}

				// 以下为单元格鼠标悬浮样式修改(使用闭包)
				( function ( addEventNode, needChangeBackGroundNodes ) {
					addEventNode.onmouseover = function () {
						for (
							var index = 0,
							length = needChangeBackGroundNodes.length;
							index < length;
							index++
						)
						{
							needChangeBackGroundNodes[
								index
							].parentNode.style.background = "#f2f2f2"; // 我这里的单元格鼠标滑过背景色为layui默认，你可以更改为你想要的颜色。
						}
					};
					addEventNode.onmouseout = function () {
						for (
							var index = 0,
							length = needChangeBackGroundNodes.length;
							index < length;
							index++
						)
						{
							needChangeBackGroundNodes[
								index
							].parentNode.style.background = "";
						}
					};
				} )( addEventNode, needChangeBackGroundNodes );
			}
		}
	},

	mounted () {
		// layui手动渲染
		this.handlePublics();
		this.handlePublicss();
		this.mapBuild();
		this.getIconlist();
		this.iconchange();
		this.iconchanges();
		if ( this.$route.query.editId )
		{
			this.handleMeetingDetailsPlease();
		}
	},
	updated () {
		this.handlePublics();
	}
};
</script>

<style scoped>
.edui-button.edui-for-135editor .edui-button-wrap .edui-button-body .edui-icon {
	background-image: url("http://static.135editor.com/img/icons/editor-135-icon.png") !important;
	background-size: 85%;
	background-position: center;
	background-repeat: no-repeat;
}

.layui-util-face ul li {
	min-height: 30px !important;
}

.tree {
	padding: 20px 10px;
	background-color: white;
	margin-bottom: 20px;
}

.a-new-meeting .theDormManager .layui-form-label {
	width: 110px;
}

.a-new-meeting .meeting-the-basic {
	font-weight: bold;
	margin-left: 10px;
	border-bottom: 1px solid #ccc;
	padding-bottom: 10px;
}

.a-new-meeting .info .layui-form-label {
	width: 110px;
}

.a-new-meeting .layui-form-label {
	padding: 9px 0;
}

.a-new-meeting .layui-input-block {
	margin-left: 120px;
}

.a-new-meeting #payment .payment {
	width: 155px;
	margin-right: 10px;
}

.a-new-meeting #hotel .hotel {
	width: 90%;
}

.a-new-meeting .required {
	color: red;
	font-size: 150%;
}

#dining .layui-form-label {
	width: 110px !important;
}

@media screen and (min-width: 320px) and (max-width: 750px) {
	.a-new-meeting .button {
		margin-top: 10px;
	}

	.a-new-meeting .left {
		margin-left: 30px;
	}

	.a-new-meeting .mar-left {
		margin-left: 110px;
	}

	.a-new-meeting .edit {
		margin-left: 10px;
		margin-bottom: 10px;
	}

	.invoice {
		margin-top: 0px;
		margin-left: 10px;
	}

	.a {
		width: 60px;
	}
}
</style>

<style>
div /deep/.el-form-item__content {
	line-height: 22px;
}
</style>
